import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions =  {}
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ConnectionCursor: any;
  DateTime: any;
  JSON: any;
  Upload: any;
};


export type Account = {
  __typename: 'Account';
  createdAt: Scalars['DateTime'];
  customer?: Maybe<Customer>;
  email: Scalars['String'];
  enabled: Scalars['Boolean'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
  permissions?: Maybe<Array<Permission>>;
  profile?: Maybe<Profile>;
  roles: Array<Scalars['String']>;
  status: Scalars['String'];
};

export type AccountAggregateGroupBy = {
  __typename: 'AccountAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type AccountCard = {
  __typename: 'AccountCard';
  cardType: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  default: Scalars['Boolean'];
  expiryDate: Scalars['DateTime'];
  expiryMonth: Scalars['String'];
  expiryYear: Scalars['String'];
  gateway: Scalars['String'];
  id: Scalars['ID'];
  lastFourDigits: Scalars['String'];
  token: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AccountCode = {
  __typename: 'AccountCode';
  code: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['Float'];
};

export type AccountConnection = {
  __typename: 'AccountConnection';
  /** Array of edges. */
  edges: Array<AccountEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AccountCountAggregate = {
  __typename: 'AccountCountAggregate';
  createdAt?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
};

export type AccountDeleteFilter = {
  and?: Maybe<Array<AccountDeleteFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  email?: Maybe<StringFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  firstName?: Maybe<StringFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  lastName?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<AccountDeleteFilter>>;
  status?: Maybe<StringFieldComparison>;
};

export type AccountDeleteResponse = {
  __typename: 'AccountDeleteResponse';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<Permission>>;
  roles?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
};

export type AccountEdge = {
  __typename: 'AccountEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Account */
  node: Account;
};

export enum AccountEventType {
  CreateCart = 'CreateCart',
  OrderConfirmation = 'OrderConfirmation',
  ProductVariantSubscription = 'ProductVariantSubscription',
  Registration = 'Registration',
  Trigger = 'Trigger',
  WishListCreated = 'WishListCreated'
}

export type AccountEventTypeFilterComparison = {
  eq?: Maybe<AccountEventType>;
  gt?: Maybe<AccountEventType>;
  gte?: Maybe<AccountEventType>;
  iLike?: Maybe<AccountEventType>;
  in?: Maybe<Array<AccountEventType>>;
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
  like?: Maybe<AccountEventType>;
  lt?: Maybe<AccountEventType>;
  lte?: Maybe<AccountEventType>;
  neq?: Maybe<AccountEventType>;
  notILike?: Maybe<AccountEventType>;
  notIn?: Maybe<Array<AccountEventType>>;
  notLike?: Maybe<AccountEventType>;
};

export type AccountFilter = {
  and?: Maybe<Array<AccountFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  email?: Maybe<StringFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  firstName?: Maybe<StringFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  lastName?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<AccountFilter>>;
  status?: Maybe<StringFieldComparison>;
};

export type AccountGroup = {
  __typename: 'AccountGroup';
  createdAt: Scalars['DateTime'];
  definition: Scalars['JSON'];
  description?: Maybe<Scalars['String']>;
  exclusions: Array<Account>;
  id: Scalars['ID'];
  inclusions: Array<Account>;
  isDynamic?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  refreshRate?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};


export type AccountGroupExclusionsArgs = {
  filter?: AccountFilter;
  sorting?: Array<AccountSort>;
};


export type AccountGroupInclusionsArgs = {
  filter?: AccountFilter;
  sorting?: Array<AccountSort>;
};

export type AccountGroupAccountConnection = {
  __typename: 'AccountGroupAccountConnection';
  count: Scalars['Float'];
  edges: Array<AccountGroupAccountEdge>;
  pageInfo: RelayPageInfo;
};

export type AccountGroupAccountEdge = {
  __typename: 'AccountGroupAccountEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: AccountGroupUserDto;
};

export type AccountGroupAggregateGroupBy = {
  __typename: 'AccountGroupAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AccountGroupConfigDto = {
  __typename: 'AccountGroupConfigDto';
  fields: Scalars['JSON'];
};

export type AccountGroupConnection = {
  __typename: 'AccountGroupConnection';
  /** Array of edges. */
  edges: Array<AccountGroupEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AccountGroupCountAggregate = {
  __typename: 'AccountGroupCountAggregate';
  createdAt?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type AccountGroupDto = {
  createdAt: Scalars['DateTime'];
  definition: Scalars['JSON'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDynamic?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  refreshRate?: Maybe<Scalars['Float']>;
  updatedAt: Scalars['DateTime'];
};

export type AccountGroupDeleteFilter = {
  and?: Maybe<Array<AccountGroupDeleteFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<AccountGroupDeleteFilter>>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type AccountGroupDeleteResponse = {
  __typename: 'AccountGroupDeleteResponse';
  createdAt?: Maybe<Scalars['DateTime']>;
  definition?: Maybe<Scalars['JSON']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isDynamic?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  refreshRate?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AccountGroupEdge = {
  __typename: 'AccountGroupEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the AccountGroup */
  node: AccountGroup;
};

export type AccountGroupFilter = {
  and?: Maybe<Array<AccountGroupFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<AccountGroupFilter>>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type AccountGroupInput = {
  definition: Scalars['JSON'];
  description?: Maybe<Scalars['String']>;
  isDynamic?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  refreshRate?: Maybe<Scalars['Float']>;
};

export type AccountGroupMaxAggregate = {
  __typename: 'AccountGroupMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AccountGroupMinAggregate = {
  __typename: 'AccountGroupMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AccountGroupSort = {
  direction: SortDirection;
  field: AccountGroupSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum AccountGroupSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type AccountGroupUpdateFilter = {
  and?: Maybe<Array<AccountGroupUpdateFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<AccountGroupUpdateFilter>>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type AccountGroupUserDto = {
  __typename: 'AccountGroupUserDTO';
  accountId: Scalars['String'];
  appOS?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['DateTime']>;
  cartCreatedAt?: Maybe<Scalars['DateTime']>;
  cartUpdatedAt?: Maybe<Scalars['DateTime']>;
  currentCartValue?: Maybe<Scalars['Float']>;
  customerRecencyGroup: Scalars['String'];
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  hasActiveCart: Scalars['Boolean'];
  isNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastName?: Maybe<Scalars['String']>;
  lastPurchaseAt?: Maybe<Scalars['DateTime']>;
  mobile?: Maybe<Scalars['String']>;
  numberOfOrders?: Maybe<Scalars['Float']>;
  pushNotificationToken?: Maybe<Scalars['String']>;
  registeredDate?: Maybe<Scalars['DateTime']>;
  valueOfOrders?: Maybe<Scalars['Float']>;
  wishlistBrandCount?: Maybe<Scalars['Float']>;
  wishlistCount?: Maybe<Scalars['Float']>;
  wishlistEditCount?: Maybe<Scalars['Float']>;
  wishlistProductCount?: Maybe<Scalars['Float']>;
  wishlistStoryCount?: Maybe<Scalars['Float']>;
  wishlistUpdateAt?: Maybe<Scalars['DateTime']>;
};

export type AccountInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  password: Scalars['String'];
  roles?: Maybe<Array<Scalars['String']>>;
};

export type AccountMaxAggregate = {
  __typename: 'AccountMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type AccountMinAggregate = {
  __typename: 'AccountMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export enum AccountPermission {
  ExportCommunication = 'EXPORT_COMMUNICATION',
  OrderCommunication = 'ORDER_COMMUNICATION'
}

export type AccountPermissionDto = {
  __typename: 'AccountPermissionDTO';
  label: Scalars['String'];
  value: AccountPermission;
};

export type AccountSort = {
  direction: SortDirection;
  field: AccountSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum AccountSortFields {
  CreatedAt = 'createdAt',
  Email = 'email',
  Enabled = 'enabled',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  Status = 'status'
}

export type AccountUpdateFilter = {
  and?: Maybe<Array<AccountUpdateFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  email?: Maybe<StringFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  firstName?: Maybe<StringFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  lastName?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<AccountUpdateFilter>>;
  status?: Maybe<StringFieldComparison>;
};

export type AccountUpdateInput = {
  enabled?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  permissions?: Maybe<Array<AccountPermission>>;
  roles?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Statuses>;
};

export enum AccountsAction {
  Exclude = 'Exclude',
  Include = 'Include'
}

export type Action = {
  __typename: 'Action';
  channels?: Maybe<Array<MessageChannels>>;
  createdAt: Scalars['DateTime'];
  delay?: Maybe<Delay>;
  enabled: Scalars['Boolean'];
  expiryDate?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['String']>;
  meta: Scalars['JSON'];
  name: Scalars['String'];
  trigger: Trigger;
  type: ActionEventType;
  typeLabel: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  voucherMessage?: Maybe<Scalars['String']>;
  voucherValue?: Maybe<Scalars['Float']>;
};

export type ActionAggregateGroupBy = {
  __typename: 'ActionAggregateGroupBy';
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type ActionConnection = {
  __typename: 'ActionConnection';
  /** Array of edges. */
  edges: Array<ActionEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ActionCountAggregate = {
  __typename: 'ActionCountAggregate';
  enabled?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
};

export type ActionEdge = {
  __typename: 'ActionEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Action */
  node: Action;
};

export enum ActionEventType {
  IssueVoucher = 'IssueVoucher',
  SendMessage = 'SendMessage'
}

export type ActionFilter = {
  and?: Maybe<Array<ActionFilter>>;
  enabled?: Maybe<BooleanFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<ActionFilter>>;
};

export type ActionMaxAggregate = {
  __typename: 'ActionMaxAggregate';
  name?: Maybe<Scalars['String']>;
};

export type ActionMinAggregate = {
  __typename: 'ActionMinAggregate';
  name?: Maybe<Scalars['String']>;
};

export type ActionSort = {
  direction: SortDirection;
  field: ActionSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum ActionSortFields {
  Enabled = 'enabled',
  Name = 'name'
}

export type AddAccountGroupsToMessageCampaignDtoInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddAccountGroupsToTriggerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddActionsToTriggerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddBillingsToCustomerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddExclusionsToAccountGroupInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddImagesToProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddInclusionsToAccountGroupInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddProviderImagesToProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddShippingsToCustomerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddTagsToBrandInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddTagsToProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddTagsToProducts = {
  productIds: Array<Scalars['String']>;
  tagIds: Array<Scalars['String']>;
};

export type AddTagsToProfileInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type AddToCartInput = {
  productVariantId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type AddToListInput = {
  entityId: Scalars['String'];
  type: EntityTypes;
};

export type AddToListResult = {
  __typename: 'AddToListResult';
  list: List;
  message: Scalars['String'];
  status: Scalars['String'];
};

export type AddTypesToTagInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type Address = {
  __typename: 'Address';
  accountId: Scalars['String'];
  city: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  line1: Scalars['String'];
  line2: Scalars['String'];
  postalCode: Scalars['String'];
  province: Scalars['String'];
  suburb?: Maybe<Scalars['String']>;
};

export type AddressAggregateGroupBy = {
  __typename: 'AddressAggregateGroupBy';
  id?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type AddressConnection = {
  __typename: 'AddressConnection';
  /** Array of edges. */
  edges: Array<AddressEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type AddressCountAggregate = {
  __typename: 'AddressCountAggregate';
  id?: Maybe<Scalars['Int']>;
  isPrimary?: Maybe<Scalars['Int']>;
};

export type AddressDeleteFilter = {
  and?: Maybe<Array<AddressDeleteFilter>>;
  id?: Maybe<StringFieldComparison>;
  isPrimary?: Maybe<BooleanFieldComparison>;
  or?: Maybe<Array<AddressDeleteFilter>>;
};

export type AddressDeleteResponse = {
  __typename: 'AddressDeleteResponse';
  accountId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
};

export type AddressEdge = {
  __typename: 'AddressEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Address */
  node: Address;
};

export type AddressEntity = {
  __typename: 'AddressEntity';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  company: Scalars['String'];
  country: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultBillingAddress: Scalars['Boolean'];
  defaultShippingAddress: Scalars['Boolean'];
  firstName?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  province: Scalars['String'];
  shippingEmail?: Maybe<Scalars['String']>;
  streetLine1?: Maybe<Scalars['String']>;
  streetLine2?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type AddressFilter = {
  and?: Maybe<Array<AddressFilter>>;
  id?: Maybe<StringFieldComparison>;
  isPrimary?: Maybe<BooleanFieldComparison>;
  or?: Maybe<Array<AddressFilter>>;
};

export type AddressMaxAggregate = {
  __typename: 'AddressMaxAggregate';
  id?: Maybe<Scalars['String']>;
};

export type AddressMinAggregate = {
  __typename: 'AddressMinAggregate';
  id?: Maybe<Scalars['String']>;
};

export type AddressSort = {
  direction: SortDirection;
  field: AddressSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum AddressSortFields {
  Id = 'id',
  IsPrimary = 'isPrimary'
}

export type AddressUpdateFilter = {
  and?: Maybe<Array<AddressUpdateFilter>>;
  id?: Maybe<StringFieldComparison>;
  isPrimary?: Maybe<BooleanFieldComparison>;
  or?: Maybe<Array<AddressUpdateFilter>>;
};

export type AuthTokens = {
  __typename: 'AuthTokens';
  accessToken: Scalars['String'];
  accessTokenExpiry: Scalars['DateTime'];
  refreshToken: Scalars['String'];
  refreshTokenExpiry: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type BankDetails = {
  __typename: 'BankDetails';
  accountNumber?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
};

export type BankDetailsInput = {
  accountNumber?: Maybe<Scalars['String']>;
  bankName?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
};

export type BooleanFieldComparison = {
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
};

export type Brand = {
  __typename: 'Brand';
  address?: Maybe<Scalars['String']>;
  adminEmails: Array<Scalars['String']>;
  bankDetails?: Maybe<BankDetails>;
  brandCellphone?: Maybe<Scalars['String']>;
  brandDescription?: Maybe<Scalars['String']>;
  brandEmail?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  brandWebsite?: Maybe<Scalars['String']>;
  commission: Scalars['Float'];
  contactDetails: Array<ContactDetail>;
  createdAt: Scalars['DateTime'];
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  facebook?: Maybe<Scalars['String']>;
  featuredLandscape?: Maybe<Image>;
  featuredPortrait?: Maybe<Image>;
  featuredStory?: Maybe<Story>;
  feed?: Maybe<Feed>;
  handle?: Maybe<Scalars['String']>;
  hiddenFields: Array<BrandContactFields>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  images: Array<Image>;
  instagram?: Maybe<Scalars['String']>;
  installUrl?: Maybe<Scalars['String']>;
  invoiceAddress?: Maybe<BrandAddress>;
  isAddressHidden?: Maybe<Scalars['Boolean']>;
  isAllowedStagingSync?: Maybe<Scalars['Boolean']>;
  isEmailHidden?: Maybe<Scalars['Boolean']>;
  isPhoneNumberHidden?: Maybe<Scalars['Boolean']>;
  lastSync: Scalars['String'];
  leadTimeDays?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  locations: Array<LocationDto>;
  marketingColor?: Maybe<Scalars['String']>;
  marketingDescription?: Maybe<Scalars['String']>;
  marketingName?: Maybe<Scalars['String']>;
  meta?: Maybe<BrandMeta>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Notes>;
  ownerName?: Maybe<Scalars['String']>;
  paymentTerms?: Maybe<PaymentTerms>;
  phone?: Maybe<Scalars['String']>;
  privacyPolicy?: Maybe<Scalars['String']>;
  productCount?: Maybe<Scalars['Float']>;
  productSort: BrandProductSortEnum;
  productSortFriendly: Scalars['String'];
  products: BrandProductsConnection;
  productsSorted?: Maybe<Array<Product>>;
  providerAddress1?: Maybe<Scalars['String']>;
  providerAddress2?: Maybe<Scalars['String']>;
  providerCity?: Maybe<Scalars['String']>;
  providerDescription?: Maybe<Scalars['String']>;
  providerEmail?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  providerPhone?: Maybe<Scalars['String']>;
  providerProvince?: Maybe<Scalars['String']>;
  providerZip?: Maybe<Scalars['String']>;
  recentlySoldProducts?: Maybe<Array<Product>>;
  recommendedProductTags: Array<Scalars['String']>;
  recommendedProducts?: Maybe<Array<Product>>;
  returnPolicy?: Maybe<Scalars['String']>;
  shippingPolicy?: Maybe<Scalars['String']>;
  shopify?: Maybe<Shopify>;
  sizingGuide?: Maybe<SizingGuide>;
  story?: Maybe<Story>;
  tags: Array<Tag>;
  terms?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vatNumber?: Maybe<Scalars['String']>;
  verified: BrandStatus;
  website?: Maybe<Scalars['String']>;
  websiteOverride?: Maybe<Scalars['String']>;
};


export type BrandProductsArgs = {
  filter?: ProductFilter;
  paging?: CursorPaging;
  sorting?: Array<ProductSort>;
};


export type BrandProductsSortedArgs = {
  limit?: Maybe<Scalars['Float']>;
};


export type BrandRecentlySoldProductsArgs = {
  limit?: Maybe<Scalars['Float']>;
};


export type BrandRecommendedProductsArgs = {
  brandOnly?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Float']>;
};


export type BrandTagsArgs = {
  filter?: TagFilter;
  sorting?: Array<TagSort>;
};

export type BrandAddress = {
  __typename: 'BrandAddress';
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  province: Scalars['String'];
  zip: Scalars['String'];
};

export type BrandAddressInput = {
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  province: Scalars['String'];
  zip: Scalars['String'];
};

export type BrandAggregateGroupBy = {
  __typename: 'BrandAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isAllowedStagingSync?: Maybe<Scalars['Boolean']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BrandConnection = {
  __typename: 'BrandConnection';
  /** Array of edges. */
  edges: Array<BrandEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export enum BrandContactFields {
  Address = 'Address',
  Email = 'Email',
  Facebook = 'Facebook',
  Instagram = 'Instagram',
  Phone = 'Phone',
  Website = 'Website'
}

export type BrandCountAggregate = {
  __typename: 'BrandCountAggregate';
  createdAt?: Maybe<Scalars['Int']>;
  currency?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Int']>;
  handle?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isAllowedStagingSync?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  providerName?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type BrandDeleteFilter = {
  and?: Maybe<Array<BrandDeleteFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  currency?: Maybe<StringFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  handle?: Maybe<StringFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  isAllowedStagingSync?: Maybe<BooleanFieldComparison>;
  locale?: Maybe<StringFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<BrandDeleteFilter>>;
  providerName?: Maybe<StringFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type BrandDeleteResponse = {
  __typename: 'BrandDeleteResponse';
  address?: Maybe<Scalars['String']>;
  adminEmails?: Maybe<Array<Scalars['String']>>;
  bankDetails?: Maybe<BankDetails>;
  brandCellphone?: Maybe<Scalars['String']>;
  brandDescription?: Maybe<Scalars['String']>;
  brandEmail?: Maybe<Scalars['String']>;
  brandName?: Maybe<Scalars['String']>;
  brandWebsite?: Maybe<Scalars['String']>;
  commission?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  facebook?: Maybe<Scalars['String']>;
  handle?: Maybe<Scalars['String']>;
  hiddenFields?: Maybe<Array<BrandContactFields>>;
  id?: Maybe<Scalars['ID']>;
  instagram?: Maybe<Scalars['String']>;
  invoiceAddress?: Maybe<BrandAddress>;
  isAddressHidden?: Maybe<Scalars['Boolean']>;
  isAllowedStagingSync?: Maybe<Scalars['Boolean']>;
  isEmailHidden?: Maybe<Scalars['Boolean']>;
  isPhoneNumberHidden?: Maybe<Scalars['Boolean']>;
  leadTimeDays?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  marketingColor?: Maybe<Scalars['String']>;
  marketingDescription?: Maybe<Scalars['String']>;
  marketingName?: Maybe<Scalars['String']>;
  meta?: Maybe<BrandMeta>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<Notes>;
  ownerName?: Maybe<Scalars['String']>;
  paymentTerms?: Maybe<PaymentTerms>;
  phone?: Maybe<Scalars['String']>;
  privacyPolicy?: Maybe<Scalars['String']>;
  productSort?: Maybe<BrandProductSortEnum>;
  productSortFriendly?: Maybe<Scalars['String']>;
  providerAddress1?: Maybe<Scalars['String']>;
  providerAddress2?: Maybe<Scalars['String']>;
  providerCity?: Maybe<Scalars['String']>;
  providerDescription?: Maybe<Scalars['String']>;
  providerEmail?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  providerPhone?: Maybe<Scalars['String']>;
  providerProvince?: Maybe<Scalars['String']>;
  providerZip?: Maybe<Scalars['String']>;
  recommendedProductTags?: Maybe<Array<Scalars['String']>>;
  returnPolicy?: Maybe<Scalars['String']>;
  shippingPolicy?: Maybe<Scalars['String']>;
  terms?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vatNumber?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  websiteOverride?: Maybe<Scalars['String']>;
};

export type BrandEdge = {
  __typename: 'BrandEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Brand */
  node: Brand;
};

export type BrandFilter = {
  and?: Maybe<Array<BrandFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  currency?: Maybe<StringFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  handle?: Maybe<StringFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  isAllowedStagingSync?: Maybe<BooleanFieldComparison>;
  locale?: Maybe<StringFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<BrandFilter>>;
  providerName?: Maybe<StringFieldComparison>;
  tags?: Maybe<BrandFilterTagFilter>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type BrandFilterTagFilter = {
  and?: Maybe<Array<BrandFilterTagFilter>>;
  category?: Maybe<TagCategoryFilterComparison>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<BrandFilterTagFilter>>;
  topic?: Maybe<BooleanFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type BrandMaxAggregate = {
  __typename: 'BrandMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type BrandMeta = {
  __typename: 'BrandMeta';
  fields?: Maybe<Array<Field>>;
  includeRecentlySold?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  resizeMode?: Maybe<ResizeMode>;
};

export type BrandMetaInput = {
  fields?: Maybe<Array<FieldInput>>;
  includeRecentlySold?: Maybe<Scalars['Boolean']>;
  location?: Maybe<Scalars['String']>;
  resizeMode?: Maybe<ResizeMode>;
};

export type BrandMinAggregate = {
  __typename: 'BrandMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  providerName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum BrandProductSortEnum {
  CreatedAsc = 'CreatedAsc',
  CreatedDesc = 'CreatedDesc',
  Default = 'Default',
  PriceAsc = 'PriceAsc',
  PriceDesc = 'PriceDesc',
  Shuffle = 'Shuffle'
}

export type BrandProductSortOption = {
  __typename: 'BrandProductSortOption';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type BrandProductsConnection = {
  __typename: 'BrandProductsConnection';
  /** Array of edges. */
  edges: Array<ProductEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type BrandSales = {
  __typename: 'BrandSales';
  name: Scalars['String'];
  numOrders: Scalars['Int'];
  numProductsSold: Scalars['Int'];
};

export type BrandSort = {
  direction: SortDirection;
  field: BrandSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum BrandSortFields {
  CreatedAt = 'createdAt',
  Currency = 'currency',
  Enabled = 'enabled',
  Handle = 'handle',
  Id = 'id',
  IsAllowedStagingSync = 'isAllowedStagingSync',
  Locale = 'locale',
  Name = 'name',
  ProviderName = 'providerName',
  UpdatedAt = 'updatedAt'
}

export type BrandSyncInput = {
  id: Scalars['ID'];
};

export type BrandUpdateFilter = {
  and?: Maybe<Array<BrandUpdateFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  currency?: Maybe<StringFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  handle?: Maybe<StringFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  isAllowedStagingSync?: Maybe<BooleanFieldComparison>;
  locale?: Maybe<StringFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<BrandUpdateFilter>>;
  providerName?: Maybe<StringFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type BrandUpdateVerifyInput = {
  id: Scalars['ID'];
  installUrl: Scalars['String'];
};

export type BrandVerifyInput = {
  email: Scalars['String'];
  id: Scalars['ID'];
};

export type BrandsInput = {
  adminEmails?: Maybe<Array<Scalars['String']>>;
  appId?: Maybe<Scalars['String']>;
  bankDetails?: Maybe<BankDetailsInput>;
  commission?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  facebook?: Maybe<Scalars['String']>;
  hiddenFields?: Maybe<Array<BrandContactFields>>;
  instagram?: Maybe<Scalars['String']>;
  invoiceAddress?: Maybe<BrandAddressInput>;
  isAddressHidden?: Maybe<Scalars['Boolean']>;
  isAllowedStagingSync?: Maybe<Scalars['Boolean']>;
  isEmailHidden?: Maybe<Scalars['Boolean']>;
  isPhoneNumberHidden?: Maybe<Scalars['Boolean']>;
  leadTimeDays?: Maybe<Scalars['Int']>;
  marketingColor?: Maybe<Scalars['String']>;
  marketingDescription?: Maybe<Scalars['String']>;
  marketingName?: Maybe<Scalars['String']>;
  meta?: Maybe<BrandMetaInput>;
  name?: Maybe<Scalars['String']>;
  notes?: Maybe<NotesInput>;
  paymentTerms?: Maybe<PaymentTermsInput>;
  phone?: Maybe<Scalars['String']>;
  privacyPolicy?: Maybe<Scalars['String']>;
  productSort?: Maybe<BrandProductSortEnum>;
  recommendedProductTags?: Maybe<Array<Scalars['String']>>;
  returnPolicy?: Maybe<Scalars['String']>;
  shippingPolicy?: Maybe<Scalars['String']>;
  sizingGuideId?: Maybe<Scalars['ID']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  terms?: Maybe<Scalars['String']>;
  vatNumber?: Maybe<Scalars['String']>;
  websiteOverride?: Maybe<Scalars['String']>;
};

export enum CampaignInterval {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum CampaignType {
  Once = 'ONCE',
  Recurring = 'RECURRING'
}

export type CampaignTypeFilterComparison = {
  eq?: Maybe<CampaignType>;
  gt?: Maybe<CampaignType>;
  gte?: Maybe<CampaignType>;
  iLike?: Maybe<CampaignType>;
  in?: Maybe<Array<CampaignType>>;
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
  like?: Maybe<CampaignType>;
  lt?: Maybe<CampaignType>;
  lte?: Maybe<CampaignType>;
  neq?: Maybe<CampaignType>;
  notILike?: Maybe<CampaignType>;
  notIn?: Maybe<Array<CampaignType>>;
  notLike?: Maybe<CampaignType>;
};

export type CartStatistics = {
  __typename: 'CartStatistics';
  averageBasketSize: Scalars['Float'];
  numOrders: Scalars['Int'];
  value: Scalars['Float'];
};

export type ChangeItemInput = {
  lineId: Scalars['String'];
  productVariantId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type ChangeVariantInput = {
  orderItemId: Scalars['String'];
  productVariantId: Scalars['String'];
};

export type ComponentEntity = {
  __typename: 'ComponentEntity';
  createdAt?: Maybe<Scalars['DateTime']>;
  entityId: Scalars['String'];
  entityType?: Maybe<EntityTypes>;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ComponentEntityConnection = {
  __typename: 'ComponentEntityConnection';
  edges: Array<EntityEdge>;
  pageInfo: RelayPageInfo;
};

export type ConfigDto = {
  __typename: 'ConfigDTO';
  id: Scalars['ID'];
  name: Scalars['String'];
  value: Scalars['String'];
};


export type ContactDetail = {
  __typename: 'ContactDetail';
  icon: Scalars['String'];
  link?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  showValue?: Maybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type ContentfulComponent = {
  __typename: 'ContentfulComponent';
  children?: Maybe<Array<ContentfulComponent>>;
  componentId: Scalars['String'];
  componentType: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  entities?: Maybe<Array<EntityUnion>>;
  id: Scalars['String'];
  meta?: Maybe<Scalars['JSON']>;
  parent?: Maybe<ContentfulComponent>;
  position?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CreateActionInput = {
  channels?: Maybe<Array<MessageChannels>>;
  delay?: Maybe<DelayInput>;
  enabled?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  type: ActionEventType;
  voucherMessage?: Maybe<Scalars['String']>;
  voucherValue?: Maybe<Scalars['Float']>;
};

export type CreateAddress = {
  accountId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
};

export type CreateAddressInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  defaultBillingAddress?: Maybe<Scalars['Boolean']>;
  defaultShippingAddress?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  province: Scalars['String'];
  shippingEmail?: Maybe<Scalars['String']>;
  streetLine1?: Maybe<Scalars['String']>;
  streetLine2?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
};

export type CreateConfigInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type CreateCustomer = {
  accountId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
};

export type CreateCustomerInput = {
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
};

export type CreateEmailTemplateInput = {
  type: TemplateType;
};

export type CreateListInput = {
  listType: ListType;
  name: Scalars['String'];
};

export type CreateMailchimpMemberInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};

export type CreateManyAccountGroupsInput = {
  /** Array of records to create */
  accountGroups: Array<AccountGroupInput>;
};

export type CreateManyAccountsInput = {
  /** Array of records to create */
  accounts: Array<AccountInput>;
};

export type CreateManyAddressesInput = {
  /** Array of records to create */
  addresses: Array<CreateAddress>;
};

export type CreateManyCustomersInput = {
  /** Array of records to create */
  customers: Array<CreateCustomer>;
};

export type CreateManySizingGuidesInput = {
  /** Array of records to create */
  sizingGuides: Array<CreateSizingGuideInput>;
};

export type CreateManyTagsInput = {
  /** Array of records to create */
  tags: Array<CreateTag>;
};

export type CreateMessageCampaignInput = {
  accountGroupIds?: Maybe<Array<Scalars['String']>>;
  accountGroupOperator?: Maybe<Operator>;
  channels: Array<MessageChannels>;
  comment?: Maybe<Scalars['String']>;
  interval?: Maybe<CampaignInterval>;
  messageId: Scalars['String'];
  name: Scalars['String'];
  nextRunAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  timeToRun?: Maybe<Scalars['DateTime']>;
  type: CampaignType;
};

export type CreateMessageInput = {
  body?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<MessageMetaInput>;
  name: Scalars['String'];
  notificationBody?: Maybe<Scalars['String']>;
  notificationTitle: Scalars['String'];
  preview?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CreateOneAccountGroupInput = {
  /** The record to create */
  accountGroup: AccountGroupInput;
};

export type CreateOneAccountInput = {
  /** The record to create */
  account: AccountInput;
};

export type CreateOneAddressInput = {
  /** The record to create */
  address: CreateAddress;
};

export type CreateOneCustomerInput = {
  /** The record to create */
  customer: CreateCustomer;
};

export type CreateOneProfileInput = {
  /** The record to create */
  profile: ProfilesCreateInput;
};

export type CreateOneShopifyBrandInput = {
  brandName: Scalars['String'];
  clientKey: Scalars['String'];
  clientSecret: Scalars['String'];
  domain: Scalars['String'];
};

export type CreateOneSizingGuideInput = {
  /** The record to create */
  sizingGuide: CreateSizingGuideInput;
};

export type CreateOneTagInput = {
  /** The record to create */
  tag: CreateTag;
};

export type CreatePaymentDto = {
  meta?: Maybe<Scalars['JSON']>;
  method: Scalars['String'];
};

export type CreateSizingGuideInput = {
  content?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateTag = {
  category?: Maybe<TagCategory>;
  categoryLabel?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ImageInput>;
  meta?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['Boolean']>;
  types?: Maybe<Array<TagTypeInput>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CreateTriggerInput = {
  accountGroupIds?: Maybe<Array<Scalars['String']>>;
  actions: Array<CreateActionInput>;
  criteria: Scalars['JSON'];
  enabled: Scalars['Boolean'];
  eventType: AccountEventType;
  name: Scalars['String'];
};

export type CreateVouchersInput = {
  expiryDate: Scalars['DateTime'];
  quantity: Scalars['Float'];
  reason: Scalars['String'];
  value: Scalars['Float'];
};

export type CursorPaging = {
  /** Paginate after opaque cursor */
  after?: Maybe<Scalars['ConnectionCursor']>;
  /** Paginate before opaque cursor */
  before?: Maybe<Scalars['ConnectionCursor']>;
  /** Paginate first */
  first?: Maybe<Scalars['Int']>;
  /** Paginate last */
  last?: Maybe<Scalars['Int']>;
};

export type Customer = {
  __typename: 'Customer';
  accountId?: Maybe<Scalars['String']>;
  availableCredit: Scalars['Float'];
  billings: Array<Address>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSubscribed: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  shippings: Array<Address>;
  transactions: TransactionsConnection;
};


export type CustomerBillingsArgs = {
  filter?: AddressFilter;
  sorting?: Array<AddressSort>;
};


export type CustomerShippingsArgs = {
  filter?: AddressFilter;
  sorting?: Array<AddressSort>;
};


export type CustomerTransactionsArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type CustomerAggregateGroupBy = {
  __typename: 'CustomerAggregateGroupBy';
  accountId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type CustomerCountAggregate = {
  __typename: 'CustomerCountAggregate';
  accountId?: Maybe<Scalars['Int']>;
  email?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['Int']>;
};

export type CustomerEdge = {
  __typename: 'CustomerEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Customer */
  node: Customer;
};

export type CustomerEntity = {
  __typename: 'CustomerEntity';
  account: Account;
  addresses: Array<AddressEntity>;
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSubscribed: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CustomerMaxAggregate = {
  __typename: 'CustomerMaxAggregate';
  accountId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type CustomerMinAggregate = {
  __typename: 'CustomerMinAggregate';
  accountId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type DashboardProduct = {
  __typename: 'DashboardProduct';
  brand: Brand;
  id: Scalars['String'];
  productTitle: Scalars['String'];
};

export type DataPoint = {
  __typename: 'DataPoint';
  day: Scalars['DateTime'];
  total: Scalars['Float'];
};

export type DateFieldComparison = {
  between?: Maybe<DateFieldComparisonBetween>;
  eq?: Maybe<Scalars['DateTime']>;
  gt?: Maybe<Scalars['DateTime']>;
  gte?: Maybe<Scalars['DateTime']>;
  in?: Maybe<Array<Scalars['DateTime']>>;
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
  lt?: Maybe<Scalars['DateTime']>;
  lte?: Maybe<Scalars['DateTime']>;
  neq?: Maybe<Scalars['DateTime']>;
  notBetween?: Maybe<DateFieldComparisonBetween>;
  notIn?: Maybe<Array<Scalars['DateTime']>>;
};

export type DateFieldComparisonBetween = {
  lower: Scalars['DateTime'];
  upper: Scalars['DateTime'];
};


export type Delay = {
  __typename: 'Delay';
  unit: Scalars['String'];
  value: Scalars['Float'];
};

export type DelayInput = {
  unit: Scalars['String'];
  value: Scalars['Float'];
};

export type DeleteManyAccountGroupsInput = {
  /** Filter to find records to delete */
  filter: AccountGroupDeleteFilter;
};

export type DeleteManyAccountsInput = {
  /** Filter to find records to delete */
  filter: AccountDeleteFilter;
};

export type DeleteManyAddressesInput = {
  /** Filter to find records to delete */
  filter: AddressDeleteFilter;
};

export type DeleteManyBrandsInput = {
  /** Filter to find records to delete */
  filter: BrandDeleteFilter;
};

export type DeleteManyImagesInput = {
  /** Filter to find records to delete */
  filter: ImageDeleteFilter;
};

export type DeleteManyOrderItemsInput = {
  /** Filter to find records to delete */
  filter: OrderItemDeleteFilter;
};

export type DeleteManyOrderLinesInput = {
  /** Filter to find records to delete */
  filter: OrderLineDeleteFilter;
};

export type DeleteManyRefundsInput = {
  /** Filter to find records to delete */
  filter: RefundDeleteFilter;
};

export type DeleteManyResponse = {
  __typename: 'DeleteManyResponse';
  /** The number of records deleted. */
  deletedCount: Scalars['Int'];
};

export type DeleteManySizingGuidesInput = {
  /** Filter to find records to delete */
  filter: SizingGuideDeleteFilter;
};

export type DeleteManyTagsInput = {
  /** Filter to find records to delete */
  filter: TagDeleteFilter;
};

export type DeleteOneAccountGroupInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneAccountInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneAddressInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneBrandInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneImageInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneOrderItemInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneOrderLineInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneRefundInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneSizingGuideInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type DeleteOneTagInput = {
  /** The id of the record to delete. */
  id: Scalars['ID'];
};

export type EmailTemplate = {
  __typename: 'EmailTemplate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EntityEdge = {
  __typename: 'EntityEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: EntityUnion;
};

export enum EntityTypes {
  Brands = 'brands',
  Email = 'email',
  Feeds = 'feeds',
  Products = 'products',
  Stories = 'stories'
}

export type EntityUnion = Brand | Feed | Product | Story;

export type Feed = {
  __typename: 'Feed';
  feedId?: Maybe<Scalars['String']>;
  headline?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isLanding: Scalars['Boolean'];
  landscapeThumbnail?: Maybe<Scalars['String']>;
  layout: Array<ContentfulComponent>;
  name: Scalars['String'];
  thumbnail?: Maybe<Scalars['String']>;
};

export type FetchProductByProviderIdInput = {
  brandId: Scalars['ID'];
  providerId: Scalars['String'];
};

export type Field = {
  __typename: 'Field';
  isExternal?: Maybe<Scalars['Boolean']>;
  link: Scalars['String'];
  title: Scalars['String'];
};

export type FieldInput = {
  isExternal?: Maybe<Scalars['Boolean']>;
  link: Scalars['String'];
  title: Scalars['String'];
};

export type FloatFieldComparison = {
  between?: Maybe<FloatFieldComparisonBetween>;
  eq?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  neq?: Maybe<Scalars['Float']>;
  notBetween?: Maybe<FloatFieldComparisonBetween>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type FloatFieldComparisonBetween = {
  lower: Scalars['Float'];
  upper: Scalars['Float'];
};

export type ForgotPasswordResult = {
  __typename: 'ForgotPasswordResult';
  message: Scalars['String'];
  success: Scalars['Boolean'];
};

export type GoogleLoginInput = {
  idToken: Scalars['String'];
};

export type IdFilterComparison = {
  eq?: Maybe<Scalars['ID']>;
  gt?: Maybe<Scalars['ID']>;
  gte?: Maybe<Scalars['ID']>;
  iLike?: Maybe<Scalars['ID']>;
  in?: Maybe<Array<Scalars['ID']>>;
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
  like?: Maybe<Scalars['ID']>;
  lt?: Maybe<Scalars['ID']>;
  lte?: Maybe<Scalars['ID']>;
  neq?: Maybe<Scalars['ID']>;
  notILike?: Maybe<Scalars['ID']>;
  notIn?: Maybe<Array<Scalars['ID']>>;
  notLike?: Maybe<Scalars['ID']>;
};

export type Image = {
  __typename: 'Image';
  id: Scalars['String'];
  key?: Maybe<Scalars['String']>;
  sourceType: Scalars['String'];
  url: Scalars['String'];
  variantIds?: Maybe<Array<Scalars['String']>>;
};

export type ImageAggregateGroupBy = {
  __typename: 'ImageAggregateGroupBy';
  id?: Maybe<Scalars['String']>;
};

export type ImageCountAggregate = {
  __typename: 'ImageCountAggregate';
  id?: Maybe<Scalars['Int']>;
};

export type ImageDeleteFilter = {
  and?: Maybe<Array<ImageDeleteFilter>>;
  id?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<ImageDeleteFilter>>;
};

export type ImageDeleteResponse = {
  __typename: 'ImageDeleteResponse';
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  variantIds?: Maybe<Array<Scalars['String']>>;
};

export type ImageEdge = {
  __typename: 'ImageEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Image */
  node: Image;
};

export type ImageFilter = {
  and?: Maybe<Array<ImageFilter>>;
  id?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<ImageFilter>>;
};

export type ImageInput = {
  id: Scalars['String'];
  key?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  variantIds?: Maybe<Array<Scalars['String']>>;
};

export type ImageMaxAggregate = {
  __typename: 'ImageMaxAggregate';
  id?: Maybe<Scalars['String']>;
};

export type ImageMinAggregate = {
  __typename: 'ImageMinAggregate';
  id?: Maybe<Scalars['String']>;
};

export type ImageSort = {
  direction: SortDirection;
  field: ImageSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum ImageSortFields {
  Id = 'id'
}

export type IntFieldComparison = {
  between?: Maybe<IntFieldComparisonBetween>;
  eq?: Maybe<Scalars['Int']>;
  gt?: Maybe<Scalars['Int']>;
  gte?: Maybe<Scalars['Int']>;
  in?: Maybe<Array<Scalars['Int']>>;
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
  lt?: Maybe<Scalars['Int']>;
  lte?: Maybe<Scalars['Int']>;
  neq?: Maybe<Scalars['Int']>;
  notBetween?: Maybe<IntFieldComparisonBetween>;
  notIn?: Maybe<Array<Scalars['Int']>>;
};

export type IntFieldComparisonBetween = {
  lower: Scalars['Int'];
  upper: Scalars['Int'];
};

export type InternalStats = {
  __typename: 'InternalStats';
  available: TimePeriods;
  created: TimePeriods;
  used: TimePeriods;
};


export type List = {
  __typename: 'List';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  entities?: Maybe<ListEntityConnection>;
  id: Scalars['ID'];
  isOwner: Scalars['Boolean'];
  isPublic: Scalars['Boolean'];
  listType: ListType;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ListEntitiesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  filter?: Maybe<EntityTypes>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
};

export type ListEntityConnection = {
  __typename: 'ListEntityConnection';
  edges: Array<ListEntityEdge>;
  pageInfo: RelayPageInfo;
};

export type ListEntityEdge = {
  __typename: 'ListEntityEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: EntityUnion;
};

export enum ListType {
  Bookmark = 'Bookmark'
}

export type LocationDto = {
  __typename: 'LocationDTO';
  address1?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
};

export type LoginAccountInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type Message = {
  __typename: 'Message';
  body: Scalars['String'];
  contentId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled: Scalars['Boolean'];
  id: Scalars['ID'];
  meta?: Maybe<MessageMeta>;
  name: Scalars['String'];
  notificationBody: Scalars['String'];
  notificationTitle: Scalars['String'];
  preview?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageAggregateGroupBy = {
  __typename: 'MessageAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageCampaign = {
  __typename: 'MessageCampaign';
  accounts: Scalars['Float'];
  comment?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  scheduledAt?: Maybe<Scalars['DateTime']>;
  sentAt: Scalars['DateTime'];
  taskId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageCampaignDto = {
  __typename: 'MessageCampaignDTO';
  accountGroupOperator: Operator;
  accountGroups: Array<AccountGroup>;
  channels: Array<MessageChannels>;
  comment?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  interval?: Maybe<CampaignInterval>;
  message?: Maybe<Message>;
  name: Scalars['String'];
  nextRunAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  timeToRun?: Maybe<Scalars['DateTime']>;
  type: CampaignType;
};


export type MessageCampaignDtoAccountGroupsArgs = {
  filter?: AccountGroupFilter;
  sorting?: Array<AccountGroupSort>;
};

export type MessageCampaignDtoAggregateGroupBy = {
  __typename: 'MessageCampaignDTOAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nextRunAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<CampaignType>;
};

export type MessageCampaignDtoConnection = {
  __typename: 'MessageCampaignDTOConnection';
  /** Array of edges. */
  edges: Array<MessageCampaignDtoEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type MessageCampaignDtoCountAggregate = {
  __typename: 'MessageCampaignDTOCountAggregate';
  createdAt?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  nextRunAt?: Maybe<Scalars['Int']>;
  scheduledAt?: Maybe<Scalars['Int']>;
  sentAt?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['Int']>;
};

export type MessageCampaignDtoEdge = {
  __typename: 'MessageCampaignDTOEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the MessageCampaignDTO */
  node: MessageCampaignDto;
};

export type MessageCampaignDtoFilter = {
  accountGroups?: Maybe<MessageCampaignDtoFilterAccountGroupFilter>;
  and?: Maybe<Array<MessageCampaignDtoFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  message?: Maybe<MessageCampaignDtoFilterMessageFilter>;
  name?: Maybe<StringFieldComparison>;
  nextRunAt?: Maybe<DateFieldComparison>;
  or?: Maybe<Array<MessageCampaignDtoFilter>>;
  scheduledAt?: Maybe<DateFieldComparison>;
  sentAt?: Maybe<DateFieldComparison>;
  type?: Maybe<CampaignTypeFilterComparison>;
};

export type MessageCampaignDtoFilterAccountGroupFilter = {
  and?: Maybe<Array<MessageCampaignDtoFilterAccountGroupFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<MessageCampaignDtoFilterAccountGroupFilter>>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type MessageCampaignDtoFilterMessageFilter = {
  and?: Maybe<Array<MessageCampaignDtoFilterMessageFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<MessageCampaignDtoFilterMessageFilter>>;
  title?: Maybe<StringFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type MessageCampaignDtoMaxAggregate = {
  __typename: 'MessageCampaignDTOMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nextRunAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<CampaignType>;
};

export type MessageCampaignDtoMinAggregate = {
  __typename: 'MessageCampaignDTOMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  nextRunAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  type?: Maybe<CampaignType>;
};

export type MessageCampaignDtoSort = {
  direction: SortDirection;
  field: MessageCampaignDtoSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum MessageCampaignDtoSortFields {
  CreatedAt = 'createdAt',
  Name = 'name',
  NextRunAt = 'nextRunAt',
  ScheduledAt = 'scheduledAt',
  SentAt = 'sentAt',
  Type = 'type'
}

export enum MessageChannels {
  Email = 'EMAIL',
  Inbox = 'INBOX',
  Push = 'PUSH',
  Sms = 'SMS',
  Whatsapp = 'WHATSAPP'
}

export type MessageConnection = {
  __typename: 'MessageConnection';
  /** Array of edges. */
  edges: Array<MessageEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type MessageCountAggregate = {
  __typename: 'MessageCountAggregate';
  createdAt?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type MessageEdge = {
  __typename: 'MessageEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Message */
  node: Message;
};

export type MessageFilter = {
  and?: Maybe<Array<MessageFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<MessageFilter>>;
  title?: Maybe<StringFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type MessageMaxAggregate = {
  __typename: 'MessageMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageMeta = {
  __typename: 'MessageMeta';
  deeplink: Scalars['String'];
};

export type MessageMetaInput = {
  deeplink: Scalars['String'];
};

export type MessageMinAggregate = {
  __typename: 'MessageMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type MessageSort = {
  direction: SortDirection;
  field: MessageSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum MessageSortFields {
  CreatedAt = 'createdAt',
  Enabled = 'enabled',
  Name = 'name',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type Meta = {
  __typename: 'Meta';
  fields?: Maybe<Array<Field>>;
  resizeMode?: Maybe<ResizeMode>;
};

export type MetaInput = {
  fields?: Maybe<Array<FieldInput>>;
  resizeMode?: Maybe<ResizeMode>;
};

export type Mutation = {
  __typename: 'Mutation';
  addAccountGroupsToMessageCampaignDTO: MessageCampaignDto;
  addAccountGroupsToTrigger: Trigger;
  addAccountPaymentMethod: Scalars['Boolean'];
  addActionsToTrigger: Trigger;
  addBillingsToCustomer: Customer;
  addExclusionsToAccountGroup: AccountGroup;
  addImagesToProduct: Product;
  addInclusionsToAccountGroup: AccountGroup;
  addItemToList: AddToListResult;
  addOrderPayment: Order;
  addProviderImagesToProduct: Product;
  addShippingsToCustomer: Customer;
  addTagsToBrand: Brand;
  addTagsToProduct: Product;
  addTagsToProducts: Scalars['Boolean'];
  addTagsToProfile: Profile;
  addToCart: Order;
  addTypesToTag: Tag;
  brandSetupandTest: Scalars['Boolean'];
  buildFeeds: Scalars['Boolean'];
  buildStories: Scalars['Boolean'];
  changeItemVariant: Order;
  chargeOrderPaymentToken: Scalars['Boolean'];
  checkPriceUpdates: Array<ProductUpdate>;
  clearCart: Order;
  completeOrder: Order;
  createAction: Action;
  createConfig: Scalars['Boolean'];
  createCustomerAddress: AddressEntity;
  createEmailTemplate: EmailTemplate;
  createLedgerItem: OrderLedger;
  createList: List;
  createManyAccountGroups: Array<AccountGroup>;
  createManyAccounts: Array<Account>;
  createManyAddresses: Array<Address>;
  createManyCustomers: Array<Customer>;
  createManySizingGuides: Array<SizingGuide>;
  createManyTags: Array<Tag>;
  createMessage: Message;
  createMessageCampaign: MessageCampaign;
  createOneAccount: Account;
  createOneAccountGroup: AccountGroup;
  createOneAddress: Address;
  createOneCustomer: Customer;
  createOneProfile: Profile;
  createOneShopifyBrand: Brand;
  createOneSizingGuide: SizingGuide;
  createOneTag: Tag;
  createTrigger: Trigger;
  createVouchers: Scalars['Boolean'];
  deleteAccount: Scalars['Boolean'];
  deleteAccountByEmail: Scalars['Boolean'];
  deleteAction: Scalars['Boolean'];
  deleteCard: Scalars['Boolean'];
  deleteCustomerAddress: Scalars['Boolean'];
  deleteLedgerEntry: Scalars['Boolean'];
  deleteList: Scalars['Boolean'];
  deleteManyAccountGroups: DeleteManyResponse;
  deleteManyAccounts: DeleteManyResponse;
  deleteManyAddresses: DeleteManyResponse;
  deleteManyBrands: DeleteManyResponse;
  deleteManyImages: DeleteManyResponse;
  deleteManyOrderItems: DeleteManyResponse;
  deleteManyOrderLines: DeleteManyResponse;
  deleteManyRefunds: DeleteManyResponse;
  deleteManySizingGuides: DeleteManyResponse;
  deleteManyTags: DeleteManyResponse;
  deleteOneAccount: AccountDeleteResponse;
  deleteOneAccountGroup: AccountGroupDeleteResponse;
  deleteOneAddress: AddressDeleteResponse;
  deleteOneBrand: BrandDeleteResponse;
  deleteOneImage: ImageDeleteResponse;
  deleteOneOrderItem: OrderItemDeleteResponse;
  deleteOneOrderLine: OrderLineDeleteResponse;
  deleteOneRefund: RefundDeleteResponse;
  deleteOneSizingGuide: SizingGuideDeleteResponse;
  deleteOneTag: TagDeleteResponse;
  deleteSubscription: Scalars['Boolean'];
  deleteTrigger: Scalars['Boolean'];
  exportAccountGroupAccounts: Scalars['Boolean'];
  exportOrders: Scalars['Boolean'];
  fetchAllBrandProductsInventory: Scalars['Boolean'];
  fetchAndSyncProductByProviderId: Scalars['Boolean'];
  generateCodesMigration: Scalars['Boolean'];
  getOrderPaymentToken: Scalars['String'];
  getRegistrationToken: Scalars['String'];
  indexBrand: Scalars['Boolean'];
  indexBrands: Scalars['Boolean'];
  indexProduct: Scalars['Boolean'];
  indexProducts: Scalars['Boolean'];
  login: Account;
  loginWithGoogle: Account;
  logout: Scalars['Boolean'];
  mailchimpSubscribe: Scalars['Boolean'];
  mailchimpUnsubscribe: Scalars['Boolean'];
  mailchimpUpdateMember: Scalars['Boolean'];
  paymentRequirements: Scalars['Boolean'];
  processBatch: Scalars['Boolean'];
  processBrandStatement: Scalars['Boolean'];
  processBrands: Scalars['Boolean'];
  processProduct: Scalars['Boolean'];
  processProducts: Scalars['Boolean'];
  processRefund: Scalars['Boolean'];
  processRefunds: Scalars['Boolean'];
  publishTagFeed: Scalars['Boolean'];
  redeemVoucher: RedeemVoucherResponse;
  register: Account;
  registerBrandWebhooks: Scalars['Boolean'];
  registerCustomerAccount: Scalars['Boolean'];
  removeAccountGroupsFromMessageCampaignDTO: MessageCampaignDto;
  removeAccountGroupsFromTrigger: Trigger;
  removeActionsFromTrigger: Trigger;
  removeAvatarFromProfile: Profile;
  removeBillingsFromCustomer: Customer;
  removeCustomerFromAccount: Account;
  removeEmailTemplate: EmailTemplate;
  removeExclusionsFromAccountGroup: AccountGroup;
  removeFeaturedLandscapeFromBrand: Brand;
  removeFeaturedPortraitFromBrand: Brand;
  removeFromList: Scalars['Boolean'];
  removeImageFromBrand: Brand;
  removeImageFromProduct: Product;
  removeImageFromTag: Tag;
  removeImagesFromProduct: Product;
  removeInclusionsFromAccountGroup: AccountGroup;
  removeItemFromOrder: Order;
  removeLineById: Order;
  removeMessage: Scalars['Boolean'];
  removeMessageCampaign: Scalars['Boolean'];
  removeMessageFromAction: Action;
  removeMessageFromMessageCampaignDTO: MessageCampaignDto;
  removeOneLineItem: Order;
  removeProductFromProductVariant: ProductVariant;
  removeProfileFromAccount: Account;
  removeProviderImagesFromProduct: Product;
  removeShippingsFromCustomer: Customer;
  removeSizingGuideFromBrand: Brand;
  removeSizingGuideFromProduct: Product;
  removeTagsFromBrand: Brand;
  removeTagsFromProduct: Product;
  removeTagsFromProducts: Scalars['Boolean'];
  removeTagsFromProfile: Profile;
  removeTriggerFromAction: Action;
  removeTypesFromTag: Tag;
  reprocessBatch: Scalars['Boolean'];
  reprocessInvoice: Scalars['Boolean'];
  reprocessOrder: Scalars['Boolean'];
  reprocessOrderLine: Scalars['Boolean'];
  resendVoucher: Scalars['Boolean'];
  resetOnePassword: Scalars['Boolean'];
  salesCommissionReport: Scalars['Boolean'];
  sendCustomerCsv: Scalars['Boolean'];
  sendOneBrandVerify: Scalars['Boolean'];
  sendOnePasswordForgot: ForgotPasswordResult;
  sendVouchersCsv: Scalars['Boolean'];
  setAccountGroupsOnMessageCampaignDTO: MessageCampaignDto;
  setAccountGroupsOnTrigger: Trigger;
  setActionsOnTrigger: Trigger;
  setAvatarOnProfile: Profile;
  setBillingsOnCustomer: Customer;
  setCustomerForOrder: Order;
  setCustomerOnAccount: Account;
  setDefaultCard?: Maybe<AccountCard>;
  setExclusionsOnAccountGroup: AccountGroup;
  setFeaturedLandscapeOnBrand: Brand;
  setFeaturedPortraitOnBrand: Brand;
  setImageOnBrand: Brand;
  setImageOnProduct: Product;
  setImageOnTag: Tag;
  setImagesOnBrand: Brand;
  setImagesOnProduct: Product;
  setInclusionsOnAccountGroup: AccountGroup;
  setMessageOnAction: Action;
  setMessageOnMessageCampaignDTO: MessageCampaignDto;
  setOrderBillingAddress: Order;
  setOrderShippingAddress: Order;
  setProductOnProductVariant: ProductVariant;
  setProfileOnAccount: Account;
  setProviderImagesOnProduct: Product;
  setShippingMethod: Order;
  setShippingsOnCustomer: Customer;
  setSizingGuideOnBrand: Brand;
  setSizingGuideOnProduct: Product;
  setTagsOnBrand: Brand;
  setTagsOnProduct: Product;
  setTagsOnProfile: Profile;
  setTriggerOnAction: Action;
  setTypesOnTag: Tag;
  setUseCreditOnOrder: Order;
  setVariantNotifications: Scalars['Boolean'];
  subscribeToKlaviyoList: SubscribeToKlaviyoListResponse;
  subscribeToPush: Scalars['Boolean'];
  subscribeToVariant: ProductVariantSubscription;
  syncAll: Scalars['Boolean'];
  syncOneBrand: Scalars['Boolean'];
  testBrandWebhook: Scalars['Boolean'];
  triggerEvent: Scalars['Boolean'];
  unsubscribeAccount: SuccessResponse;
  unsubscribeFromPush: Scalars['Boolean'];
  updateAccountGroupUsers: Scalars['Boolean'];
  updateAction: Action;
  updateBrand: Brand;
  updateConfig: Scalars['Boolean'];
  updateCustomerAddress: AddressEntity;
  updateEmailTemplate: EmailTemplate;
  updateLedgerEntry: OrderLedger;
  updateList: List;
  updateManyAccountGroups: UpdateManyResponse;
  updateManyAccounts: UpdateManyResponse;
  updateManyAddresses: UpdateManyResponse;
  updateManyBrands: UpdateManyResponse;
  updateManyOptionNames: UpdateManyResponse;
  updateManyProductOptions: UpdateManyResponse;
  updateManyProductVariants: UpdateManyResponse;
  updateManyProducts: UpdateManyResponse;
  updateManySizingGuides: UpdateManyResponse;
  updateManyTags: UpdateManyResponse;
  updateManyVouchers: UpdateManyResponse;
  updateMessage: Message;
  updateMessageCampaign: MessageCampaign;
  updateOneAccount: Account;
  updateOneAccountGroup: AccountGroup;
  updateOneAddress: Address;
  updateOneBrand: Brand;
  updateOneBrandVerify: Scalars['Boolean'];
  updateOneCustomer: Customer;
  updateOneLineQuantity: Order;
  updateOneOptionName: OptionName;
  updateOneProduct: Product;
  updateOneProductOption: ProductOption;
  updateOneProductVariant: ProductVariant;
  updateOneProfile: Profile;
  updateOneSizingGuide: SizingGuide;
  updateOneTag: Tag;
  updateOneVoucher: Voucher;
  updateOrderItemMeta: OrderItem;
  updateOrderLinePaymentDate: OrderLine;
  updatePassword: Scalars['Boolean'];
  updateShopify: Shopify;
  updateTrigger: Trigger;
  uploadOneImage: Image;
};


export type MutationAddAccountGroupsToMessageCampaignDtoArgs = {
  input: AddAccountGroupsToMessageCampaignDtoInput;
};


export type MutationAddAccountGroupsToTriggerArgs = {
  input: AddAccountGroupsToTriggerInput;
};


export type MutationAddAccountPaymentMethodArgs = {
  input: CreatePaymentDto;
};


export type MutationAddActionsToTriggerArgs = {
  input: AddActionsToTriggerInput;
};


export type MutationAddBillingsToCustomerArgs = {
  input: AddBillingsToCustomerInput;
};


export type MutationAddExclusionsToAccountGroupArgs = {
  input: AddExclusionsToAccountGroupInput;
};


export type MutationAddImagesToProductArgs = {
  input: AddImagesToProductInput;
};


export type MutationAddInclusionsToAccountGroupArgs = {
  input: AddInclusionsToAccountGroupInput;
};


export type MutationAddItemToListArgs = {
  input: AddToListInput;
  listId: Scalars['String'];
};


export type MutationAddOrderPaymentArgs = {
  input: OrderPaymentInput;
};


export type MutationAddProviderImagesToProductArgs = {
  input: AddProviderImagesToProductInput;
};


export type MutationAddShippingsToCustomerArgs = {
  input: AddShippingsToCustomerInput;
};


export type MutationAddTagsToBrandArgs = {
  input: AddTagsToBrandInput;
};


export type MutationAddTagsToProductArgs = {
  input: AddTagsToProductInput;
};


export type MutationAddTagsToProductsArgs = {
  input: AddTagsToProducts;
};


export type MutationAddTagsToProfileArgs = {
  input: AddTagsToProfileInput;
};


export type MutationAddToCartArgs = {
  input: AddToCartInput;
  orderMeta?: Maybe<OrderMetaFieldsInput>;
};


export type MutationAddTypesToTagArgs = {
  input: AddTypesToTagInput;
};


export type MutationChangeItemVariantArgs = {
  input: ChangeVariantInput;
};


export type MutationChargeOrderPaymentTokenArgs = {
  input: CreatePaymentDto;
  orderMeta?: Maybe<OrderMetaFieldsInput>;
};


export type MutationCompleteOrderArgs = {
  orderMeta?: Maybe<OrderMetaFieldsInput>;
};


export type MutationCreateActionArgs = {
  input: CreateActionInput;
};


export type MutationCreateConfigArgs = {
  input: CreateConfigInput;
};


export type MutationCreateCustomerAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateEmailTemplateArgs = {
  input: CreateEmailTemplateInput;
};


export type MutationCreateLedgerItemArgs = {
  input: OrderLineLedgerInput;
  orderLineId: Scalars['String'];
};


export type MutationCreateListArgs = {
  input: CreateListInput;
};


export type MutationCreateManyAccountGroupsArgs = {
  input: CreateManyAccountGroupsInput;
};


export type MutationCreateManyAccountsArgs = {
  input: CreateManyAccountsInput;
};


export type MutationCreateManyAddressesArgs = {
  input: CreateManyAddressesInput;
};


export type MutationCreateManyCustomersArgs = {
  input: CreateManyCustomersInput;
};


export type MutationCreateManySizingGuidesArgs = {
  input: CreateManySizingGuidesInput;
};


export type MutationCreateManyTagsArgs = {
  input: CreateManyTagsInput;
};


export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationCreateMessageCampaignArgs = {
  input: CreateMessageCampaignInput;
};


export type MutationCreateOneAccountArgs = {
  input: CreateOneAccountInput;
};


export type MutationCreateOneAccountGroupArgs = {
  input: CreateOneAccountGroupInput;
};


export type MutationCreateOneAddressArgs = {
  input: CreateOneAddressInput;
};


export type MutationCreateOneCustomerArgs = {
  input: CreateOneCustomerInput;
};


export type MutationCreateOneProfileArgs = {
  input: CreateOneProfileInput;
};


export type MutationCreateOneShopifyBrandArgs = {
  input: CreateOneShopifyBrandInput;
};


export type MutationCreateOneSizingGuideArgs = {
  input: CreateOneSizingGuideInput;
};


export type MutationCreateOneTagArgs = {
  input: CreateOneTagInput;
};


export type MutationCreateTriggerArgs = {
  input: CreateTriggerInput;
};


export type MutationCreateVouchersArgs = {
  input: CreateVouchersInput;
};


export type MutationDeleteAccountByEmailArgs = {
  email: Scalars['String'];
};


export type MutationDeleteActionArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteCardArgs = {
  cardId: Scalars['String'];
};


export type MutationDeleteCustomerAddressArgs = {
  addressId: Scalars['String'];
};


export type MutationDeleteLedgerEntryArgs = {
  id: Scalars['String'];
};


export type MutationDeleteListArgs = {
  listId: Scalars['String'];
};


export type MutationDeleteManyAccountGroupsArgs = {
  input: DeleteManyAccountGroupsInput;
};


export type MutationDeleteManyAccountsArgs = {
  input: DeleteManyAccountsInput;
};


export type MutationDeleteManyAddressesArgs = {
  input: DeleteManyAddressesInput;
};


export type MutationDeleteManyBrandsArgs = {
  input: DeleteManyBrandsInput;
};


export type MutationDeleteManyImagesArgs = {
  input: DeleteManyImagesInput;
};


export type MutationDeleteManyOrderItemsArgs = {
  input: DeleteManyOrderItemsInput;
};


export type MutationDeleteManyOrderLinesArgs = {
  input: DeleteManyOrderLinesInput;
};


export type MutationDeleteManyRefundsArgs = {
  input: DeleteManyRefundsInput;
};


export type MutationDeleteManySizingGuidesArgs = {
  input: DeleteManySizingGuidesInput;
};


export type MutationDeleteManyTagsArgs = {
  input: DeleteManyTagsInput;
};


export type MutationDeleteOneAccountArgs = {
  input: DeleteOneAccountInput;
};


export type MutationDeleteOneAccountGroupArgs = {
  input: DeleteOneAccountGroupInput;
};


export type MutationDeleteOneAddressArgs = {
  input: DeleteOneAddressInput;
};


export type MutationDeleteOneBrandArgs = {
  input: DeleteOneBrandInput;
};


export type MutationDeleteOneImageArgs = {
  input: DeleteOneImageInput;
};


export type MutationDeleteOneOrderItemArgs = {
  input: DeleteOneOrderItemInput;
};


export type MutationDeleteOneOrderLineArgs = {
  input: DeleteOneOrderLineInput;
};


export type MutationDeleteOneRefundArgs = {
  input: DeleteOneRefundInput;
};


export type MutationDeleteOneSizingGuideArgs = {
  input: DeleteOneSizingGuideInput;
};


export type MutationDeleteOneTagArgs = {
  input: DeleteOneTagInput;
};


export type MutationDeleteSubscriptionArgs = {
  variantId: Scalars['String'];
};


export type MutationDeleteTriggerArgs = {
  id: Scalars['ID'];
};


export type MutationExportAccountGroupAccountsArgs = {
  accountGroupId: Scalars['String'];
};


export type MutationExportOrdersArgs = {
  filter?: OrderFilter;
  paging?: CursorPaging;
  sorting?: Array<OrderSort>;
};


export type MutationFetchAndSyncProductByProviderIdArgs = {
  input: FetchProductByProviderIdInput;
};


export type MutationGetOrderPaymentTokenArgs = {
  input: CreatePaymentDto;
  orderMeta?: Maybe<OrderMetaFieldsInput>;
};


export type MutationGetRegistrationTokenArgs = {
  input: CreatePaymentDto;
};


export type MutationIndexBrandArgs = {
  id: Scalars['String'];
};


export type MutationIndexProductArgs = {
  id: Scalars['String'];
};


export type MutationIndexProductsArgs = {
  ids?: Maybe<Array<Scalars['String']>>;
};


export type MutationLoginArgs = {
  input: LoginAccountInput;
};


export type MutationLoginWithGoogleArgs = {
  input: GoogleLoginInput;
};


export type MutationMailchimpSubscribeArgs = {
  input: CreateMailchimpMemberInput;
};


export type MutationMailchimpUnsubscribeArgs = {
  email: Scalars['String'];
};


export type MutationMailchimpUpdateMemberArgs = {
  email: Scalars['String'];
  input: UpdateMailchimpMemberInput;
};


export type MutationProcessBrandStatementArgs = {
  brandId: Scalars['String'];
  endDate: Scalars['String'];
  sendToBrand: Scalars['Boolean'];
  startDate: Scalars['String'];
};


export type MutationProcessProductArgs = {
  id: Scalars['String'];
};


export type MutationPublishTagFeedArgs = {
  tagId: Scalars['String'];
};


export type MutationRedeemVoucherArgs = {
  voucherCode: Scalars['String'];
};


export type MutationRegisterArgs = {
  input: AccountInput;
};


export type MutationRegisterBrandWebhooksArgs = {
  id: Scalars['String'];
};


export type MutationRegisterCustomerAccountArgs = {
  input: RegisterCustomerInput;
};


export type MutationRemoveAccountGroupsFromMessageCampaignDtoArgs = {
  input: RemoveAccountGroupsFromMessageCampaignDtoInput;
};


export type MutationRemoveAccountGroupsFromTriggerArgs = {
  input: RemoveAccountGroupsFromTriggerInput;
};


export type MutationRemoveActionsFromTriggerArgs = {
  input: RemoveActionsFromTriggerInput;
};


export type MutationRemoveAvatarFromProfileArgs = {
  input: RemoveAvatarFromProfileInput;
};


export type MutationRemoveBillingsFromCustomerArgs = {
  input: RemoveBillingsFromCustomerInput;
};


export type MutationRemoveCustomerFromAccountArgs = {
  input: RemoveCustomerFromAccountInput;
};


export type MutationRemoveEmailTemplateArgs = {
  id: Scalars['String'];
};


export type MutationRemoveExclusionsFromAccountGroupArgs = {
  input: RemoveExclusionsFromAccountGroupInput;
};


export type MutationRemoveFeaturedLandscapeFromBrandArgs = {
  input: RemoveFeaturedLandscapeFromBrandInput;
};


export type MutationRemoveFeaturedPortraitFromBrandArgs = {
  input: RemoveFeaturedPortraitFromBrandInput;
};


export type MutationRemoveFromListArgs = {
  itemId: Scalars['String'];
  listId: Scalars['String'];
};


export type MutationRemoveImageFromBrandArgs = {
  input: RemoveImageFromBrandInput;
};


export type MutationRemoveImageFromProductArgs = {
  input: RemoveImageFromProductInput;
};


export type MutationRemoveImageFromTagArgs = {
  input: RemoveImageFromTagInput;
};


export type MutationRemoveImagesFromProductArgs = {
  input: RemoveImagesFromProductInput;
};


export type MutationRemoveInclusionsFromAccountGroupArgs = {
  input: RemoveInclusionsFromAccountGroupInput;
};


export type MutationRemoveItemFromOrderArgs = {
  input: RemoveItemInput;
  orderId: Scalars['String'];
};


export type MutationRemoveLineByIdArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMessageArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMessageCampaignArgs = {
  id: Scalars['String'];
};


export type MutationRemoveMessageFromActionArgs = {
  input: RemoveMessageFromActionInput;
};


export type MutationRemoveMessageFromMessageCampaignDtoArgs = {
  input: RemoveMessageFromMessageCampaignDtoInput;
};


export type MutationRemoveOneLineItemArgs = {
  input: RemoveItemInput;
};


export type MutationRemoveProductFromProductVariantArgs = {
  input: RemoveProductFromProductVariantInput;
};


export type MutationRemoveProfileFromAccountArgs = {
  input: RemoveProfileFromAccountInput;
};


export type MutationRemoveProviderImagesFromProductArgs = {
  input: RemoveProviderImagesFromProductInput;
};


export type MutationRemoveShippingsFromCustomerArgs = {
  input: RemoveShippingsFromCustomerInput;
};


export type MutationRemoveSizingGuideFromBrandArgs = {
  input: RemoveSizingGuideFromBrandInput;
};


export type MutationRemoveSizingGuideFromProductArgs = {
  input: RemoveSizingGuideFromProductInput;
};


export type MutationRemoveTagsFromBrandArgs = {
  input: RemoveTagsFromBrandInput;
};


export type MutationRemoveTagsFromProductArgs = {
  input: RemoveTagsFromProductInput;
};


export type MutationRemoveTagsFromProductsArgs = {
  input: RemoveTagsFromProducts;
};


export type MutationRemoveTagsFromProfileArgs = {
  input: RemoveTagsFromProfileInput;
};


export type MutationRemoveTriggerFromActionArgs = {
  input: RemoveTriggerFromActionInput;
};


export type MutationRemoveTypesFromTagArgs = {
  input: RemoveTypesFromTagInput;
};


export type MutationReprocessBatchArgs = {
  batch: Scalars['String'];
  send: Scalars['Boolean'];
};


export type MutationReprocessInvoiceArgs = {
  id: Scalars['String'];
};


export type MutationReprocessOrderArgs = {
  id: Scalars['String'];
};


export type MutationReprocessOrderLineArgs = {
  id: Scalars['String'];
};


export type MutationResendVoucherArgs = {
  id: Scalars['String'];
};


export type MutationResetOnePasswordArgs = {
  input: ResetOnePasswordInput;
};


export type MutationSendCustomerCsvArgs = {
  dateRange?: Maybe<Array<Scalars['DateTime']>>;
  emails?: Maybe<Array<Scalars['String']>>;
  isSubscribed: Scalars['Boolean'];
};


export type MutationSendOneBrandVerifyArgs = {
  input: BrandVerifyInput;
};


export type MutationSendOnePasswordForgotArgs = {
  input: SendOnePasswordForgotInput;
};


export type MutationSendVouchersCsvArgs = {
  reason?: Maybe<Scalars['String']>;
};


export type MutationSetAccountGroupsOnMessageCampaignDtoArgs = {
  input: SetAccountGroupsOnMessageCampaignDtoInput;
};


export type MutationSetAccountGroupsOnTriggerArgs = {
  input: SetAccountGroupsOnTriggerInput;
};


export type MutationSetActionsOnTriggerArgs = {
  input: SetActionsOnTriggerInput;
};


export type MutationSetAvatarOnProfileArgs = {
  input: SetAvatarOnProfileInput;
};


export type MutationSetBillingsOnCustomerArgs = {
  input: SetBillingsOnCustomerInput;
};


export type MutationSetCustomerForOrderArgs = {
  input: CreateCustomerInput;
};


export type MutationSetCustomerOnAccountArgs = {
  input: SetCustomerOnAccountInput;
};


export type MutationSetDefaultCardArgs = {
  cardId: Scalars['String'];
};


export type MutationSetExclusionsOnAccountGroupArgs = {
  input: SetExclusionsOnAccountGroupInput;
};


export type MutationSetFeaturedLandscapeOnBrandArgs = {
  input: SetFeaturedLandscapeOnBrandInput;
};


export type MutationSetFeaturedPortraitOnBrandArgs = {
  input: SetFeaturedPortraitOnBrandInput;
};


export type MutationSetImageOnBrandArgs = {
  input: SetImageOnBrandInput;
};


export type MutationSetImageOnProductArgs = {
  input: SetImageOnProductInput;
};


export type MutationSetImageOnTagArgs = {
  input: SetImageOnTagInput;
};


export type MutationSetImagesOnBrandArgs = {
  input: SetImagesOnBrandInput;
};


export type MutationSetImagesOnProductArgs = {
  input: SetImagesOnProductInput;
};


export type MutationSetInclusionsOnAccountGroupArgs = {
  input: SetInclusionsOnAccountGroupInput;
};


export type MutationSetMessageOnActionArgs = {
  input: SetMessageOnActionInput;
};


export type MutationSetMessageOnMessageCampaignDtoArgs = {
  input: SetMessageOnMessageCampaignDtoInput;
};


export type MutationSetOrderBillingAddressArgs = {
  input: OrderAddressInputDto;
};


export type MutationSetOrderShippingAddressArgs = {
  input: OrderAddressInputDto;
};


export type MutationSetProductOnProductVariantArgs = {
  input: SetProductOnProductVariantInput;
};


export type MutationSetProfileOnAccountArgs = {
  input: SetProfileOnAccountInput;
};


export type MutationSetProviderImagesOnProductArgs = {
  input: SetProviderImagesOnProductInput;
};


export type MutationSetShippingMethodArgs = {
  input: OrderShippingMethodInputDto;
};


export type MutationSetShippingsOnCustomerArgs = {
  input: SetShippingsOnCustomerInput;
};


export type MutationSetSizingGuideOnBrandArgs = {
  input: SetSizingGuideOnBrandInput;
};


export type MutationSetSizingGuideOnProductArgs = {
  input: SetSizingGuideOnProductInput;
};


export type MutationSetTagsOnBrandArgs = {
  input: SetTagsOnBrandInput;
};


export type MutationSetTagsOnProductArgs = {
  input: SetTagsOnProductInput;
};


export type MutationSetTagsOnProfileArgs = {
  input: SetTagsOnProfileInput;
};


export type MutationSetTriggerOnActionArgs = {
  input: SetTriggerOnActionInput;
};


export type MutationSetTypesOnTagArgs = {
  input: SetTypesOnTagInput;
};


export type MutationSetUseCreditOnOrderArgs = {
  useCredit: Scalars['Boolean'];
};


export type MutationSetVariantNotificationsArgs = {
  enableNotification: Scalars['Boolean'];
};


export type MutationSubscribeToKlaviyoListArgs = {
  input: SubscribeToKlaviyoListInput;
  listId: Scalars['String'];
};


export type MutationSubscribeToPushArgs = {
  input: PushSubscribeInput;
};


export type MutationSubscribeToVariantArgs = {
  variantId: Scalars['String'];
};


export type MutationSyncOneBrandArgs = {
  input: BrandSyncInput;
};


export type MutationTestBrandWebhookArgs = {
  id: Scalars['String'];
};


export type MutationTriggerEventArgs = {
  accountId: Scalars['String'];
  event: AccountEventType;
  metadata: Scalars['JSON'];
};


export type MutationUnsubscribeAccountArgs = {
  token: Scalars['String'];
};


export type MutationUnsubscribeFromPushArgs = {
  input: PushUnsubscribeInput;
};


export type MutationUpdateAccountGroupUsersArgs = {
  accountGroupId: Scalars['String'];
  action: AccountsAction;
  ids: Array<Scalars['String']>;
};


export type MutationUpdateActionArgs = {
  id: Scalars['ID'];
  input: UpdateActionInput;
};


export type MutationUpdateBrandArgs = {
  id: Scalars['ID'];
  update: BrandsInput;
};


export type MutationUpdateConfigArgs = {
  id: Scalars['String'];
  input: UpdateConfigInput;
};


export type MutationUpdateCustomerAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateEmailTemplateArgs = {
  id: Scalars['String'];
  input: UpdateEmailTemplateInput;
};


export type MutationUpdateLedgerEntryArgs = {
  id: Scalars['String'];
  input: OrderLineLedgerInput;
};


export type MutationUpdateListArgs = {
  input: UpdateListInput;
  listId: Scalars['String'];
};


export type MutationUpdateManyAccountGroupsArgs = {
  input: UpdateManyAccountGroupsInput;
};


export type MutationUpdateManyAccountsArgs = {
  input: UpdateManyAccountsInput;
};


export type MutationUpdateManyAddressesArgs = {
  input: UpdateManyAddressesInput;
};


export type MutationUpdateManyBrandsArgs = {
  input: UpdateManyBrandsInput;
};


export type MutationUpdateManyOptionNamesArgs = {
  input: UpdateManyOptionNamesInput;
};


export type MutationUpdateManyProductOptionsArgs = {
  input: UpdateManyProductOptionsInput;
};


export type MutationUpdateManyProductVariantsArgs = {
  input: UpdateManyProductVariantsInput;
};


export type MutationUpdateManyProductsArgs = {
  input: UpdateManyProductsInput;
};


export type MutationUpdateManySizingGuidesArgs = {
  input: UpdateManySizingGuidesInput;
};


export type MutationUpdateManyTagsArgs = {
  input: UpdateManyTagsInput;
};


export type MutationUpdateManyVouchersArgs = {
  input: UpdateManyVouchersInput;
};


export type MutationUpdateMessageArgs = {
  id: Scalars['String'];
  input: UpdateMessageInput;
};


export type MutationUpdateMessageCampaignArgs = {
  id: Scalars['String'];
  input: UpdateMessageCampaignInput;
};


export type MutationUpdateOneAccountArgs = {
  input: UpdateOneAccountInput;
};


export type MutationUpdateOneAccountGroupArgs = {
  input: UpdateOneAccountGroupInput;
};


export type MutationUpdateOneAddressArgs = {
  input: UpdateOneAddressInput;
};


export type MutationUpdateOneBrandArgs = {
  input: UpdateOneBrandInput;
};


export type MutationUpdateOneBrandVerifyArgs = {
  input: BrandUpdateVerifyInput;
};


export type MutationUpdateOneCustomerArgs = {
  input: UpdateOneCustomerInput;
};


export type MutationUpdateOneLineQuantityArgs = {
  input: ChangeItemInput;
};


export type MutationUpdateOneOptionNameArgs = {
  input: UpdateOneOptionNameInput;
};


export type MutationUpdateOneProductArgs = {
  input: UpdateOneProductInput;
};


export type MutationUpdateOneProductOptionArgs = {
  input: UpdateOneProductOptionInput;
};


export type MutationUpdateOneProductVariantArgs = {
  input: UpdateOneProductVariantInput;
};


export type MutationUpdateOneProfileArgs = {
  input: UpdateOneProfileInput;
};


export type MutationUpdateOneSizingGuideArgs = {
  input: UpdateOneSizingGuideInput;
};


export type MutationUpdateOneTagArgs = {
  input: UpdateOneTagInput;
};


export type MutationUpdateOneVoucherArgs = {
  input: UpdateOneVoucherInput;
};


export type MutationUpdateOrderItemMetaArgs = {
  id: Scalars['String'];
  meta: OrderItemMetaInput;
};


export type MutationUpdateOrderLinePaymentDateArgs = {
  input: OrderLinePaymentDateInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdateShopifyArgs = {
  id: Scalars['String'];
  update: ShopifyUpdate;
};


export type MutationUpdateTriggerArgs = {
  id: Scalars['ID'];
  input: UpdateTriggerInput;
};


export type MutationUploadOneImageArgs = {
  file?: Maybe<Scalars['Upload']>;
  url?: Maybe<Scalars['String']>;
};

export type Notes = {
  __typename: 'Notes';
  alert?: Maybe<Scalars['String']>;
  cart?: Maybe<Scalars['String']>;
  checkout?: Maybe<Scalars['String']>;
  freeShippingThreshold?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  shipping?: Maybe<Scalars['String']>;
};

export type NotesInput = {
  alert?: Maybe<Scalars['String']>;
  cart?: Maybe<Scalars['String']>;
  checkout?: Maybe<Scalars['String']>;
  freeShippingThreshold?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  shipping?: Maybe<Scalars['String']>;
};

export type NumberFieldComparison = {
  between?: Maybe<NumberFieldComparisonBetween>;
  eq?: Maybe<Scalars['Float']>;
  gt?: Maybe<Scalars['Float']>;
  gte?: Maybe<Scalars['Float']>;
  in?: Maybe<Array<Scalars['Float']>>;
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
  lt?: Maybe<Scalars['Float']>;
  lte?: Maybe<Scalars['Float']>;
  neq?: Maybe<Scalars['Float']>;
  notBetween?: Maybe<NumberFieldComparisonBetween>;
  notIn?: Maybe<Array<Scalars['Float']>>;
};

export type NumberFieldComparisonBetween = {
  lower: Scalars['Float'];
  upper: Scalars['Float'];
};

export enum Operator {
  And = 'AND',
  Or = 'OR'
}

export type OptionName = {
  __typename: 'OptionName';
  id: Scalars['String'];
  name: Scalars['String'];
  option: ProductOption;
  providerName: Scalars['String'];
};

export type OptionNameAggregateGroupBy = {
  __typename: 'OptionNameAggregateGroupBy';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OptionNameConnection = {
  __typename: 'OptionNameConnection';
  /** Array of edges. */
  edges: Array<OptionNameEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type OptionNameCountAggregate = {
  __typename: 'OptionNameCountAggregate';
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
};

export type OptionNameEdge = {
  __typename: 'OptionNameEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the OptionName */
  node: OptionName;
};

export type OptionNameFilter = {
  and?: Maybe<Array<OptionNameFilter>>;
  id?: Maybe<StringFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<OptionNameFilter>>;
};

export type OptionNameMaxAggregate = {
  __typename: 'OptionNameMaxAggregate';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OptionNameMinAggregate = {
  __typename: 'OptionNameMinAggregate';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type OptionNameSort = {
  direction: SortDirection;
  field: OptionNameSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum OptionNameSortFields {
  Id = 'id',
  Name = 'name'
}

export type OptionNameUpdateFilter = {
  and?: Maybe<Array<OptionNameUpdateFilter>>;
  id?: Maybe<StringFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<OptionNameUpdateFilter>>;
};

export type OptionNamesInput = {
  name: Scalars['String'];
};

export type OptionProperties = {
  __typename: 'OptionProperties';
  id: Scalars['String'];
  name: Scalars['String'];
  position: Scalars['Float'];
  values: Array<Scalars['String']>;
};

export type Options = {
  __typename: 'Options';
  defaultValue?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  position: Scalars['Float'];
  shouldDisplay: Scalars['Boolean'];
  values: Array<Scalars['String']>;
};

export type Order = {
  __typename: 'Order';
  account?: Maybe<Account>;
  billingAddress?: Maybe<OrderAddress>;
  createdAt: Scalars['DateTime'];
  creditUsed: Scalars['Float'];
  customer?: Maybe<Customer>;
  hasOnlyVouchers: Scalars['Boolean'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  issues: OrderIssues;
  itemCount: Scalars['Int'];
  lineCount: Scalars['Float'];
  lines: Array<OrderLine>;
  metadata: OrderMetadata;
  orderDate?: Maybe<Scalars['DateTime']>;
  orderNumber: Scalars['Float'];
  payments: Array<Payment>;
  previewImages: Array<Scalars['String']>;
  productCount: Scalars['Float'];
  shippingAddress?: Maybe<OrderAddress>;
  status: Scalars['String'];
  subTotal: Scalars['Float'];
  summary: OrderSummary;
  totalPaid: Scalars['Float'];
  updatedAt: Scalars['DateTime'];
  useCredit: Scalars['Boolean'];
};


export type OrderLinesArgs = {
  filter?: OrderLineFilter;
  sorting?: Array<OrderLineSort>;
};


export type OrderPaymentsArgs = {
  filter?: PaymentFilter;
  sorting?: Array<PaymentSort>;
};

export type OrderAddress = {
  __typename: 'OrderAddress';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  province: Scalars['String'];
  shippingEmail?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
};

export type OrderAddressInputDto = {
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  province: Scalars['String'];
  shippingEmail?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
};

export type OrderAggregateGroupBy = {
  __typename: 'OrderAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  orderDate?: Maybe<Scalars['DateTime']>;
  orderNumber?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrderAvgAggregate = {
  __typename: 'OrderAvgAggregate';
  orderNumber?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
};

export type OrderConnection = {
  __typename: 'OrderConnection';
  /** Array of edges. */
  edges: Array<OrderEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type OrderCountAggregate = {
  __typename: 'OrderCountAggregate';
  createdAt?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  isActive?: Maybe<Scalars['Int']>;
  orderDate?: Maybe<Scalars['Int']>;
  orderNumber?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  subTotal?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type OrderEdge = {
  __typename: 'OrderEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Order */
  node: Order;
};

export type OrderFilter = {
  account?: Maybe<OrderFilterAccountFilter>;
  and?: Maybe<Array<OrderFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  customer?: Maybe<OrderFilterCustomerFilter>;
  id?: Maybe<IdFilterComparison>;
  isActive?: Maybe<BooleanFieldComparison>;
  lines?: Maybe<OrderFilterOrderLineFilter>;
  or?: Maybe<Array<OrderFilter>>;
  orderDate?: Maybe<DateFieldComparison>;
  orderNumber?: Maybe<NumberFieldComparison>;
  status?: Maybe<StringFieldComparison>;
  subTotal?: Maybe<FloatFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type OrderFilterAccountFilter = {
  and?: Maybe<Array<OrderFilterAccountFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  email?: Maybe<StringFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  firstName?: Maybe<StringFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  lastName?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<OrderFilterAccountFilter>>;
  status?: Maybe<StringFieldComparison>;
};

export type OrderFilterCustomerFilter = {
  accountId?: Maybe<StringFieldComparison>;
  and?: Maybe<Array<OrderFilterCustomerFilter>>;
  email?: Maybe<StringFieldComparison>;
  firstName?: Maybe<StringFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  lastName?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<OrderFilterCustomerFilter>>;
};

export type OrderFilterOrderLineFilter = {
  and?: Maybe<Array<OrderFilterOrderLineFilter>>;
  brandId?: Maybe<StringFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  or?: Maybe<Array<OrderFilterOrderLineFilter>>;
};

export type OrderIssues = {
  __typename: 'OrderIssues';
  error?: Maybe<Scalars['String']>;
  productErrors?: Maybe<Array<ValidationIssue>>;
};

export type OrderItem = {
  __typename: 'OrderItem';
  id: Scalars['ID'];
  meta?: Maybe<OrderItemMeta>;
  price: Scalars['Float'];
  productVariant: ProductVariant;
  productVariantId: Scalars['String'];
  quantity: Scalars['Int'];
  variantUpdated?: Maybe<Scalars['DateTime']>;
};

export type OrderItemAggregateGroupBy = {
  __typename: 'OrderItemAggregateGroupBy';
  id?: Maybe<Scalars['ID']>;
};

export type OrderItemCountAggregate = {
  __typename: 'OrderItemCountAggregate';
  id?: Maybe<Scalars['Int']>;
};

export type OrderItemDeleteFilter = {
  and?: Maybe<Array<OrderItemDeleteFilter>>;
  id?: Maybe<IdFilterComparison>;
  or?: Maybe<Array<OrderItemDeleteFilter>>;
};

export type OrderItemDeleteResponse = {
  __typename: 'OrderItemDeleteResponse';
  id?: Maybe<Scalars['ID']>;
  meta?: Maybe<OrderItemMeta>;
  price?: Maybe<Scalars['Float']>;
  productVariantId?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  variantUpdated?: Maybe<Scalars['DateTime']>;
};

export type OrderItemEdge = {
  __typename: 'OrderItemEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the OrderItem */
  node: OrderItem;
};

export type OrderItemFilter = {
  and?: Maybe<Array<OrderItemFilter>>;
  id?: Maybe<IdFilterComparison>;
  or?: Maybe<Array<OrderItemFilter>>;
};

export type OrderItemMaxAggregate = {
  __typename: 'OrderItemMaxAggregate';
  id?: Maybe<Scalars['ID']>;
};

export type OrderItemMeta = {
  __typename: 'OrderItemMeta';
  isSendViaEmail: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
};

export type OrderItemMetaInput = {
  isSendViaEmail?: Scalars['Boolean'];
  message?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  senderName?: Maybe<Scalars['String']>;
};

export type OrderItemMinAggregate = {
  __typename: 'OrderItemMinAggregate';
  id?: Maybe<Scalars['ID']>;
};

export type OrderItemSort = {
  direction: SortDirection;
  field: OrderItemSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum OrderItemSortFields {
  Id = 'id'
}

export type OrderLedger = {
  __typename: 'OrderLedger';
  amount: Scalars['Float'];
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCredit?: Maybe<Scalars['Boolean']>;
  isSystem?: Maybe<Scalars['Boolean']>;
};

export type OrderLine = {
  __typename: 'OrderLine';
  brand: Brand;
  brandId: Scalars['String'];
  hasOnlyVouchers: Scalars['Boolean'];
  id: Scalars['ID'];
  invoiceUrl?: Maybe<Scalars['String']>;
  issues: OrderLinesIssues;
  items: Array<OrderItem>;
  ledgerItems: Array<OrderLedger>;
  order: Order;
  orderId: Scalars['String'];
  orderStatus?: Maybe<ShopifyOrder>;
  paymentAdviceUrl?: Maybe<Scalars['String']>;
  paymentDate?: Maybe<Scalars['DateTime']>;
  providerId?: Maybe<Scalars['String']>;
  shippingHandle?: Maybe<Scalars['String']>;
  shippingMethods: Array<OrderLineShippingMethods>;
  shippingTotal?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  subTotal: Scalars['Float'];
};


export type OrderLineItemsArgs = {
  filter?: OrderItemFilter;
  sorting?: Array<OrderItemSort>;
};

export type OrderLineAggregateGroupBy = {
  __typename: 'OrderLineAggregateGroupBy';
  brandId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type OrderLineConnection = {
  __typename: 'OrderLineConnection';
  /** Array of edges. */
  edges: Array<OrderLineEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type OrderLineCountAggregate = {
  __typename: 'OrderLineCountAggregate';
  brandId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
};

export type OrderLineDeleteFilter = {
  and?: Maybe<Array<OrderLineDeleteFilter>>;
  brandId?: Maybe<StringFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  or?: Maybe<Array<OrderLineDeleteFilter>>;
};

export type OrderLineDeleteResponse = {
  __typename: 'OrderLineDeleteResponse';
  brandId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  orderId?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<ShopifyOrder>;
  paymentDate?: Maybe<Scalars['DateTime']>;
  providerId?: Maybe<Scalars['String']>;
  shippingHandle?: Maybe<Scalars['String']>;
  shippingTotal?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['Float']>;
};

export type OrderLineEdge = {
  __typename: 'OrderLineEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the OrderLine */
  node: OrderLine;
};

export type OrderLineFilter = {
  and?: Maybe<Array<OrderLineFilter>>;
  brandId?: Maybe<StringFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  or?: Maybe<Array<OrderLineFilter>>;
};

export type OrderLineLedgerInput = {
  amount: Scalars['Float'];
  codeId: Scalars['Float'];
  description: Scalars['String'];
  isCredit?: Maybe<Scalars['Boolean']>;
};

export type OrderLineMaxAggregate = {
  __typename: 'OrderLineMaxAggregate';
  brandId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type OrderLineMinAggregate = {
  __typename: 'OrderLineMinAggregate';
  brandId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type OrderLinePaymentDateInput = {
  id: Scalars['ID'];
  paymentDate: Scalars['DateTime'];
};

export type OrderLineShippingMethods = {
  __typename: 'OrderLineShippingMethods';
  handle: Scalars['String'];
  price: PriceFormat;
  title: Scalars['String'];
};

export type OrderLineSort = {
  direction: SortDirection;
  field: OrderLineSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum OrderLineSortFields {
  BrandId = 'brandId',
  Id = 'id'
}

export type OrderLinesIssues = {
  __typename: 'OrderLinesIssues';
  error: Scalars['String'];
  productErrors: Array<ProductError>;
};

export type OrderMaxAggregate = {
  __typename: 'OrderMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  orderDate?: Maybe<Scalars['DateTime']>;
  orderNumber?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrderMetaFields = {
  __typename: 'OrderMetaFields';
  os?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
};

export type OrderMetaFieldsInput = {
  os?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
};

export type OrderMetadata = {
  __typename: 'OrderMetadata';
  checkout?: Maybe<OrderMetaFields>;
  create?: Maybe<OrderMetaFields>;
};

export type OrderMetadataInput = {
  checkout?: Maybe<OrderMetaFieldsInput>;
  create?: Maybe<OrderMetaFieldsInput>;
};

export type OrderMinAggregate = {
  __typename: 'OrderMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  orderDate?: Maybe<Scalars['DateTime']>;
  orderNumber?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  subTotal?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type OrderPaymentInput = {
  meta?: Maybe<Scalars['JSON']>;
  method: Scalars['String'];
};

export type OrderShippingMethodInputDto = {
  handle: Scalars['String'];
  lineId: Scalars['String'];
};

export type OrderSort = {
  direction: SortDirection;
  field: OrderSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum OrderSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsActive = 'isActive',
  OrderDate = 'orderDate',
  OrderNumber = 'orderNumber',
  Status = 'status',
  SubTotal = 'subTotal',
  UpdatedAt = 'updatedAt'
}

export type OrderSumAggregate = {
  __typename: 'OrderSumAggregate';
  orderNumber?: Maybe<Scalars['Float']>;
  subTotal?: Maybe<Scalars['Float']>;
};

export type OrderSummary = {
  __typename: 'OrderSummary';
  amountDue: Scalars['Float'];
  creditUsed?: Maybe<Scalars['Float']>;
};

export type PageInfo = {
  __typename: 'PageInfo';
  /** The cursor of the last returned record. */
  endCursor?: Maybe<Scalars['ConnectionCursor']>;
  /** true if paging forward and there are more records. */
  hasNextPage?: Maybe<Scalars['Boolean']>;
  /** true if paging backwards and there are more records. */
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  /** The cursor of the first returned record. */
  startCursor?: Maybe<Scalars['ConnectionCursor']>;
};

export type Payment = {
  __typename: 'Payment';
  amount: Scalars['Float'];
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  method: Scalars['String'];
  order: Order;
  state: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PaymentFilter = {
  and?: Maybe<Array<PaymentFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  method?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<PaymentFilter>>;
  state?: Maybe<StringFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type PaymentSort = {
  direction: SortDirection;
  field: PaymentSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum PaymentSortFields {
  CreatedAt = 'createdAt',
  Method = 'method',
  State = 'state',
  UpdatedAt = 'updatedAt'
}

export type PaymentTerms = {
  __typename: 'PaymentTerms';
  amount: Scalars['String'];
  unit: Scalars['Float'];
};

export type PaymentTermsInput = {
  amount: Scalars['String'];
  unit: Scalars['Float'];
};

export enum Permission {
  Admin = 'Admin',
  Authenticated = 'Authenticated',
  BrandAdmin = 'BrandAdmin',
  FinancialAdmin = 'FinancialAdmin',
  OrderAdmin = 'OrderAdmin',
  Owner = 'Owner',
  ProductAdmin = 'ProductAdmin',
  Public = 'Public',
  SuperAdmin = 'SuperAdmin'
}

export type Policy = {
  __typename: 'Policy';
  body: Scalars['String'];
  created_at: Scalars['String'];
  handle: Scalars['String'];
  updated_at: Scalars['String'];
  url: Scalars['String'];
};

export type PriceFormat = {
  __typename: 'PriceFormat';
  amount: Scalars['String'];
  currencyCode: Scalars['String'];
};

export type Product = {
  __typename: 'Product';
  brand?: Maybe<Brand>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  descriptionHtml: Scalars['String'];
  enabled: Scalars['Boolean'];
  feed?: Maybe<Feed>;
  handle?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  images: Array<Image>;
  isAutoPublish: Scalars['Boolean'];
  isImageContained: Scalars['Boolean'];
  isVoucher: Scalars['Boolean'];
  meta?: Maybe<Meta>;
  minPrice: Scalars['Float'];
  notes?: Maybe<Notes>;
  options: Array<ProductOption>;
  productDescription?: Maybe<Scalars['String']>;
  productTitle?: Maybe<Scalars['String']>;
  properties?: Maybe<Array<Options>>;
  providerDescription?: Maybe<Scalars['String']>;
  providerId: Scalars['String'];
  providerImage?: Maybe<Scalars['String']>;
  providerImages: Array<Image>;
  providerTags?: Maybe<Array<Scalars['String']>>;
  providerTitle: Scalars['String'];
  sizingGuide?: Maybe<SizingGuide>;
  status: Scalars['String'];
  stockStatus: StockStatus;
  story?: Maybe<Story>;
  tags: Array<Tag>;
  title?: Maybe<Scalars['String']>;
  tracksInventory: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  validatedProperties: Array<Options>;
  variants: Array<ProductVariant>;
};


export type ProductImagesArgs = {
  filter?: ImageFilter;
  sorting?: Array<ImageSort>;
};


export type ProductOptionsArgs = {
  filter?: ProductOptionFilter;
  sorting?: Array<ProductOptionSort>;
};


export type ProductProviderImagesArgs = {
  filter?: ImageFilter;
  sorting?: Array<ImageSort>;
};


export type ProductTagsArgs = {
  filter?: TagFilter;
  sorting?: Array<TagSort>;
};


export type ProductVariantsArgs = {
  filter?: ProductVariantFilter;
  sorting?: Array<ProductVariantSort>;
};

export type ProductAggregateGroupBy = {
  __typename: 'ProductAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  providerTitle?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductCardDto = {
  __typename: 'ProductCardDTO';
  brand?: Maybe<Brand>;
  description?: Maybe<Scalars['String']>;
  handle?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Image>;
  isImageContained: Scalars['Boolean'];
  isVoucher: Scalars['Boolean'];
  minPrice?: Maybe<Scalars['Float']>;
  providerTitle: Scalars['String'];
  stockStatus?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<ProductTagDto>>;
  title?: Maybe<Scalars['String']>;
};

export type ProductConnection = {
  __typename: 'ProductConnection';
  /** Array of edges. */
  edges: Array<ProductEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ProductCountAggregate = {
  __typename: 'ProductCountAggregate';
  createdAt?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Int']>;
  handle?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  providerTitle?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type ProductEdge = {
  __typename: 'ProductEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Product */
  node: Product;
};

export type ProductError = {
  __typename: 'ProductError';
  issue: Scalars['String'];
  item: Scalars['String'];
};

export type ProductFilter = {
  and?: Maybe<Array<ProductFilter>>;
  brand?: Maybe<ProductFilterBrandFilter>;
  createdAt?: Maybe<DateFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  handle?: Maybe<StringFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  options?: Maybe<ProductFilterProductOptionFilter>;
  or?: Maybe<Array<ProductFilter>>;
  providerTitle?: Maybe<StringFieldComparison>;
  status?: Maybe<StringFieldComparison>;
  tags?: Maybe<ProductFilterTagFilter>;
  title?: Maybe<StringFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
  variants?: Maybe<ProductFilterProductVariantFilter>;
};

export type ProductFilterBrandFilter = {
  and?: Maybe<Array<ProductFilterBrandFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  currency?: Maybe<StringFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  handle?: Maybe<StringFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  isAllowedStagingSync?: Maybe<BooleanFieldComparison>;
  locale?: Maybe<StringFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<ProductFilterBrandFilter>>;
  providerName?: Maybe<StringFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type ProductFilterProductOptionFilter = {
  and?: Maybe<Array<ProductFilterProductOptionFilter>>;
  id?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<ProductFilterProductOptionFilter>>;
  value?: Maybe<StringFieldComparison>;
};

export type ProductFilterProductVariantFilter = {
  and?: Maybe<Array<ProductFilterProductVariantFilter>>;
  enabled?: Maybe<BooleanFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  inventory?: Maybe<IntFieldComparison>;
  or?: Maybe<Array<ProductFilterProductVariantFilter>>;
  price?: Maybe<FloatFieldComparison>;
  providerTitle?: Maybe<StringFieldComparison>;
  sku?: Maybe<StringFieldComparison>;
  title?: Maybe<StringFieldComparison>;
};

export type ProductFilterTagFilter = {
  and?: Maybe<Array<ProductFilterTagFilter>>;
  category?: Maybe<TagCategoryFilterComparison>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<ProductFilterTagFilter>>;
  topic?: Maybe<BooleanFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type ProductMaxAggregate = {
  __typename: 'ProductMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  providerTitle?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductMinAggregate = {
  __typename: 'ProductMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  handle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  providerTitle?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ProductOption = {
  __typename: 'ProductOption';
  id: Scalars['String'];
  name: OptionName;
  product: Product;
  providerValue: Scalars['String'];
  value: Scalars['String'];
};

export type ProductOptionAggregateGroupBy = {
  __typename: 'ProductOptionAggregateGroupBy';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ProductOptionConnection = {
  __typename: 'ProductOptionConnection';
  /** Array of edges. */
  edges: Array<ProductOptionEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ProductOptionCountAggregate = {
  __typename: 'ProductOptionCountAggregate';
  id?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

export type ProductOptionEdge = {
  __typename: 'ProductOptionEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the ProductOption */
  node: ProductOption;
};

export type ProductOptionFilter = {
  and?: Maybe<Array<ProductOptionFilter>>;
  id?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<ProductOptionFilter>>;
  value?: Maybe<StringFieldComparison>;
};

export type ProductOptionMaxAggregate = {
  __typename: 'ProductOptionMaxAggregate';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ProductOptionMinAggregate = {
  __typename: 'ProductOptionMinAggregate';
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ProductOptionSort = {
  direction: SortDirection;
  field: ProductOptionSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum ProductOptionSortFields {
  Id = 'id',
  Value = 'value'
}

export type ProductOptionUpdateFilter = {
  and?: Maybe<Array<ProductOptionUpdateFilter>>;
  id?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<ProductOptionUpdateFilter>>;
  value?: Maybe<StringFieldComparison>;
};

export type ProductOptionsInput = {
  value: Scalars['String'];
};

export type ProductSort = {
  direction: SortDirection;
  field: ProductSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum ProductSortFields {
  CreatedAt = 'createdAt',
  Enabled = 'enabled',
  Handle = 'handle',
  Id = 'id',
  ProviderTitle = 'providerTitle',
  Status = 'status',
  Title = 'title',
  UpdatedAt = 'updatedAt'
}

export type ProductStat = {
  __typename: 'ProductStat';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type ProductTagDto = {
  __typename: 'ProductTagDto';
  category: Scalars['String'];
  name: Scalars['String'];
};

export type ProductUpdate = {
  __typename: 'ProductUpdate';
  itemId: Scalars['String'];
  newPrice: Scalars['String'];
  oldPrice: Scalars['String'];
  productName: Scalars['String'];
};

export type ProductUpdateFilter = {
  and?: Maybe<Array<ProductUpdateFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  handle?: Maybe<StringFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  or?: Maybe<Array<ProductUpdateFilter>>;
  providerTitle?: Maybe<StringFieldComparison>;
  status?: Maybe<StringFieldComparison>;
  title?: Maybe<StringFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type ProductVariant = {
  __typename: 'ProductVariant';
  createdAt: Scalars['DateTime'];
  enabled: Scalars['Boolean'];
  id: Scalars['String'];
  images?: Maybe<Array<Image>>;
  inventory: Scalars['Int'];
  inventoryPolicy: InventoryPolicy;
  option1: Scalars['String'];
  option2: Scalars['String'];
  option3: Scalars['String'];
  price: Scalars['Float'];
  product?: Maybe<Product>;
  providerId: Scalars['String'];
  providerTitle: Scalars['String'];
  selectedOption: Array<Scalars['String']>;
  selectedOptions: Array<ProductVariantOptionsDto>;
  sku?: Maybe<Scalars['String']>;
  stockStatus: StockStatus;
  title: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ProductVariantAggregateGroupBy = {
  __typename: 'ProductVariantAggregateGroupBy';
  enabled?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  inventory?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  providerTitle?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ProductVariantAvgAggregate = {
  __typename: 'ProductVariantAvgAggregate';
  inventory?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

export type ProductVariantConnection = {
  __typename: 'ProductVariantConnection';
  /** Array of edges. */
  edges: Array<ProductVariantEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ProductVariantCountAggregate = {
  __typename: 'ProductVariantCountAggregate';
  enabled?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  inventory?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Int']>;
  providerTitle?: Maybe<Scalars['Int']>;
  sku?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['Int']>;
};

export type ProductVariantEdge = {
  __typename: 'ProductVariantEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the ProductVariant */
  node: ProductVariant;
};

export type ProductVariantFilter = {
  and?: Maybe<Array<ProductVariantFilter>>;
  enabled?: Maybe<BooleanFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  inventory?: Maybe<IntFieldComparison>;
  or?: Maybe<Array<ProductVariantFilter>>;
  price?: Maybe<FloatFieldComparison>;
  providerTitle?: Maybe<StringFieldComparison>;
  sku?: Maybe<StringFieldComparison>;
  title?: Maybe<StringFieldComparison>;
};

export type ProductVariantMaxAggregate = {
  __typename: 'ProductVariantMaxAggregate';
  id?: Maybe<Scalars['String']>;
  inventory?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  providerTitle?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ProductVariantMinAggregate = {
  __typename: 'ProductVariantMinAggregate';
  id?: Maybe<Scalars['String']>;
  inventory?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  providerTitle?: Maybe<Scalars['String']>;
  sku?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type ProductVariantOptionsDto = {
  __typename: 'ProductVariantOptionsDTO';
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type ProductVariantSort = {
  direction: SortDirection;
  field: ProductVariantSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum ProductVariantSortFields {
  Enabled = 'enabled',
  Id = 'id',
  Inventory = 'inventory',
  Price = 'price',
  ProviderTitle = 'providerTitle',
  Sku = 'sku',
  Title = 'title'
}

export type ProductVariantSubscription = {
  __typename: 'ProductVariantSubscription';
  account: Account;
  id: Scalars['String'];
  variant: ProductVariant;
};

export type ProductVariantSumAggregate = {
  __typename: 'ProductVariantSumAggregate';
  inventory?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
};

export type ProductVariantUpdateFilter = {
  and?: Maybe<Array<ProductVariantUpdateFilter>>;
  enabled?: Maybe<BooleanFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  inventory?: Maybe<IntFieldComparison>;
  or?: Maybe<Array<ProductVariantUpdateFilter>>;
  price?: Maybe<FloatFieldComparison>;
  providerTitle?: Maybe<StringFieldComparison>;
  sku?: Maybe<StringFieldComparison>;
  title?: Maybe<StringFieldComparison>;
};

export type ProductVariantsInput = {
  title: Scalars['String'];
};

export type ProductsInput = {
  description?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  imageId?: Maybe<Scalars['String']>;
  isAutoPublish?: Maybe<Scalars['Boolean']>;
  isImageContained?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<MetaInput>;
  notes?: Maybe<NotesInput>;
  sizingGuideId?: Maybe<Scalars['String']>;
  tagIds?: Maybe<Array<Scalars['String']>>;
  title?: Maybe<Scalars['String']>;
};

export type Profile = {
  __typename: 'Profile';
  accountId: Scalars['String'];
  appVersion?: Maybe<Scalars['String']>;
  avatar: Image;
  dob?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  gender: Gender;
  id: Scalars['String'];
  isNewsletterEnabled: Scalars['Boolean'];
  isNotificationsEnabled: Scalars['Boolean'];
  isPromoEmailsEnabled: Scalars['Boolean'];
  lastName: Scalars['String'];
  mobile?: Maybe<Scalars['String']>;
  tags: Array<Tag>;
};


export type ProfileTagsArgs = {
  filter?: TagFilter;
  sorting?: Array<TagSort>;
};

export type ProfileAggregateGroupBy = {
  __typename: 'ProfileAggregateGroupBy';
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type ProfileConnection = {
  __typename: 'ProfileConnection';
  /** Array of edges. */
  edges: Array<ProfileEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type ProfileCountAggregate = {
  __typename: 'ProfileCountAggregate';
  firstName?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  lastName?: Maybe<Scalars['Int']>;
};

export type ProfileEdge = {
  __typename: 'ProfileEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Profile */
  node: Profile;
};

export type ProfileFilter = {
  and?: Maybe<Array<ProfileFilter>>;
  firstName?: Maybe<StringFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  lastName?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<ProfileFilter>>;
};

export type ProfileMaxAggregate = {
  __typename: 'ProfileMaxAggregate';
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type ProfileMinAggregate = {
  __typename: 'ProfileMinAggregate';
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type ProfileSort = {
  direction: SortDirection;
  field: ProfileSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum ProfileSortFields {
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName'
}

export type ProfilesCreateInput = {
  dob?: Maybe<Scalars['DateTime']>;
  firstName: Scalars['String'];
  gender?: Maybe<Gender>;
  lastName: Scalars['String'];
  mobile?: Maybe<Scalars['String']>;
};

export type ProfilesUpdateInput = {
  appVersion?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  firstName?: Maybe<Scalars['String']>;
  gender?: Maybe<Gender>;
  isNewsletterEnabled?: Maybe<Scalars['Boolean']>;
  isNotificationsEnabled?: Maybe<Scalars['Boolean']>;
  isPromoEmailsEnabled?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
  pushNotificationToken?: Maybe<Scalars['String']>;
};

export type PushSubscribeInput = {
  auth: Scalars['String'];
  endpoint: Scalars['String'];
  p256dh: Scalars['String'];
  userAgent?: Maybe<Scalars['String']>;
};

export type PushUnsubscribeInput = {
  endpoint: Scalars['String'];
};

export type Query = {
  __typename: 'Query';
  account?: Maybe<Account>;
  accountCards: Array<AccountCard>;
  accountEventOptions: Scalars['JSON'];
  accountGroup?: Maybe<AccountGroup>;
  accountGroupConfig: AccountGroupConfigDto;
  accountGroups: AccountGroupConnection;
  accountingCodes: Array<AccountCode>;
  accounts: AccountConnection;
  action?: Maybe<Action>;
  actionTypeOptions: Scalars['JSON'];
  actions: ActionConnection;
  activeCustomer?: Maybe<CustomerEntity>;
  activeOrder: Order;
  activeProductCount: Scalars['Int'];
  address?: Maybe<Address>;
  addresses: AddressConnection;
  allAccountGroups: Array<AccountGroup>;
  allBrands: Array<Brand>;
  allMessageCampaigns: Array<MessageCampaign>;
  allMessages: Array<Message>;
  allProducts: Array<Product>;
  allTags: Array<Tag>;
  appConfig: Array<ConfigDto>;
  brand?: Maybe<Brand>;
  brandProductSortOptions: Array<BrandProductSortOption>;
  brands: BrandConnection;
  cart?: Maybe<Order>;
  cartCount: Scalars['Int'];
  componentEntities: ComponentEntityConnection;
  configValue: ConfigDto;
  customer?: Maybe<Customer>;
  customerOrder: Order;
  emailTemplate: EmailTemplate;
  emailTemplates: Array<EmailTemplate>;
  feed: Feed;
  getAccountGroupAccountIds: Array<Scalars['String']>;
  getAccountGroupAccounts: AccountGroupAccountConnection;
  getEntityList?: Maybe<Scalars['String']>;
  getList: List;
  getListByCode: List;
  getLists: Array<List>;
  getUsersByPermission: Array<Account>;
  me?: Maybe<Account>;
  message?: Maybe<Message>;
  messageCampaign?: Maybe<MessageCampaignDto>;
  messageCampaigns: MessageCampaignDtoConnection;
  messageChannels: Scalars['JSON'];
  messages: MessageConnection;
  optionName?: Maybe<OptionName>;
  optionNames: OptionNameConnection;
  order?: Maybe<Order>;
  orderLine?: Maybe<OrderLine>;
  orderLines: OrderLineConnection;
  orders: OrderConnection;
  permissions: Array<AccountPermissionDto>;
  ping: Scalars['String'];
  policies: Array<Policy>;
  product?: Maybe<Product>;
  productOption?: Maybe<ProductOption>;
  productOptions: ProductOptionConnection;
  productStats: Array<ProductStat>;
  productVariant?: Maybe<ProductVariant>;
  productVariants: ProductVariantConnection;
  products: ProductConnection;
  profile?: Maybe<Profile>;
  profiles: ProfileConnection;
  refreshToken: AuthTokens;
  refund?: Maybe<Refund>;
  refunds: RefundConnection;
  relatedProducts: Array<Product>;
  searchBrands: Array<Brand>;
  searchFeeds: Array<Feed>;
  searchProducts: Array<ProductCardDto>;
  searchStories: Array<Story>;
  sizingGuide?: Maybe<SizingGuide>;
  sizingGuides: SizingGuideConnection;
  statistics: Statistics;
  story: Story;
  tag?: Maybe<Tag>;
  tagCategories: Array<TagCategoryDto>;
  tagType?: Maybe<TagType>;
  tagTypes: TagTypeConnection;
  tags: TagConnection;
  testMessage: Scalars['Boolean'];
  testVariantUpdate: Scalars['Boolean'];
  trigger?: Maybe<Trigger>;
  triggers: TriggerConnection;
  variantSubscriptions: Array<ProductVariantSubscription>;
  voucher?: Maybe<Voucher>;
  voucherReasons: Array<Scalars['String']>;
  voucherStats: VoucherStats;
  vouchers: VoucherConnection;
};


export type QueryAccountArgs = {
  id: Scalars['ID'];
};


export type QueryAccountGroupArgs = {
  id: Scalars['ID'];
};


export type QueryAccountGroupsArgs = {
  filter?: AccountGroupFilter;
  paging?: CursorPaging;
  sorting?: Array<AccountGroupSort>;
};


export type QueryAccountsArgs = {
  filter?: AccountFilter;
  paging?: CursorPaging;
  sorting?: Array<AccountSort>;
};


export type QueryActionArgs = {
  id: Scalars['ID'];
};


export type QueryActionsArgs = {
  filter?: ActionFilter;
  paging?: CursorPaging;
  sorting?: Array<ActionSort>;
};


export type QueryActiveProductCountArgs = {
  feature?: Maybe<Scalars['String']>;
};


export type QueryAddressArgs = {
  id: Scalars['ID'];
};


export type QueryAddressesArgs = {
  filter?: AddressFilter;
  paging?: CursorPaging;
  sorting?: Array<AddressSort>;
};


export type QueryAllProductsArgs = {
  filter?: ProductFilter;
  paging?: CursorPaging;
  sorting?: Array<ProductSort>;
};


export type QueryAllTagsArgs = {
  type?: Maybe<TagTypeEnum>;
};


export type QueryBrandArgs = {
  id: Scalars['ID'];
};


export type QueryBrandsArgs = {
  filter?: BrandFilter;
  paging?: CursorPaging;
  sorting?: Array<BrandSort>;
};


export type QueryComponentEntitiesArgs = {
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  last?: Maybe<Scalars['Int']>;
};


export type QueryConfigValueArgs = {
  name: Scalars['String'];
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryCustomerOrderArgs = {
  id: Scalars['String'];
};


export type QueryEmailTemplateArgs = {
  id: Scalars['String'];
};


export type QueryFeedArgs = {
  id: Scalars['String'];
};


export type QueryGetAccountGroupAccountIdsArgs = {
  accountGroupIds: Array<Scalars['String']>;
  operator?: Maybe<Operator>;
};


export type QueryGetAccountGroupAccountsArgs = {
  accountGroupIds: Array<Scalars['String']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  operator?: Maybe<Operator>;
};


export type QueryGetEntityListArgs = {
  input: AddToListInput;
};


export type QueryGetListArgs = {
  listId: Scalars['String'];
};


export type QueryGetListByCodeArgs = {
  code: Scalars['String'];
};


export type QueryGetListsArgs = {
  type: ListType;
};


export type QueryGetUsersByPermissionArgs = {
  permission: Permission;
};


export type QueryMessageArgs = {
  id: Scalars['ID'];
};


export type QueryMessageCampaignArgs = {
  id: Scalars['ID'];
};


export type QueryMessageCampaignsArgs = {
  filter?: MessageCampaignDtoFilter;
  paging?: CursorPaging;
  sorting?: Array<MessageCampaignDtoSort>;
};


export type QueryMessagesArgs = {
  filter?: MessageFilter;
  paging?: CursorPaging;
  sorting?: Array<MessageSort>;
};


export type QueryOptionNameArgs = {
  id: Scalars['ID'];
};


export type QueryOptionNamesArgs = {
  filter?: OptionNameFilter;
  paging?: CursorPaging;
  sorting?: Array<OptionNameSort>;
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
};


export type QueryOrderLineArgs = {
  id: Scalars['ID'];
};


export type QueryOrderLinesArgs = {
  filter?: OrderLineFilter;
  paging?: CursorPaging;
  sorting?: Array<OrderLineSort>;
};


export type QueryOrdersArgs = {
  filter?: OrderFilter;
  paging?: CursorPaging;
  sorting?: Array<OrderSort>;
};


export type QueryPoliciesArgs = {
  input: BrandSyncInput;
};


export type QueryProductArgs = {
  id: Scalars['ID'];
};


export type QueryProductOptionArgs = {
  id: Scalars['ID'];
};


export type QueryProductOptionsArgs = {
  filter?: ProductOptionFilter;
  paging?: CursorPaging;
  sorting?: Array<ProductOptionSort>;
};


export type QueryProductVariantArgs = {
  id: Scalars['ID'];
};


export type QueryProductVariantsArgs = {
  filter?: ProductVariantFilter;
  paging?: CursorPaging;
  sorting?: Array<ProductVariantSort>;
};


export type QueryProductsArgs = {
  filter?: ProductFilter;
  paging?: CursorPaging;
  sorting?: Array<ProductSort>;
};


export type QueryProfileArgs = {
  id: Scalars['ID'];
};


export type QueryProfilesArgs = {
  filter?: ProfileFilter;
  paging?: CursorPaging;
  sorting?: Array<ProfileSort>;
};


export type QueryRefreshTokenArgs = {
  token: Scalars['String'];
};


export type QueryRefundArgs = {
  id: Scalars['ID'];
};


export type QueryRefundsArgs = {
  filter?: RefundFilter;
  paging?: CursorPaging;
  sorting?: Array<RefundSort>;
};


export type QueryRelatedProductsArgs = {
  brandName: Scalars['String'];
  limit: Scalars['Float'];
  productId: Scalars['String'];
};


export type QuerySearchBrandsArgs = {
  input: SearchBrandIndexDto;
};


export type QuerySearchFeedsArgs = {
  input: SearchFeedsDto;
};


export type QuerySearchProductsArgs = {
  input: SearchProductIndexDto;
};


export type QuerySearchStoriesArgs = {
  input: SearchStoriesDto;
};


export type QuerySizingGuideArgs = {
  id: Scalars['ID'];
};


export type QuerySizingGuidesArgs = {
  filter?: SizingGuideFilter;
  paging?: CursorPaging;
  sorting?: Array<SizingGuideSort>;
};


export type QueryStoryArgs = {
  id: Scalars['String'];
};


export type QueryTagArgs = {
  id: Scalars['ID'];
};


export type QueryTagTypeArgs = {
  id: Scalars['ID'];
};


export type QueryTagTypesArgs = {
  filter?: TagTypeFilter;
  paging?: CursorPaging;
  sorting?: Array<TagTypeSort>;
};


export type QueryTagsArgs = {
  filter?: TagFilter;
  paging?: CursorPaging;
  sorting?: Array<TagSort>;
};


export type QueryTriggerArgs = {
  id: Scalars['ID'];
};


export type QueryTriggersArgs = {
  filter?: TriggerFilter;
  paging?: CursorPaging;
  sorting?: Array<TriggerSort>;
};


export type QueryVoucherArgs = {
  id: Scalars['ID'];
};


export type QueryVouchersArgs = {
  filter?: VoucherFilter;
  paging?: CursorPaging;
  sorting?: Array<VoucherSort>;
};

export enum QueryOperator {
  And = 'AND',
  Custom = 'CUSTOM',
  Or = 'OR'
}

export type RedeemVoucherResponse = {
  __typename: 'RedeemVoucherResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Refund = {
  __typename: 'Refund';
  adjustmentAmount?: Maybe<Scalars['Float']>;
  basketAmount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  orderLine?: Maybe<OrderLine>;
  state: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type RefundAggregateGroupBy = {
  __typename: 'RefundAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RefundConnection = {
  __typename: 'RefundConnection';
  /** Array of edges. */
  edges: Array<RefundEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type RefundCountAggregate = {
  __typename: 'RefundCountAggregate';
  createdAt?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type RefundDeleteFilter = {
  and?: Maybe<Array<RefundDeleteFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  or?: Maybe<Array<RefundDeleteFilter>>;
  state?: Maybe<StringFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type RefundDeleteResponse = {
  __typename: 'RefundDeleteResponse';
  adjustmentAmount?: Maybe<Scalars['Float']>;
  basketAmount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  note?: Maybe<Scalars['String']>;
  orderLine?: Maybe<OrderLine>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RefundEdge = {
  __typename: 'RefundEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Refund */
  node: Refund;
};

export type RefundFilter = {
  and?: Maybe<Array<RefundFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  or?: Maybe<Array<RefundFilter>>;
  orderLine?: Maybe<RefundFilterOrderLineFilter>;
  state?: Maybe<StringFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type RefundFilterOrderLineFilter = {
  and?: Maybe<Array<RefundFilterOrderLineFilter>>;
  brandId?: Maybe<StringFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  or?: Maybe<Array<RefundFilterOrderLineFilter>>;
};

export type RefundMaxAggregate = {
  __typename: 'RefundMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RefundMinAggregate = {
  __typename: 'RefundMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RefundSort = {
  direction: SortDirection;
  field: RefundSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum RefundSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  State = 'state',
  UpdatedAt = 'updatedAt'
}

export type RegisterCustomerInput = {
  email: Scalars['String'];
  firstName: Scalars['String'];
  interests?: Maybe<Array<Scalars['String']>>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  lastName: Scalars['String'];
  password: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  platform?: Maybe<Scalars['String']>;
};

export type RelayPageInfo = {
  __typename: 'RelayPageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  startCursor?: Maybe<Scalars['String']>;
};

export type RemoveAccountGroupsFromMessageCampaignDtoInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveAccountGroupsFromTriggerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveActionsFromTriggerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveAvatarFromProfileInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveBillingsFromCustomerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveCustomerFromAccountInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveExclusionsFromAccountGroupInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveFeaturedLandscapeFromBrandInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveFeaturedPortraitFromBrandInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveImageFromBrandInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveImageFromProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveImageFromTagInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveImagesFromProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveInclusionsFromAccountGroupInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveItemInput = {
  lineId: Scalars['String'];
  productVariantId: Scalars['String'];
};

export type RemoveMessageFromActionInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveMessageFromMessageCampaignDtoInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveProductFromProductVariantInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveProfileFromAccountInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveProviderImagesFromProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveShippingsFromCustomerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveSizingGuideFromBrandInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveSizingGuideFromProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveTagsFromBrandInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveTagsFromProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveTagsFromProducts = {
  productIds: Array<Scalars['String']>;
  tagIds: Array<Scalars['String']>;
};

export type RemoveTagsFromProfileInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type RemoveTriggerFromActionInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type RemoveTypesFromTagInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type ResetOnePasswordInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export enum ResizeMode {
  Contain = 'contain',
  Cover = 'cover'
}

export type SalesStatistics = {
  __typename: 'SalesStatistics';
  activeCarts: CartStatistics;
  completedOrders: CartStatistics;
  revenue: Scalars['Float'];
  rollingSum: Array<DataPoint>;
  salesPerDay: Scalars['Float'];
  salesPerUser: Scalars['Float'];
  topBrands: Array<TopBrands>;
  topProducts: Array<TopProducts>;
};

export type SearchBrandIndexDto = {
  brands: Array<Scalars['String']>;
  exclusions: Array<Scalars['String']>;
  ids: Array<Scalars['String']>;
  operator: QueryOperator;
  query: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type SearchFeedsDto = {
  exclusions: Array<Scalars['String']>;
  ids: Array<Scalars['String']>;
  operator: QueryOperator;
  query: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type SearchProductIndexDto = {
  brands: Array<Scalars['String']>;
  exclusions: Array<Scalars['String']>;
  ids: Array<Scalars['String']>;
  limit?: Maybe<Scalars['Float']>;
  operator: QueryOperator;
  query: Scalars['String'];
  queryId?: Maybe<Scalars['String']>;
  tags: Array<Scalars['String']>;
};

export type SearchStoriesDto = {
  exclusions: Array<Scalars['String']>;
  ids: Array<Scalars['String']>;
  operator: QueryOperator;
  query: Scalars['String'];
  tags: Array<Scalars['String']>;
};

export type SendOnePasswordForgotInput = {
  email: Scalars['String'];
};

export type SetAccountGroupsOnMessageCampaignDtoInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetAccountGroupsOnTriggerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetActionsOnTriggerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetAvatarOnProfileInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetBillingsOnCustomerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetCustomerOnAccountInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetExclusionsOnAccountGroupInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetFeaturedLandscapeOnBrandInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetFeaturedPortraitOnBrandInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetImageOnBrandInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetImageOnProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetImageOnTagInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetImagesOnBrandInput = {
  id: Scalars['ID'];
  relationIds: Array<Scalars['ID']>;
};

export type SetImagesOnProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetInclusionsOnAccountGroupInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetMessageOnActionInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetMessageOnMessageCampaignDtoInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetProductOnProductVariantInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetProfileOnAccountInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetProviderImagesOnProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetShippingsOnCustomerInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetSizingGuideOnBrandInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetSizingGuideOnProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetTagsOnBrandInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetTagsOnProductInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetTagsOnProfileInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type SetTriggerOnActionInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The id of relation. */
  relationId: Scalars['ID'];
};

export type SetTypesOnTagInput = {
  /** The id of the record. */
  id: Scalars['ID'];
  /** The ids of the relations. */
  relationIds: Array<Scalars['ID']>;
};

export type Shopify = {
  __typename: 'Shopify';
  appId?: Maybe<Scalars['String']>;
  brand: Brand;
  domain: Scalars['String'];
  id: Scalars['String'];
};

export type ShopifyAggregateGroupBy = {
  __typename: 'ShopifyAggregateGroupBy';
  domain?: Maybe<Scalars['String']>;
};

export type ShopifyCountAggregate = {
  __typename: 'ShopifyCountAggregate';
  domain?: Maybe<Scalars['Int']>;
};

export type ShopifyEdge = {
  __typename: 'ShopifyEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Shopify */
  node: Shopify;
};

export type ShopifyMaxAggregate = {
  __typename: 'ShopifyMaxAggregate';
  domain?: Maybe<Scalars['String']>;
};

export type ShopifyMinAggregate = {
  __typename: 'ShopifyMinAggregate';
  domain?: Maybe<Scalars['String']>;
};

export type ShopifyOrder = {
  __typename: 'ShopifyOrder';
  confirmed?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  orderReference?: Maybe<Scalars['String']>;
  shippingStatus: Scalars['String'];
  status?: Maybe<Scalars['String']>;
};

export type ShopifyUpdate = {
  domain?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  secret?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type SizingGuide = {
  __typename: 'SizingGuide';
  content?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type SizingGuideAggregateGroupBy = {
  __typename: 'SizingGuideAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SizingGuideConnection = {
  __typename: 'SizingGuideConnection';
  /** Array of edges. */
  edges: Array<SizingGuideEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type SizingGuideCountAggregate = {
  __typename: 'SizingGuideCountAggregate';
  createdAt?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type SizingGuideDeleteFilter = {
  and?: Maybe<Array<SizingGuideDeleteFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<SizingGuideDeleteFilter>>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type SizingGuideDeleteResponse = {
  __typename: 'SizingGuideDeleteResponse';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SizingGuideEdge = {
  __typename: 'SizingGuideEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the SizingGuide */
  node: SizingGuide;
};

export type SizingGuideFilter = {
  and?: Maybe<Array<SizingGuideFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<SizingGuideFilter>>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type SizingGuideMaxAggregate = {
  __typename: 'SizingGuideMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SizingGuideMinAggregate = {
  __typename: 'SizingGuideMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SizingGuideSort = {
  direction: SortDirection;
  field: SizingGuideSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum SizingGuideSortFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type SizingGuideUpdateFilter = {
  and?: Maybe<Array<SizingGuideUpdateFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<SizingGuideUpdateFilter>>;
  updatedAt?: Maybe<DateFieldComparison>;
};

/** Sort Directions */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Sort Nulls Options */
export enum SortNulls {
  NullsFirst = 'NULLS_FIRST',
  NullsLast = 'NULLS_LAST'
}

export type Statistics = {
  __typename: 'Statistics';
  brandSales: Array<BrandSales>;
  sales: SalesStatistics;
  users: UserStatistics;
};


export type StatisticsBrandSalesArgs = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
};

export type Story = {
  __typename: 'Story';
  author?: Maybe<Scalars['JSON']>;
  content?: Maybe<Scalars['JSON']>;
  headline?: Maybe<Scalars['String']>;
  hero?: Maybe<Scalars['JSON']>;
  id: Scalars['ID'];
  landscapeThumbnail?: Maybe<Scalars['String']>;
  links: Array<ContentfulComponent>;
  name: Scalars['String'];
  storyId: Scalars['String'];
  summary?: Maybe<Scalars['String']>;
  thumbnail?: Maybe<Scalars['String']>;
};

export type StringFieldComparison = {
  eq?: Maybe<Scalars['String']>;
  gt?: Maybe<Scalars['String']>;
  gte?: Maybe<Scalars['String']>;
  iLike?: Maybe<Scalars['String']>;
  in?: Maybe<Array<Scalars['String']>>;
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
  like?: Maybe<Scalars['String']>;
  lt?: Maybe<Scalars['String']>;
  lte?: Maybe<Scalars['String']>;
  neq?: Maybe<Scalars['String']>;
  notILike?: Maybe<Scalars['String']>;
  notIn?: Maybe<Array<Scalars['String']>>;
  notLike?: Maybe<Scalars['String']>;
};

export type SubscribeToKlaviyoListInput = {
  birthday?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  first_name?: Maybe<Scalars['String']>;
  last_name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
};

export type SubscribeToKlaviyoListResponse = {
  __typename: 'SubscribeToKlaviyoListResponse';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type SuccessResponse = {
  __typename: 'SuccessResponse';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type Tag = {
  __typename: 'Tag';
  category?: Maybe<TagCategory>;
  categoryLabel?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Image>;
  meta?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  topic?: Maybe<Scalars['Boolean']>;
  types: Array<TagType>;
  updatedAt: Scalars['DateTime'];
};


export type TagTypesArgs = {
  filter?: TagTypeFilter;
  sorting?: Array<TagTypeSort>;
};

export type TagAggregateGroupBy = {
  __typename: 'TagAggregateGroupBy';
  category?: Maybe<TagCategory>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['Boolean']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum TagCategory {
  Admin = 'ADMIN',
  Brand = 'BRAND',
  Collection = 'COLLECTION',
  Color = 'COLOR',
  Editorial = 'EDITORIAL',
  Feature = 'FEATURE',
  Material = 'MATERIAL',
  Occasion = 'OCCASION',
  PriceRange = 'PRICE_RANGE',
  ProductType = 'PRODUCT_TYPE',
  Size = 'SIZE',
  Style = 'STYLE'
}

export type TagCategoryDto = {
  __typename: 'TagCategoryDTO';
  name: TagCategory;
  title: Scalars['String'];
};

export type TagCategoryFilterComparison = {
  eq?: Maybe<TagCategory>;
  gt?: Maybe<TagCategory>;
  gte?: Maybe<TagCategory>;
  iLike?: Maybe<TagCategory>;
  in?: Maybe<Array<TagCategory>>;
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
  like?: Maybe<TagCategory>;
  lt?: Maybe<TagCategory>;
  lte?: Maybe<TagCategory>;
  neq?: Maybe<TagCategory>;
  notILike?: Maybe<TagCategory>;
  notIn?: Maybe<Array<TagCategory>>;
  notLike?: Maybe<TagCategory>;
};

export type TagConnection = {
  __typename: 'TagConnection';
  /** Array of edges. */
  edges: Array<TagEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type TagCountAggregate = {
  __typename: 'TagCountAggregate';
  category?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  topic?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type TagDeleteFilter = {
  and?: Maybe<Array<TagDeleteFilter>>;
  category?: Maybe<TagCategoryFilterComparison>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<TagDeleteFilter>>;
  topic?: Maybe<BooleanFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type TagDeleteResponse = {
  __typename: 'TagDeleteResponse';
  category?: Maybe<TagCategory>;
  categoryLabel?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Image>;
  meta?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['Boolean']>;
  types?: Maybe<Array<TagType>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TagEdge = {
  __typename: 'TagEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Tag */
  node: Tag;
};

export type TagFilter = {
  and?: Maybe<Array<TagFilter>>;
  category?: Maybe<TagCategoryFilterComparison>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<TagFilter>>;
  topic?: Maybe<BooleanFieldComparison>;
  types?: Maybe<TagFilterTagTypeFilter>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type TagFilterTagTypeFilter = {
  and?: Maybe<Array<TagFilterTagTypeFilter>>;
  name?: Maybe<TagTypeEnumFilterComparison>;
  or?: Maybe<Array<TagFilterTagTypeFilter>>;
};

export type TagMaxAggregate = {
  __typename: 'TagMaxAggregate';
  category?: Maybe<TagCategory>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TagMinAggregate = {
  __typename: 'TagMinAggregate';
  category?: Maybe<TagCategory>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TagSort = {
  direction: SortDirection;
  field: TagSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum TagSortFields {
  Category = 'category',
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  Topic = 'topic',
  UpdatedAt = 'updatedAt'
}

export type TagType = {
  __typename: 'TagType';
  name: TagTypeEnum;
};

export type TagTypeAggregateGroupBy = {
  __typename: 'TagTypeAggregateGroupBy';
  name?: Maybe<TagTypeEnum>;
};

export type TagTypeConnection = {
  __typename: 'TagTypeConnection';
  /** Array of edges. */
  edges: Array<TagTypeEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type TagTypeCountAggregate = {
  __typename: 'TagTypeCountAggregate';
  name?: Maybe<Scalars['Int']>;
};

export type TagTypeEdge = {
  __typename: 'TagTypeEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the TagType */
  node: TagType;
};

/** A tag used to identify what entities are able to use this tag. */
export enum TagTypeEnum {
  Brand = 'Brand',
  Product = 'Product',
  Story = 'Story'
}

export type TagTypeEnumFilterComparison = {
  eq?: Maybe<TagTypeEnum>;
  gt?: Maybe<TagTypeEnum>;
  gte?: Maybe<TagTypeEnum>;
  iLike?: Maybe<TagTypeEnum>;
  in?: Maybe<Array<TagTypeEnum>>;
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
  like?: Maybe<TagTypeEnum>;
  lt?: Maybe<TagTypeEnum>;
  lte?: Maybe<TagTypeEnum>;
  neq?: Maybe<TagTypeEnum>;
  notILike?: Maybe<TagTypeEnum>;
  notIn?: Maybe<Array<TagTypeEnum>>;
  notLike?: Maybe<TagTypeEnum>;
};

export type TagTypeFilter = {
  and?: Maybe<Array<TagTypeFilter>>;
  name?: Maybe<TagTypeEnumFilterComparison>;
  or?: Maybe<Array<TagTypeFilter>>;
};

export type TagTypeInput = {
  name: TagTypeEnum;
};

export type TagTypeMaxAggregate = {
  __typename: 'TagTypeMaxAggregate';
  name?: Maybe<TagTypeEnum>;
};

export type TagTypeMinAggregate = {
  __typename: 'TagTypeMinAggregate';
  name?: Maybe<TagTypeEnum>;
};

export type TagTypeSort = {
  direction: SortDirection;
  field: TagTypeSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum TagTypeSortFields {
  Name = 'name'
}

export type TagUpdateFilter = {
  and?: Maybe<Array<TagUpdateFilter>>;
  category?: Maybe<TagCategoryFilterComparison>;
  createdAt?: Maybe<DateFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<TagUpdateFilter>>;
  topic?: Maybe<BooleanFieldComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export enum TemplateType {
  CartEmail = 'CART_EMAIL',
  CartEmailPreview = 'CART_EMAIL_PREVIEW',
  GeneralEmail = 'GENERAL_EMAIL',
  GridTemplate = 'GRID_TEMPLATE',
  OrderEmail = 'ORDER_EMAIL',
  ProductVariant = 'PRODUCT_VARIANT',
  StoreStatus = 'STORE_STATUS',
  TemplateContainer = 'TEMPLATE_CONTAINER',
  TemplateContainerWithUnsubscribe = 'TEMPLATE_CONTAINER_WITH_UNSUBSCRIBE',
  VoucherEmail = 'VOUCHER_EMAIL'
}

export type TimePeriods = {
  __typename: 'TimePeriods';
  month: Scalars['Float'];
  total: Scalars['Float'];
};

export type TopBrands = {
  __typename: 'TopBrands';
  brand: Brand;
  numOrders: Scalars['Int'];
};

export type TopProducts = {
  __typename: 'TopProducts';
  numOrders: Scalars['Int'];
  product: DashboardProduct;
};

export type TransactionEdge = {
  __typename: 'TransactionEdge';
  /** Used in `before` and `after` args */
  cursor: Scalars['String'];
  node: VoucherLedgerDto;
};

export type TransactionsConnection = {
  __typename: 'TransactionsConnection';
  edges: Array<TransactionEdge>;
  pageInfo: RelayPageInfo;
};

export type Trigger = {
  __typename: 'Trigger';
  accountGroups?: Maybe<Array<AccountGroup>>;
  actions: Array<Action>;
  createdAt: Scalars['DateTime'];
  criteria: Scalars['JSON'];
  enabled: Scalars['Boolean'];
  eventType: AccountEventType;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


export type TriggerAccountGroupsArgs = {
  filter?: AccountGroupFilter;
  sorting?: Array<AccountGroupSort>;
};


export type TriggerActionsArgs = {
  filter?: ActionFilter;
  sorting?: Array<ActionSort>;
};

export type TriggerAggregateGroupBy = {
  __typename: 'TriggerAggregateGroupBy';
  createdAt?: Maybe<Scalars['DateTime']>;
  enabled?: Maybe<Scalars['Boolean']>;
  eventType?: Maybe<AccountEventType>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TriggerConnection = {
  __typename: 'TriggerConnection';
  /** Array of edges. */
  edges: Array<TriggerEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type TriggerCountAggregate = {
  __typename: 'TriggerCountAggregate';
  createdAt?: Maybe<Scalars['Int']>;
  enabled?: Maybe<Scalars['Int']>;
  eventType?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
};

export type TriggerEdge = {
  __typename: 'TriggerEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Trigger */
  node: Trigger;
};

export type TriggerFilter = {
  and?: Maybe<Array<TriggerFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  eventType?: Maybe<AccountEventTypeFilterComparison>;
  name?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<TriggerFilter>>;
  updatedAt?: Maybe<DateFieldComparison>;
};

export type TriggerMaxAggregate = {
  __typename: 'TriggerMaxAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<AccountEventType>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TriggerMinAggregate = {
  __typename: 'TriggerMinAggregate';
  createdAt?: Maybe<Scalars['DateTime']>;
  eventType?: Maybe<AccountEventType>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TriggerSort = {
  direction: SortDirection;
  field: TriggerSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum TriggerSortFields {
  CreatedAt = 'createdAt',
  Enabled = 'enabled',
  EventType = 'eventType',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type UnredeemedAmounts = {
  __typename: 'UnredeemedAmounts';
  internal: Scalars['Float'];
  purchased: Scalars['Float'];
};

export type UpdateActionInput = {
  channels?: Maybe<Array<MessageChannels>>;
  delay?: Maybe<DelayInput>;
  enabled?: Maybe<Scalars['Boolean']>;
  expiryDate?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<ActionEventType>;
  voucherMessage?: Maybe<Scalars['String']>;
  voucherValue?: Maybe<Scalars['Float']>;
};

export type UpdateAddress = {
  accountId?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
};

export type UpdateAddressInput = {
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  defaultBillingAddress?: Maybe<Scalars['Boolean']>;
  defaultShippingAddress?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  shippingEmail?: Maybe<Scalars['String']>;
  streetLine1?: Maybe<Scalars['String']>;
  streetLine2?: Maybe<Scalars['String']>;
  suburb?: Maybe<Scalars['String']>;
};

export type UpdateConfigInput = {
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UpdateCustomer = {
  accountId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isSubscribed?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
};

export type UpdateEmailTemplateInput = {
  type?: Maybe<TemplateType>;
};

export type UpdateListInput = {
  isPublic?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateMailchimpMemberInput = {
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type UpdateManyAccountGroupsInput = {
  /** Filter used to find fields to update */
  filter: AccountGroupUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: AccountGroupInput;
};

export type UpdateManyAccountsInput = {
  /** Filter used to find fields to update */
  filter: AccountUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: AccountUpdateInput;
};

export type UpdateManyAddressesInput = {
  /** Filter used to find fields to update */
  filter: AddressUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateAddress;
};

export type UpdateManyBrandsInput = {
  /** Filter used to find fields to update */
  filter: BrandUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: BrandsInput;
};

export type UpdateManyOptionNamesInput = {
  /** Filter used to find fields to update */
  filter: OptionNameUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: OptionNamesInput;
};

export type UpdateManyProductOptionsInput = {
  /** Filter used to find fields to update */
  filter: ProductOptionUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: ProductOptionsInput;
};

export type UpdateManyProductVariantsInput = {
  /** Filter used to find fields to update */
  filter: ProductVariantUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: ProductVariantsInput;
};

export type UpdateManyProductsInput = {
  /** Filter used to find fields to update */
  filter: ProductUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: ProductsInput;
};

export type UpdateManyResponse = {
  __typename: 'UpdateManyResponse';
  /** The number of records updated. */
  updatedCount: Scalars['Int'];
};

export type UpdateManySizingGuidesInput = {
  /** Filter used to find fields to update */
  filter: SizingGuideUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateSizingGuideInput;
};

export type UpdateManyTagsInput = {
  /** Filter used to find fields to update */
  filter: TagUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateTag;
};

export type UpdateManyVouchersInput = {
  /** Filter used to find fields to update */
  filter: VoucherUpdateFilter;
  /** The update to apply to all records found using the filter */
  update: UpdateVoucher;
};

export type UpdateMessageCampaignInput = {
  accountGroupIds?: Maybe<Array<Scalars['String']>>;
  accountGroupOperator?: Maybe<Operator>;
  channels?: Maybe<Array<MessageChannels>>;
  comment?: Maybe<Scalars['String']>;
  interval?: Maybe<CampaignInterval>;
  messageId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nextRunAt?: Maybe<Scalars['DateTime']>;
  scheduledAt?: Maybe<Scalars['DateTime']>;
  timeToRun?: Maybe<Scalars['DateTime']>;
  type?: Maybe<CampaignType>;
};

export type UpdateMessageInput = {
  body?: Maybe<Scalars['String']>;
  contentId?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<MessageMetaInput>;
  name?: Maybe<Scalars['String']>;
  notificationBody?: Maybe<Scalars['String']>;
  notificationTitle?: Maybe<Scalars['String']>;
  preview?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type UpdateOneAccountGroupInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: AccountGroupInput;
};

export type UpdateOneAccountInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: AccountUpdateInput;
};

export type UpdateOneAddressInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: UpdateAddress;
};

export type UpdateOneBrandInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: BrandsInput;
};

export type UpdateOneCustomerInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: UpdateCustomer;
};

export type UpdateOneOptionNameInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: OptionNamesInput;
};

export type UpdateOneProductInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: ProductsInput;
};

export type UpdateOneProductOptionInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: ProductOptionsInput;
};

export type UpdateOneProductVariantInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: ProductVariantsInput;
};

export type UpdateOneProfileInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: ProfilesUpdateInput;
};

export type UpdateOneSizingGuideInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: UpdateSizingGuideInput;
};

export type UpdateOneTagInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: UpdateTag;
};

export type UpdateOneVoucherInput = {
  /** The id of the record to update */
  id: Scalars['ID'];
  /** The update to apply. */
  update: UpdateVoucher;
};

export type UpdatePasswordInput = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};

export type UpdateSizingGuideInput = {
  content?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateTag = {
  category?: Maybe<TagCategory>;
  categoryLabel?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<ImageInput>;
  meta?: Maybe<Scalars['JSON']>;
  name?: Maybe<Scalars['String']>;
  topic?: Maybe<Scalars['Boolean']>;
  types?: Maybe<Array<TagTypeInput>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UpdateTriggerInput = {
  accountGroupIds?: Maybe<Array<Scalars['String']>>;
  actions?: Maybe<Array<CreateActionInput>>;
  criteria?: Maybe<Scalars['JSON']>;
  enabled?: Maybe<Scalars['Boolean']>;
  eventType?: Maybe<AccountEventType>;
  name?: Maybe<Scalars['String']>;
};

export type UpdateVoucher = {
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  redemptionDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<VoucherStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Float']>;
  voucherNumber?: Maybe<Scalars['Int']>;
};


export type UserStatistics = {
  __typename: 'UserStatistics';
  signups: Scalars['Int'];
  signupsPerDay: Scalars['Int'];
  wishlists: WishlistStats;
};

export type ValidationIssue = {
  __typename: 'ValidationIssue';
  issue: Scalars['String'];
  itemId?: Maybe<Scalars['String']>;
  orderLineId?: Maybe<Scalars['String']>;
};

export type Voucher = {
  __typename: 'Voucher';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<Account>;
  expiryDate: Scalars['DateTime'];
  id: Scalars['ID'];
  orderItem: OrderItem;
  reason?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  redemptionDate?: Maybe<Scalars['DateTime']>;
  status: VoucherStatus;
  updatedAt: Scalars['DateTime'];
  value: Scalars['Float'];
  voucherNumber: Scalars['Int'];
};

export type VoucherAggregateGroupBy = {
  __typename: 'VoucherAggregateGroupBy';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  status?: Maybe<VoucherStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Float']>;
  voucherNumber?: Maybe<Scalars['Int']>;
};

export type VoucherAvgAggregate = {
  __typename: 'VoucherAvgAggregate';
  value?: Maybe<Scalars['Float']>;
  voucherNumber?: Maybe<Scalars['Float']>;
};

export type VoucherConnection = {
  __typename: 'VoucherConnection';
  /** Array of edges. */
  edges: Array<VoucherEdge>;
  /** Paging information */
  pageInfo: PageInfo;
};

export type VoucherCountAggregate = {
  __typename: 'VoucherCountAggregate';
  code?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Int']>;
  expiryDate?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['Int']>;
  recipientEmail?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
  voucherNumber?: Maybe<Scalars['Int']>;
};

export type VoucherEdge = {
  __typename: 'VoucherEdge';
  /** Cursor for this node. */
  cursor: Scalars['ConnectionCursor'];
  /** The node containing the Voucher */
  node: Voucher;
};

export type VoucherFilter = {
  and?: Maybe<Array<VoucherFilter>>;
  code?: Maybe<StringFieldComparison>;
  createdAt?: Maybe<DateFieldComparison>;
  createdBy?: Maybe<VoucherFilterAccountFilter>;
  expiryDate?: Maybe<DateFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  or?: Maybe<Array<VoucherFilter>>;
  reason?: Maybe<StringFieldComparison>;
  recipientEmail?: Maybe<StringFieldComparison>;
  status?: Maybe<VoucherStatusFilterComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
  value?: Maybe<FloatFieldComparison>;
  voucherNumber?: Maybe<IntFieldComparison>;
};

export type VoucherFilterAccountFilter = {
  and?: Maybe<Array<VoucherFilterAccountFilter>>;
  createdAt?: Maybe<DateFieldComparison>;
  email?: Maybe<StringFieldComparison>;
  enabled?: Maybe<BooleanFieldComparison>;
  firstName?: Maybe<StringFieldComparison>;
  id?: Maybe<StringFieldComparison>;
  lastName?: Maybe<StringFieldComparison>;
  or?: Maybe<Array<VoucherFilterAccountFilter>>;
  status?: Maybe<StringFieldComparison>;
};

export type VoucherLedgerDto = {
  __typename: 'VoucherLedgerDTO';
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  order?: Maybe<Order>;
  type: VoucherLedgerType;
  voucher: Voucher;
};

export enum VoucherLedgerType {
  Expiry = 'Expiry',
  Internal = 'Internal',
  Purchase = 'Purchase',
  Transaction = 'Transaction'
}

export type VoucherMaxAggregate = {
  __typename: 'VoucherMaxAggregate';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  status?: Maybe<VoucherStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Float']>;
  voucherNumber?: Maybe<Scalars['Int']>;
};

export type VoucherMinAggregate = {
  __typename: 'VoucherMinAggregate';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  expiryDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  reason?: Maybe<Scalars['String']>;
  recipientEmail?: Maybe<Scalars['String']>;
  status?: Maybe<VoucherStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  value?: Maybe<Scalars['Float']>;
  voucherNumber?: Maybe<Scalars['Int']>;
};

export type VoucherSort = {
  direction: SortDirection;
  field: VoucherSortFields;
  nulls?: Maybe<SortNulls>;
};

export enum VoucherSortFields {
  Code = 'code',
  CreatedAt = 'createdAt',
  ExpiryDate = 'expiryDate',
  Id = 'id',
  Reason = 'reason',
  RecipientEmail = 'recipientEmail',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  Value = 'value',
  VoucherNumber = 'voucherNumber'
}

export type VoucherStats = {
  __typename: 'VoucherStats';
  averageSalesPerDay: Scalars['Float'];
  dailySales: Array<DataPoint>;
  internal: InternalStats;
  totalIssued: Scalars['Float'];
  totalSales: Scalars['Float'];
  totalWalletBalance: Scalars['String'];
  unredeemedAmounts: UnredeemedAmounts;
};

export enum VoucherStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Redeemed = 'REDEEMED'
}

export type VoucherStatusFilterComparison = {
  eq?: Maybe<VoucherStatus>;
  gt?: Maybe<VoucherStatus>;
  gte?: Maybe<VoucherStatus>;
  iLike?: Maybe<VoucherStatus>;
  in?: Maybe<Array<VoucherStatus>>;
  is?: Maybe<Scalars['Boolean']>;
  isNot?: Maybe<Scalars['Boolean']>;
  like?: Maybe<VoucherStatus>;
  lt?: Maybe<VoucherStatus>;
  lte?: Maybe<VoucherStatus>;
  neq?: Maybe<VoucherStatus>;
  notILike?: Maybe<VoucherStatus>;
  notIn?: Maybe<Array<VoucherStatus>>;
  notLike?: Maybe<VoucherStatus>;
};

export type VoucherSumAggregate = {
  __typename: 'VoucherSumAggregate';
  value?: Maybe<Scalars['Float']>;
  voucherNumber?: Maybe<Scalars['Float']>;
};

export type VoucherUpdateFilter = {
  and?: Maybe<Array<VoucherUpdateFilter>>;
  code?: Maybe<StringFieldComparison>;
  createdAt?: Maybe<DateFieldComparison>;
  expiryDate?: Maybe<DateFieldComparison>;
  id?: Maybe<IdFilterComparison>;
  or?: Maybe<Array<VoucherUpdateFilter>>;
  reason?: Maybe<StringFieldComparison>;
  recipientEmail?: Maybe<StringFieldComparison>;
  status?: Maybe<VoucherStatusFilterComparison>;
  updatedAt?: Maybe<DateFieldComparison>;
  value?: Maybe<FloatFieldComparison>;
  voucherNumber?: Maybe<IntFieldComparison>;
};

export type WishlistStats = {
  __typename: 'WishlistStats';
  numberOfUsers: Scalars['Int'];
  total: Scalars['Int'];
};

export enum BrandStatus {
  Expired = 'expired',
  Pending = 'pending',
  Unverified = 'unverified',
  Verified = 'verified'
}

export enum Gender {
  Female = 'female',
  Male = 'male',
  Other = 'other'
}

/** whether back orders are allowed */
export enum InventoryPolicy {
  Continue = 'continue',
  Deny = 'deny'
}

/** statuses are specific status for users in the system */
export enum Statuses {
  Active = 'active',
  Blocked = 'blocked',
  Disabled = 'disabled',
  Pending = 'pending'
}

export enum StockStatus {
  InStock = 'IN_STOCK',
  LowStock = 'LOW_STOCK',
  OutOfStock = 'OUT_OF_STOCK',
  ProductRemoved = 'PRODUCT_REMOVED'
}

export type AccountEventOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountEventOptionsQuery = { __typename: 'Query', accountEventOptions: any };

export type AllAccountGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAccountGroupsQuery = { __typename: 'Query', allAccountGroups: Array<{ __typename: 'AccountGroup', id: string, name: string }> };

export type AccountGroupConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountGroupConfigQuery = { __typename: 'Query', accountGroupConfig: { __typename: 'AccountGroupConfigDto', fields: any } };

export type ProcessBrandStatementMutationVariables = Exact<{
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  brandId: Scalars['String'];
  sendToBrand: Scalars['Boolean'];
}>;


export type ProcessBrandStatementMutation = { __typename: 'Mutation', processBrandStatement: boolean };

export type ActionTypeOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionTypeOptionsQuery = { __typename: 'Query', actionTypeOptions: any };

export type UpdateConfigMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateConfigInput;
}>;


export type UpdateConfigMutation = { __typename: 'Mutation', updateConfig: boolean };

export type GetAppVersionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAppVersionQuery = { __typename: 'Query', configValue: { __typename: 'ConfigDTO', id: string, value: string } };

export type BrandPoliciesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BrandPoliciesQuery = { __typename: 'Query', policies: Array<{ __typename: 'Policy', body: string, url: string, handle: string }> };

export type UpdateShopifyMutationVariables = Exact<{
  id: Scalars['String'];
  update: ShopifyUpdate;
}>;


export type UpdateShopifyMutation = { __typename: 'Mutation', updateShopify: { __typename: 'Shopify', id: string, domain: string } };

export type RemoveItemMutationVariables = Exact<{
  orderId: Scalars['String'];
  input: RemoveItemInput;
}>;


export type RemoveItemMutation = { __typename: 'Mutation', removeItemFromOrder: { __typename: 'Order', id: string } };

export type RemoveLineByIdMutationVariables = Exact<{
  lineId: Scalars['String'];
}>;


export type RemoveLineByIdMutation = { __typename: 'Mutation', removeLineById: { __typename: 'Order', id: string } };

export type MessageChannelsQueryVariables = Exact<{ [key: string]: never; }>;


export type MessageChannelsQuery = { __typename: 'Query', messageChannels: any };

export type ReprocessOrderMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReprocessOrderMutation = { __typename: 'Mutation', reprocessOrder: boolean };

export type FetchAndSyncProductMutationVariables = Exact<{
  input: FetchProductByProviderIdInput;
}>;


export type FetchAndSyncProductMutation = { __typename: 'Mutation', fetchAndSyncProductByProviderId: boolean };

export type ProductStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductStatsQuery = { __typename: 'Query', productStats: Array<{ __typename: 'ProductStat', label: string, value: string }> };

export type ReprocessInvoiceMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReprocessInvoiceMutation = { __typename: 'Mutation', reprocessInvoice: boolean };

export type UserExportMutationVariables = Exact<{
  isSubscribed: Scalars['Boolean'];
  dateRange?: Maybe<Array<Scalars['DateTime']> | Scalars['DateTime']>;
  emails?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type UserExportMutation = { __typename: 'Mutation', sendCustomerCsv: boolean };

export type VoucherReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type VoucherReasonsQuery = { __typename: 'Query', voucherReasons: Array<string> };

export type VouchersExportMutationVariables = Exact<{
  reason?: Maybe<Scalars['String']>;
}>;


export type VouchersExportMutation = { __typename: 'Mutation', sendVouchersCsv: boolean };

export type MeQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQueryQuery = { __typename: 'Query', me?: Maybe<{ __typename: 'Account', id: string, email: string, firstName: string, lastName: string, status: string, enabled: boolean, roles: Array<string>, createdAt: any, permissions?: Maybe<Array<Permission>> }> };

export type AccountFieldsFragment = { __typename: 'Account', id: string, email: string, firstName: string, lastName: string, status: string, enabled: boolean, roles: Array<string>, createdAt: any, permissions?: Maybe<Array<Permission>> };

export type ImageFieldsFragment = { __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string };

export type TagFieldsFragment = { __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> };

export type MetaFieldsFragment = { __typename: 'Meta', fields?: Maybe<Array<{ __typename: 'Field', title: string, link: string, isExternal?: Maybe<boolean> }>> };

export type BrandMetaFieldsFragment = { __typename: 'BrandMeta', includeRecentlySold?: Maybe<boolean>, location?: Maybe<string>, fields?: Maybe<Array<{ __typename: 'Field', title: string, link: string, isExternal?: Maybe<boolean> }>> };

export type NotesFieldsFragment = { __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> };

export type BrandFieldsFragment = { __typename: 'Brand', id: string, name?: Maybe<string>, providerName?: Maybe<string>, brandName?: Maybe<string>, enabled?: Maybe<boolean>, verified: BrandStatus, marketingName?: Maybe<string>, marketingDescription?: Maybe<string>, marketingColor?: Maybe<string>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredPortrait?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredLandscape?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> };

export type BrandDetailFieldsFragment = { __typename: 'Brand', description?: Maybe<string>, providerDescription?: Maybe<string>, brandDescription?: Maybe<string>, address?: Maybe<string>, currency?: Maybe<string>, locale?: Maybe<string>, ownerName?: Maybe<string>, terms?: Maybe<string>, privacyPolicy?: Maybe<string>, returnPolicy?: Maybe<string>, shippingPolicy?: Maybe<string>, lastSync: string, installUrl?: Maybe<string>, phone?: Maybe<string>, providerPhone?: Maybe<string>, brandCellphone?: Maybe<string>, website?: Maybe<string>, websiteOverride?: Maybe<string>, brandWebsite?: Maybe<string>, email?: Maybe<string>, providerEmail?: Maybe<string>, brandEmail?: Maybe<string>, facebook?: Maybe<string>, instagram?: Maybe<string>, commission: number, adminEmails: Array<string>, hiddenFields: Array<BrandContactFields>, vatNumber?: Maybe<string>, productSort: BrandProductSortEnum, productSortFriendly: string, recommendedProductTags: Array<string>, leadTimeDays?: Maybe<number>, meta?: Maybe<{ __typename: 'BrandMeta', includeRecentlySold?: Maybe<boolean>, location?: Maybe<string>, fields?: Maybe<Array<{ __typename: 'Field', title: string, link: string, isExternal?: Maybe<boolean> }>> }>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }>, paymentTerms?: Maybe<{ __typename: 'PaymentTerms', unit: number, amount: string }>, bankDetails?: Maybe<{ __typename: 'BankDetails', accountNumber?: Maybe<string>, branchCode?: Maybe<string>, bankName?: Maybe<string> }>, shopify?: Maybe<{ __typename: 'Shopify', id: string, appId?: Maybe<string>, domain: string }>, invoiceAddress?: Maybe<{ __typename: 'BrandAddress', address1: string, address2?: Maybe<string>, city: string, province: string, zip: string }>, locations: Array<{ __typename: 'LocationDTO', id?: Maybe<number>, name?: Maybe<string>, address1?: Maybe<string> }>, sizingGuide?: Maybe<{ __typename: 'SizingGuide', id: string, name: string }> };

export type OptionNameFieldsFragment = { __typename: 'OptionName', id: string, name: string };

export type OptionFieldsFragment = { __typename: 'ProductOption', id: string, value: string, name: { __typename: 'OptionName', id: string, name: string } };

export type VariantFieldsFragment = { __typename: 'ProductVariant', id: string, title: string, price: number, inventory: number, sku?: Maybe<string>, inventoryPolicy: InventoryPolicy };

export type ProductFieldsFragment = { __typename: 'Product', id: string, title?: Maybe<string>, providerTitle: string, productTitle?: Maybe<string>, description?: Maybe<string>, providerId: string, providerDescription?: Maybe<string>, productDescription?: Maybe<string>, tracksInventory: boolean, enabled: boolean, createdAt: any, updatedAt: any, providerTags?: Maybe<Array<string>>, providerImage?: Maybe<string>, isAutoPublish: boolean, isImageContained: boolean, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, providerImages: Array<{ __typename: 'Image', url: string, id: string, key?: Maybe<string>, sourceType: string }>, brand?: Maybe<{ __typename: 'Brand', id: string, name?: Maybe<string>, providerName?: Maybe<string>, brandName?: Maybe<string>, enabled?: Maybe<boolean>, verified: BrandStatus, marketingName?: Maybe<string>, marketingDescription?: Maybe<string>, marketingColor?: Maybe<string>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredPortrait?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredLandscape?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, options: Array<{ __typename: 'ProductOption', id: string, value: string, name: { __typename: 'OptionName', id: string, name: string } }>, variants: Array<{ __typename: 'ProductVariant', id: string, title: string, price: number, inventory: number, sku?: Maybe<string>, inventoryPolicy: InventoryPolicy, selectedOptions: Array<{ __typename: 'ProductVariantOptionsDTO', name: string, value?: Maybe<string> }>, images?: Maybe<Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>> }>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, sizingGuide?: Maybe<{ __typename: 'SizingGuide', id: string, name: string }>, meta?: Maybe<{ __typename: 'Meta', fields?: Maybe<Array<{ __typename: 'Field', title: string, link: string, isExternal?: Maybe<boolean> }>> }>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> };

export type PagingFieldsFragment = { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> };

export type UpdateOrderCustomerMutationVariables = Exact<{
  input: UpdateOneCustomerInput;
}>;


export type UpdateOrderCustomerMutation = { __typename: 'Mutation', updateOneCustomer: { __typename: 'Customer', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, email: string, mobile?: Maybe<string> } };

export type AllBrandsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type AllBrandsQueryQuery = { __typename: 'Query', allBrands: Array<{ __typename: 'Brand', id: string, brandName?: Maybe<string>, tags: Array<{ __typename: 'Tag', id: string, name: string, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string> }> }> };

export type BrandsQueryQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<BrandFilter>;
  sorting?: Maybe<Array<BrandSort> | BrandSort>;
}>;


export type BrandsQueryQuery = { __typename: 'Query', brands: { __typename: 'BrandConnection', edges: Array<{ __typename: 'BrandEdge', node: { __typename: 'Brand', id: string, name?: Maybe<string>, providerName?: Maybe<string>, brandName?: Maybe<string>, enabled?: Maybe<boolean>, verified: BrandStatus, marketingName?: Maybe<string>, marketingDescription?: Maybe<string>, marketingColor?: Maybe<string>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredPortrait?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredLandscape?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type DeleteBrandMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteBrandMutation = { __typename: 'Mutation', deleteOneBrand: { __typename: 'BrandDeleteResponse', id?: Maybe<string> } };

export type DeleteBrandsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type DeleteBrandsMutation = { __typename: 'Mutation', deleteManyBrands: { __typename: 'DeleteManyResponse', deletedCount: number } };

export type UpdateBrandsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  update: BrandsInput;
}>;


export type UpdateBrandsMutation = { __typename: 'Mutation', updateManyBrands: { __typename: 'UpdateManyResponse', updatedCount: number } };

export type UpdateBrandMutationVariables = Exact<{
  id: Scalars['ID'];
  update: BrandsInput;
}>;


export type UpdateBrandMutation = { __typename: 'Mutation', updateBrand: { __typename: 'Brand', id: string, name?: Maybe<string>, providerName?: Maybe<string>, brandName?: Maybe<string>, enabled?: Maybe<boolean>, verified: BrandStatus, marketingName?: Maybe<string>, marketingDescription?: Maybe<string>, marketingColor?: Maybe<string>, description?: Maybe<string>, providerDescription?: Maybe<string>, brandDescription?: Maybe<string>, address?: Maybe<string>, currency?: Maybe<string>, locale?: Maybe<string>, ownerName?: Maybe<string>, terms?: Maybe<string>, privacyPolicy?: Maybe<string>, returnPolicy?: Maybe<string>, shippingPolicy?: Maybe<string>, lastSync: string, installUrl?: Maybe<string>, phone?: Maybe<string>, providerPhone?: Maybe<string>, brandCellphone?: Maybe<string>, website?: Maybe<string>, websiteOverride?: Maybe<string>, brandWebsite?: Maybe<string>, email?: Maybe<string>, providerEmail?: Maybe<string>, brandEmail?: Maybe<string>, facebook?: Maybe<string>, instagram?: Maybe<string>, commission: number, adminEmails: Array<string>, hiddenFields: Array<BrandContactFields>, vatNumber?: Maybe<string>, productSort: BrandProductSortEnum, productSortFriendly: string, recommendedProductTags: Array<string>, leadTimeDays?: Maybe<number>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredPortrait?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredLandscape?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, meta?: Maybe<{ __typename: 'BrandMeta', includeRecentlySold?: Maybe<boolean>, location?: Maybe<string>, fields?: Maybe<Array<{ __typename: 'Field', title: string, link: string, isExternal?: Maybe<boolean> }>> }>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }>, paymentTerms?: Maybe<{ __typename: 'PaymentTerms', unit: number, amount: string }>, bankDetails?: Maybe<{ __typename: 'BankDetails', accountNumber?: Maybe<string>, branchCode?: Maybe<string>, bankName?: Maybe<string> }>, shopify?: Maybe<{ __typename: 'Shopify', id: string, appId?: Maybe<string>, domain: string }>, invoiceAddress?: Maybe<{ __typename: 'BrandAddress', address1: string, address2?: Maybe<string>, city: string, province: string, zip: string }>, locations: Array<{ __typename: 'LocationDTO', id?: Maybe<number>, name?: Maybe<string>, address1?: Maybe<string> }>, sizingGuide?: Maybe<{ __typename: 'SizingGuide', id: string, name: string }> } };

export type SetTagsOnBrandMutationVariables = Exact<{
  id: Scalars['ID'];
  tagIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SetTagsOnBrandMutation = { __typename: 'Mutation', setTagsOnBrand: { __typename: 'Brand', id: string, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } };

export type CreateBrandMutationVariables = Exact<{
  input: CreateOneShopifyBrandInput;
}>;


export type CreateBrandMutation = { __typename: 'Mutation', createOneShopifyBrand: { __typename: 'Brand', id: string, name?: Maybe<string>, providerName?: Maybe<string>, brandName?: Maybe<string>, enabled?: Maybe<boolean>, verified: BrandStatus, marketingName?: Maybe<string>, marketingDescription?: Maybe<string>, marketingColor?: Maybe<string>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredPortrait?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredLandscape?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } };

export type SetPortraitOnBrandMutationVariables = Exact<{
  id: Scalars['ID'];
  imageId: Scalars['ID'];
}>;


export type SetPortraitOnBrandMutation = { __typename: 'Mutation', setFeaturedPortraitOnBrand: { __typename: 'Brand', id: string, featuredPortrait?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } };

export type SetLandscapeOnBrandMutationVariables = Exact<{
  id: Scalars['ID'];
  imageId: Scalars['ID'];
}>;


export type SetLandscapeOnBrandMutation = { __typename: 'Mutation', setFeaturedLandscapeOnBrand: { __typename: 'Brand', id: string, featuredLandscape?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } };

export type SetImagesOnBrandMutationVariables = Exact<{
  id: Scalars['ID'];
  imageIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SetImagesOnBrandMutation = { __typename: 'Mutation', setImagesOnBrand: { __typename: 'Brand', id: string, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } };

export type SetLogoOnBrandMutationVariables = Exact<{
  id: Scalars['ID'];
  imageId: Scalars['ID'];
}>;


export type SetLogoOnBrandMutation = { __typename: 'Mutation', setImageOnBrand: { __typename: 'Brand', id: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } };

export type SendOneBrandVerifyMutationVariables = Exact<{
  id: Scalars['ID'];
  email: Scalars['String'];
}>;


export type SendOneBrandVerifyMutation = { __typename: 'Mutation', sendOneBrandVerify: boolean };

export type UpdateOneBrandVerifyMutationVariables = Exact<{
  id: Scalars['ID'];
  installUrl: Scalars['String'];
}>;


export type UpdateOneBrandVerifyMutation = { __typename: 'Mutation', updateOneBrandVerify: boolean };

export type SyncOneBrandMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SyncOneBrandMutation = { __typename: 'Mutation', syncOneBrand: boolean };

export type IndexBrandMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type IndexBrandMutation = { __typename: 'Mutation', indexBrand: boolean };

export type SetupWebhookMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type SetupWebhookMutation = { __typename: 'Mutation', registerBrandWebhooks: boolean };

export type UploadOneImageMutationVariables = Exact<{
  file: Scalars['Upload'];
}>;


export type UploadOneImageMutation = { __typename: 'Mutation', uploadOneImage: { __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string } };

export type OrderAddressFieldsFragment = { __typename: 'OrderAddress', addressLine1: string, addressLine2?: Maybe<string>, suburb?: Maybe<string>, city: string, province: string, postalCode: string, country: string, phone?: Maybe<string>, note?: Maybe<string> };

export type AccountingCodeFieldsFragment = { __typename: 'AccountCode', id: number, code: string, description: string };

export type OrderLedgerFieldsFragment = { __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> };

export type OrderLineFieldsFragment = { __typename: 'OrderLine', id: string, subTotal: number, shippingHandle?: Maybe<string>, shippingTotal?: Maybe<number>, status: string, paymentDate?: Maybe<any>, invoiceUrl?: Maybe<string>, paymentAdviceUrl?: Maybe<string>, orderStatus?: Maybe<{ __typename: 'ShopifyOrder', status?: Maybe<string>, shippingStatus: string, confirmed?: Maybe<boolean>, orderReference?: Maybe<string> }>, issues: { __typename: 'OrderLinesIssues', error: string }, brand: { __typename: 'Brand', id: string, brandName?: Maybe<string>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> }, items: Array<{ __typename: 'OrderItem', id: string, quantity: number, price: number, productVariant: { __typename: 'ProductVariant', id: string, title: string, stockStatus: StockStatus, product?: Maybe<{ __typename: 'Product', id: string, productTitle?: Maybe<string>, stockStatus: StockStatus, status: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } }>, ledgerItems: Array<{ __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> }>, shippingMethods: Array<{ __typename: 'OrderLineShippingMethods', title: string, id: string, price: { __typename: 'PriceFormat', amount: string, currencyCode: string } }> };

export type BaseOrderFieldsFragment = { __typename: 'Order', id: string, createdAt: any, updatedAt: any, orderDate?: Maybe<any>, isActive: boolean, subTotal: number, orderNumber: number, productCount: number, status: string, shippingAddress?: Maybe<{ __typename: 'OrderAddress', firstName?: Maybe<string>, lastName?: Maybe<string> }>, customer?: Maybe<{ __typename: 'Customer', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, accountId?: Maybe<string>, email: string, mobile?: Maybe<string> }>, metadata: { __typename: 'OrderMetadata', checkout?: Maybe<{ __typename: 'OrderMetaFields', platform?: Maybe<string> }> } };

export type OrderFieldsFragment = { __typename: 'Order', useCredit: boolean, totalPaid: number, creditUsed: number, id: string, createdAt: any, updatedAt: any, orderDate?: Maybe<any>, isActive: boolean, subTotal: number, orderNumber: number, productCount: number, status: string, shippingAddress?: Maybe<{ __typename: 'OrderAddress', firstName?: Maybe<string>, lastName?: Maybe<string>, addressLine1: string, addressLine2?: Maybe<string>, suburb?: Maybe<string>, city: string, province: string, postalCode: string, country: string, phone?: Maybe<string>, note?: Maybe<string> }>, billingAddress?: Maybe<{ __typename: 'OrderAddress', addressLine1: string, addressLine2?: Maybe<string>, suburb?: Maybe<string>, city: string, province: string, postalCode: string, country: string, phone?: Maybe<string>, note?: Maybe<string> }>, lines: Array<{ __typename: 'OrderLine', id: string, subTotal: number, shippingHandle?: Maybe<string>, shippingTotal?: Maybe<number>, status: string, paymentDate?: Maybe<any>, invoiceUrl?: Maybe<string>, paymentAdviceUrl?: Maybe<string>, orderStatus?: Maybe<{ __typename: 'ShopifyOrder', status?: Maybe<string>, shippingStatus: string, confirmed?: Maybe<boolean>, orderReference?: Maybe<string> }>, issues: { __typename: 'OrderLinesIssues', error: string }, brand: { __typename: 'Brand', id: string, brandName?: Maybe<string>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> }, items: Array<{ __typename: 'OrderItem', id: string, quantity: number, price: number, productVariant: { __typename: 'ProductVariant', id: string, title: string, stockStatus: StockStatus, product?: Maybe<{ __typename: 'Product', id: string, productTitle?: Maybe<string>, stockStatus: StockStatus, status: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } }>, ledgerItems: Array<{ __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> }>, shippingMethods: Array<{ __typename: 'OrderLineShippingMethods', title: string, id: string, price: { __typename: 'PriceFormat', amount: string, currencyCode: string } }> }>, payments: Array<{ __typename: 'Payment', id: string, amount: number, createdAt?: Maybe<any>, method: string, state: string }>, customer?: Maybe<{ __typename: 'Customer', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, accountId?: Maybe<string>, email: string, mobile?: Maybe<string> }>, metadata: { __typename: 'OrderMetadata', checkout?: Maybe<{ __typename: 'OrderMetaFields', platform?: Maybe<string> }> } };

export type OrdersQueryQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<OrderFilter>;
  sorting?: Maybe<Array<OrderSort> | OrderSort>;
}>;


export type OrdersQueryQuery = { __typename: 'Query', orders: { __typename: 'OrderConnection', edges: Array<{ __typename: 'OrderEdge', node: { __typename: 'Order', id: string, createdAt: any, updatedAt: any, orderDate?: Maybe<any>, isActive: boolean, subTotal: number, orderNumber: number, productCount: number, status: string, lines: Array<{ __typename: 'OrderLine', brand: { __typename: 'Brand', brandName?: Maybe<string> } }>, shippingAddress?: Maybe<{ __typename: 'OrderAddress', firstName?: Maybe<string>, lastName?: Maybe<string> }>, customer?: Maybe<{ __typename: 'Customer', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, accountId?: Maybe<string>, email: string, mobile?: Maybe<string> }>, metadata: { __typename: 'OrderMetadata', checkout?: Maybe<{ __typename: 'OrderMetaFields', platform?: Maybe<string> }> } } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type ProductTableFieldsFragment = { __typename: 'Product', id: string, productTitle?: Maybe<string>, enabled: boolean, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, brand?: Maybe<{ __typename: 'Brand', brandName?: Maybe<string> }>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> };

export type ProductsQueryQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<ProductFilter>;
  sorting?: Maybe<Array<ProductSort> | ProductSort>;
}>;


export type ProductsQueryQuery = { __typename: 'Query', products: { __typename: 'ProductConnection', edges: Array<{ __typename: 'ProductEdge', node: { __typename: 'Product', id: string, productTitle?: Maybe<string>, enabled: boolean, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, brand?: Maybe<{ __typename: 'Brand', brandName?: Maybe<string> }>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type ProductQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ProductQueryQuery = { __typename: 'Query', product?: Maybe<{ __typename: 'Product', id: string, title?: Maybe<string>, providerTitle: string, productTitle?: Maybe<string>, description?: Maybe<string>, providerId: string, providerDescription?: Maybe<string>, productDescription?: Maybe<string>, tracksInventory: boolean, enabled: boolean, createdAt: any, updatedAt: any, providerTags?: Maybe<Array<string>>, providerImage?: Maybe<string>, isAutoPublish: boolean, isImageContained: boolean, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, providerImages: Array<{ __typename: 'Image', url: string, id: string, key?: Maybe<string>, sourceType: string }>, brand?: Maybe<{ __typename: 'Brand', id: string, name?: Maybe<string>, providerName?: Maybe<string>, brandName?: Maybe<string>, enabled?: Maybe<boolean>, verified: BrandStatus, marketingName?: Maybe<string>, marketingDescription?: Maybe<string>, marketingColor?: Maybe<string>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredPortrait?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredLandscape?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, options: Array<{ __typename: 'ProductOption', id: string, value: string, name: { __typename: 'OptionName', id: string, name: string } }>, variants: Array<{ __typename: 'ProductVariant', id: string, title: string, price: number, inventory: number, sku?: Maybe<string>, inventoryPolicy: InventoryPolicy, selectedOptions: Array<{ __typename: 'ProductVariantOptionsDTO', name: string, value?: Maybe<string> }>, images?: Maybe<Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>> }>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, sizingGuide?: Maybe<{ __typename: 'SizingGuide', id: string, name: string }>, meta?: Maybe<{ __typename: 'Meta', fields?: Maybe<Array<{ __typename: 'Field', title: string, link: string, isExternal?: Maybe<boolean> }>> }>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> }> };

export type AllProductsQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<ProductFilter>;
  sorting?: Maybe<Array<ProductSort> | ProductSort>;
}>;


export type AllProductsQuery = { __typename: 'Query', allProducts: Array<{ __typename: 'Product', id: string }> };

export type UpdateProductMutationVariables = Exact<{
  id: Scalars['ID'];
  update: ProductsInput;
}>;


export type UpdateProductMutation = { __typename: 'Mutation', updateOneProduct: { __typename: 'Product', id: string, title?: Maybe<string>, providerTitle: string, productTitle?: Maybe<string>, description?: Maybe<string>, providerId: string, providerDescription?: Maybe<string>, productDescription?: Maybe<string>, tracksInventory: boolean, enabled: boolean, createdAt: any, updatedAt: any, providerTags?: Maybe<Array<string>>, providerImage?: Maybe<string>, isAutoPublish: boolean, isImageContained: boolean, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, providerImages: Array<{ __typename: 'Image', url: string, id: string, key?: Maybe<string>, sourceType: string }>, brand?: Maybe<{ __typename: 'Brand', id: string, name?: Maybe<string>, providerName?: Maybe<string>, brandName?: Maybe<string>, enabled?: Maybe<boolean>, verified: BrandStatus, marketingName?: Maybe<string>, marketingDescription?: Maybe<string>, marketingColor?: Maybe<string>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredPortrait?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredLandscape?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, options: Array<{ __typename: 'ProductOption', id: string, value: string, name: { __typename: 'OptionName', id: string, name: string } }>, variants: Array<{ __typename: 'ProductVariant', id: string, title: string, price: number, inventory: number, sku?: Maybe<string>, inventoryPolicy: InventoryPolicy, selectedOptions: Array<{ __typename: 'ProductVariantOptionsDTO', name: string, value?: Maybe<string> }>, images?: Maybe<Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>> }>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, sizingGuide?: Maybe<{ __typename: 'SizingGuide', id: string, name: string }>, meta?: Maybe<{ __typename: 'Meta', fields?: Maybe<Array<{ __typename: 'Field', title: string, link: string, isExternal?: Maybe<boolean> }>> }>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> } };

export type UpdateProductsMutationVariables = Exact<{
  ids: Array<Scalars['ID']> | Scalars['ID'];
  update: ProductsInput;
}>;


export type UpdateProductsMutation = { __typename: 'Mutation', updateManyProducts: { __typename: 'UpdateManyResponse', updatedCount: number } };

export type SetTagsOnProductMutationVariables = Exact<{
  id: Scalars['ID'];
  tagIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SetTagsOnProductMutation = { __typename: 'Mutation', setTagsOnProduct: { __typename: 'Product', id: string, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } };

export type SetImageOnProductMutationVariables = Exact<{
  id: Scalars['ID'];
  imageId: Scalars['ID'];
}>;


export type SetImageOnProductMutation = { __typename: 'Mutation', setImageOnProduct: { __typename: 'Product', id: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } };

export type SetImagesOnProductMutationVariables = Exact<{
  id: Scalars['ID'];
  imageIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type SetImagesOnProductMutation = { __typename: 'Mutation', setImagesOnProduct: { __typename: 'Product', id: string, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } };

export type UpdateProductVariantMutationVariables = Exact<{
  id: Scalars['ID'];
  update: ProductVariantsInput;
}>;


export type UpdateProductVariantMutation = { __typename: 'Mutation', updateOneProductVariant: { __typename: 'ProductVariant', id: string, title: string, price: number, inventory: number, sku?: Maybe<string>, inventoryPolicy: InventoryPolicy } };

export type IndexProductMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type IndexProductMutation = { __typename: 'Mutation', indexProduct: boolean };

export type RefundFieldsFragment = { __typename: 'Refund', id: string, createdAt: any, updatedAt: any, state: string, basketAmount: number, adjustmentAmount?: Maybe<number>, note?: Maybe<string>, orderLine?: Maybe<{ __typename: 'OrderLine', id: string, subTotal: number, shippingHandle?: Maybe<string>, shippingTotal?: Maybe<number>, status: string, paymentDate?: Maybe<any>, invoiceUrl?: Maybe<string>, paymentAdviceUrl?: Maybe<string>, order: { __typename: 'Order', id: string, orderNumber: number, orderDate?: Maybe<any>, status: string, createdAt: any, updatedAt: any, creditUsed: number, subTotal: number, totalPaid: number, productCount: number, customer?: Maybe<{ __typename: 'Customer', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, accountId?: Maybe<string>, email: string, mobile?: Maybe<string> }>, shippingAddress?: Maybe<{ __typename: 'OrderAddress', addressLine1: string, addressLine2?: Maybe<string>, suburb?: Maybe<string>, city: string, province: string, postalCode: string, country: string, phone?: Maybe<string>, note?: Maybe<string> }>, billingAddress?: Maybe<{ __typename: 'OrderAddress', addressLine1: string, addressLine2?: Maybe<string>, suburb?: Maybe<string>, city: string, province: string, postalCode: string, country: string, phone?: Maybe<string>, note?: Maybe<string> }>, payments: Array<{ __typename: 'Payment', id: string, amount: number, createdAt?: Maybe<any>, method: string, state: string }>, lines: Array<{ __typename: 'OrderLine', id: string }> }, orderStatus?: Maybe<{ __typename: 'ShopifyOrder', status?: Maybe<string>, shippingStatus: string, confirmed?: Maybe<boolean>, orderReference?: Maybe<string> }>, issues: { __typename: 'OrderLinesIssues', error: string }, brand: { __typename: 'Brand', id: string, brandName?: Maybe<string>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> }, items: Array<{ __typename: 'OrderItem', id: string, quantity: number, price: number, productVariant: { __typename: 'ProductVariant', id: string, title: string, stockStatus: StockStatus, product?: Maybe<{ __typename: 'Product', id: string, productTitle?: Maybe<string>, stockStatus: StockStatus, status: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } }>, ledgerItems: Array<{ __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> }>, shippingMethods: Array<{ __typename: 'OrderLineShippingMethods', title: string, id: string, price: { __typename: 'PriceFormat', amount: string, currencyCode: string } }> }> };

export type RefundsQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<RefundFilter>;
  sorting?: Maybe<Array<RefundSort> | RefundSort>;
}>;


export type RefundsQuery = { __typename: 'Query', refunds: { __typename: 'RefundConnection', edges: Array<{ __typename: 'RefundEdge', node: { __typename: 'Refund', id: string, createdAt: any, updatedAt: any, state: string, basketAmount: number, adjustmentAmount?: Maybe<number>, note?: Maybe<string>, orderLine?: Maybe<{ __typename: 'OrderLine', id: string, subTotal: number, shippingHandle?: Maybe<string>, shippingTotal?: Maybe<number>, status: string, paymentDate?: Maybe<any>, invoiceUrl?: Maybe<string>, paymentAdviceUrl?: Maybe<string>, order: { __typename: 'Order', id: string, orderNumber: number, orderDate?: Maybe<any>, status: string, createdAt: any, updatedAt: any, creditUsed: number, subTotal: number, totalPaid: number, productCount: number, customer?: Maybe<{ __typename: 'Customer', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, accountId?: Maybe<string>, email: string, mobile?: Maybe<string> }>, shippingAddress?: Maybe<{ __typename: 'OrderAddress', addressLine1: string, addressLine2?: Maybe<string>, suburb?: Maybe<string>, city: string, province: string, postalCode: string, country: string, phone?: Maybe<string>, note?: Maybe<string> }>, billingAddress?: Maybe<{ __typename: 'OrderAddress', addressLine1: string, addressLine2?: Maybe<string>, suburb?: Maybe<string>, city: string, province: string, postalCode: string, country: string, phone?: Maybe<string>, note?: Maybe<string> }>, payments: Array<{ __typename: 'Payment', id: string, amount: number, createdAt?: Maybe<any>, method: string, state: string }>, lines: Array<{ __typename: 'OrderLine', id: string }> }, orderStatus?: Maybe<{ __typename: 'ShopifyOrder', status?: Maybe<string>, shippingStatus: string, confirmed?: Maybe<boolean>, orderReference?: Maybe<string> }>, issues: { __typename: 'OrderLinesIssues', error: string }, brand: { __typename: 'Brand', id: string, brandName?: Maybe<string>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> }, items: Array<{ __typename: 'OrderItem', id: string, quantity: number, price: number, productVariant: { __typename: 'ProductVariant', id: string, title: string, stockStatus: StockStatus, product?: Maybe<{ __typename: 'Product', id: string, productTitle?: Maybe<string>, stockStatus: StockStatus, status: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } }>, ledgerItems: Array<{ __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> }>, shippingMethods: Array<{ __typename: 'OrderLineShippingMethods', title: string, id: string, price: { __typename: 'PriceFormat', amount: string, currencyCode: string } }> }> } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type SizingGuidesQueryQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<SizingGuideFilter>;
  sorting?: Maybe<Array<SizingGuideSort> | SizingGuideSort>;
}>;


export type SizingGuidesQueryQuery = { __typename: 'Query', sizingGuides: { __typename: 'SizingGuideConnection', edges: Array<{ __typename: 'SizingGuideEdge', node: { __typename: 'SizingGuide', id: string, name: string, createdAt: any } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type SizingGuideQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SizingGuideQueryQuery = { __typename: 'Query', sizingGuide?: Maybe<{ __typename: 'SizingGuide', id: string, name: string, content?: Maybe<string>, createdAt: any, updatedAt: any }> };

export type AllSizingGuidesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllSizingGuidesQuery = { __typename: 'Query', sizingGuides: { __typename: 'SizingGuideConnection', edges: Array<{ __typename: 'SizingGuideEdge', node: { __typename: 'SizingGuide', id: string, name: string } }> } };

export type SizingGuidesForSelectQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<SizingGuideFilter>;
}>;


export type SizingGuidesForSelectQuery = { __typename: 'Query', sizingGuides: { __typename: 'SizingGuideConnection', edges: Array<{ __typename: 'SizingGuideEdge', node: { __typename: 'SizingGuide', id: string, name: string } }> } };

export type CreateSizingGuideMutationVariables = Exact<{
  input: CreateSizingGuideInput;
}>;


export type CreateSizingGuideMutation = { __typename: 'Mutation', createOneSizingGuide: { __typename: 'SizingGuide', id: string, name: string } };

export type UpdateSizingGuideMutationVariables = Exact<{
  id: Scalars['ID'];
  update: UpdateSizingGuideInput;
}>;


export type UpdateSizingGuideMutation = { __typename: 'Mutation', updateOneSizingGuide: { __typename: 'SizingGuide', id: string, name: string, content?: Maybe<string> } };

export type DeleteSizingGuideMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSizingGuideMutation = { __typename: 'Mutation', deleteOneSizingGuide: { __typename: 'SizingGuideDeleteResponse', id?: Maybe<string> } };

export type TagQueryQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TagQueryQuery = { __typename: 'Query', tag?: Maybe<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> };

export type TagTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type TagTypesQuery = { __typename: 'Query', tagTypes: { __typename: 'TagTypeConnection', edges: Array<{ __typename: 'TagTypeEdge', node: { __typename: 'TagType', name: TagTypeEnum } }> } };

export type TagCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type TagCategoriesQuery = { __typename: 'Query', tagCategories: Array<{ __typename: 'TagCategoryDTO', name: TagCategory, title: string }> };

export type AllTagsQueryVariables = Exact<{
  type?: Maybe<TagTypeEnum>;
}>;


export type AllTagsQuery = { __typename: 'Query', allTags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> };

export type TagsQueryQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<TagFilter>;
  sorting?: Maybe<Array<TagSort> | TagSort>;
}>;


export type TagsQueryQuery = { __typename: 'Query', tags: { __typename: 'TagConnection', edges: Array<{ __typename: 'TagEdge', node: { __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type DeleteTagMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTagMutation = { __typename: 'Mutation', deleteOneTag: { __typename: 'TagDeleteResponse', id?: Maybe<string> } };

export type DeleteTagsMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteTagsMutation = { __typename: 'Mutation', deleteManyTags: { __typename: 'DeleteManyResponse', deletedCount: number } };

export type UpdateTagMutationVariables = Exact<{
  id: Scalars['ID'];
  update: UpdateTag;
}>;


export type UpdateTagMutation = { __typename: 'Mutation', updateOneTag: { __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } };

export type CreateTagMutationVariables = Exact<{
  tag: CreateTag;
}>;


export type CreateTagMutation = { __typename: 'Mutation', createOneTag: { __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } };

export type SetImageOnTagMutationVariables = Exact<{
  id: Scalars['ID'];
  imageId: Scalars['ID'];
}>;


export type SetImageOnTagMutation = { __typename: 'Mutation', setImageOnTag: { __typename: 'Tag', id: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> } };

export type PublishTagFeedMutationVariables = Exact<{
  tagId: Scalars['String'];
}>;


export type PublishTagFeedMutation = { __typename: 'Mutation', publishTagFeed: boolean };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { __typename: 'Mutation', sendOnePasswordForgot: { __typename: 'ForgotPasswordResult', success: boolean, message: string } };

export type UserQueryVariables = Exact<{
  id: Scalars['ID'];
  firstTransactions: Scalars['Int'];
  after?: Maybe<Scalars['String']>;
}>;


export type UserQuery = { __typename: 'Query', account?: Maybe<{ __typename: 'Account', id: string, email: string, firstName: string, lastName: string, status: string, enabled: boolean, roles: Array<string>, createdAt: any, permissions?: Maybe<Array<Permission>>, customer?: Maybe<{ __typename: 'Customer', availableCredit: number, transactions: { __typename: 'TransactionsConnection', pageInfo: { __typename: 'RelayPageInfo', hasNextPage?: Maybe<boolean>, endCursor?: Maybe<string> }, edges: Array<{ __typename: 'TransactionEdge', node: { __typename: 'VoucherLedgerDTO', id: string, type: VoucherLedgerType, amount: number, createdAt: any, order?: Maybe<{ __typename: 'Order', id: string, orderNumber: number }>, voucher: { __typename: 'Voucher', id: string, redemptionDate?: Maybe<any>, updatedAt: any, voucherNumber: number } } }> } }> }> };

export type UsersQueryQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<AccountFilter>;
  sorting?: Maybe<Array<AccountSort> | AccountSort>;
}>;


export type UsersQueryQuery = { __typename: 'Query', accounts: { __typename: 'AccountConnection', edges: Array<{ __typename: 'AccountEdge', node: { __typename: 'Account', id: string, email: string, firstName: string, lastName: string, status: string, enabled: boolean, roles: Array<string>, createdAt: any, permissions?: Maybe<Array<Permission>> } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type CreateUserMutationVariables = Exact<{
  input: CreateOneAccountInput;
}>;


export type CreateUserMutation = { __typename: 'Mutation', createOneAccount: { __typename: 'Account', id: string, email: string, firstName: string, lastName: string, status: string, enabled: boolean, roles: Array<string>, createdAt: any, permissions?: Maybe<Array<Permission>> } };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  update: AccountUpdateInput;
}>;


export type UpdateUserMutation = { __typename: 'Mutation', updateOneAccount: { __typename: 'Account', id: string, email: string, firstName: string, lastName: string, status: string, enabled: boolean, roles: Array<string>, createdAt: any, permissions?: Maybe<Array<Permission>> } };

export type UpdateUsersMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  update: AccountUpdateInput;
}>;


export type UpdateUsersMutation = { __typename: 'Mutation', updateManyAccounts: { __typename: 'UpdateManyResponse', updatedCount: number } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteUserMutation = { __typename: 'Mutation', deleteOneAccount: { __typename: 'AccountDeleteResponse', id?: Maybe<string> } };

export type DeleteUsersMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
}>;


export type DeleteUsersMutation = { __typename: 'Mutation', deleteManyAccounts: { __typename: 'DeleteManyResponse', deletedCount: number } };

export type GetOptionNamesQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<OptionNameFilter>;
  sorting?: Maybe<Array<OptionNameSort> | OptionNameSort>;
}>;


export type GetOptionNamesQuery = { __typename: 'Query', optionNames: { __typename: 'OptionNameConnection', edges: Array<{ __typename: 'OptionNameEdge', node: { __typename: 'OptionName', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type UpdateOptionNameMutationVariables = Exact<{
  input: UpdateOneOptionNameInput;
}>;


export type UpdateOptionNameMutation = { __typename: 'Mutation', updateOneOptionName: { __typename: 'OptionName', id: string, name: string } };

export type GetAccountGroupsQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<AccountGroupFilter>;
  sorting?: Maybe<Array<AccountGroupSort> | AccountGroupSort>;
}>;


export type GetAccountGroupsQuery = { __typename: 'Query', accountGroups: { __typename: 'AccountGroupConnection', edges: Array<{ __typename: 'AccountGroupEdge', node: { __typename: 'AccountGroup', id: string, name: string, description?: Maybe<string> } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type CreateAccountGroupMutationVariables = Exact<{
  input: AccountGroupInput;
}>;


export type CreateAccountGroupMutation = { __typename: 'Mutation', createOneAccountGroup: { __typename: 'AccountGroup', id: string, name: string } };

export type DeleteAccountGroupMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteAccountGroupMutation = { __typename: 'Mutation', deleteOneAccountGroup: { __typename: 'AccountGroupDeleteResponse', id?: Maybe<string> } };

export type EditAccountGroupMutationVariables = Exact<{
  id: Scalars['ID'];
  update: AccountGroupInput;
}>;


export type EditAccountGroupMutation = { __typename: 'Mutation', updateOneAccountGroup: { __typename: 'AccountGroup', id: string, name: string, description?: Maybe<string>, definition: any } };

export type ExportAccountGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ExportAccountGroupMutation = { __typename: 'Mutation', exportAccountGroupAccounts: boolean };

export type AccountGroupFieldsFragment = { __typename: 'AccountGroup', id: string, name: string, description?: Maybe<string>, definition: any };

export type GetAccountGroupQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetAccountGroupQuery = { __typename: 'Query', accountGroup?: Maybe<{ __typename: 'AccountGroup', id: string, name: string, description?: Maybe<string>, definition: any }> };

export type GetAccountsInAccountGroupQueryVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  first?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['String']>;
}>;


export type GetAccountsInAccountGroupQuery = { __typename: 'Query', getAccountGroupAccounts: { __typename: 'AccountGroupAccountConnection', count: number, edges: Array<{ __typename: 'AccountGroupAccountEdge', node: { __typename: 'AccountGroupUserDTO', email: string, customerRecencyGroup: string, lastPurchaseAt?: Maybe<any>, lastLogin?: Maybe<any>, hasActiveCart: boolean, currentCartValue?: Maybe<number>, cartUpdatedAt?: Maybe<any>, numberOfOrders?: Maybe<number>, valueOfOrders?: Maybe<number>, registeredDate?: Maybe<any>, appOS?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, birthday?: Maybe<any>, id: string } }>, pageInfo: { __typename: 'RelayPageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<string>, endCursor?: Maybe<string> } } };

export type DeleteActionMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteActionMutation = { __typename: 'Mutation', deleteAction: boolean };

export type ActionQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActionQuery = { __typename: 'Query', action?: Maybe<{ __typename: 'Action', id: string, name: string, type: ActionEventType, enabled: boolean, channels?: Maybe<Array<MessageChannels>>, createdAt: any, updatedAt: any, voucherValue?: Maybe<number>, voucherMessage?: Maybe<string>, expiryDate?: Maybe<any>, message?: Maybe<{ __typename: 'Message', id: string, name: string }>, delay?: Maybe<{ __typename: 'Delay', unit: string, value: number }>, trigger: { __typename: 'Trigger', id: string, name: string, eventType: AccountEventType, enabled: boolean, criteria: any, createdAt: any, updatedAt: any, actions: Array<{ __typename: 'Action', id: string, name: string, type: ActionEventType, enabled: boolean, messageId?: Maybe<string>, channels?: Maybe<Array<MessageChannels>>, createdAt: any, updatedAt: any, voucherValue?: Maybe<number>, voucherMessage?: Maybe<string>, expiryDate?: Maybe<any>, message?: Maybe<{ __typename: 'Message', id: string, name: string }>, delay?: Maybe<{ __typename: 'Delay', unit: string, value: number }> }>, accountGroups?: Maybe<Array<{ __typename: 'AccountGroup', id: string, name: string }>> } }> };

export type UpdateActionMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateActionInput;
}>;


export type UpdateActionMutation = { __typename: 'Mutation', updateAction: { __typename: 'Action', id: string } };

export type BrandOrdersQueryVariables = Exact<{
  filter?: Maybe<OrderLineFilter>;
  sorting?: Maybe<Array<OrderLineSort> | OrderLineSort>;
  paging?: Maybe<CursorPaging>;
}>;


export type BrandOrdersQuery = { __typename: 'Query', orderLines: { __typename: 'OrderLineConnection', pageInfo: { __typename: 'PageInfo', endCursor?: Maybe<any>, startCursor?: Maybe<any>, hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean> }, edges: Array<{ __typename: 'OrderLineEdge', node: { __typename: 'OrderLine', id: string, subTotal: number, shippingHandle?: Maybe<string>, shippingTotal?: Maybe<number>, status: string, paymentDate?: Maybe<any>, invoiceUrl?: Maybe<string>, paymentAdviceUrl?: Maybe<string>, order: { __typename: 'Order', id: string, orderNumber: number, isActive: boolean, status: string, account?: Maybe<{ __typename: 'Account', firstName: string, lastName: string }> }, orderStatus?: Maybe<{ __typename: 'ShopifyOrder', status?: Maybe<string>, shippingStatus: string, confirmed?: Maybe<boolean>, orderReference?: Maybe<string> }>, issues: { __typename: 'OrderLinesIssues', error: string }, brand: { __typename: 'Brand', id: string, brandName?: Maybe<string>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> }, items: Array<{ __typename: 'OrderItem', id: string, quantity: number, price: number, productVariant: { __typename: 'ProductVariant', id: string, title: string, stockStatus: StockStatus, product?: Maybe<{ __typename: 'Product', id: string, productTitle?: Maybe<string>, stockStatus: StockStatus, status: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } }>, ledgerItems: Array<{ __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> }>, shippingMethods: Array<{ __typename: 'OrderLineShippingMethods', title: string, id: string, price: { __typename: 'PriceFormat', amount: string, currencyCode: string } }> } }> } };

export type BrandOrdersQueryQueryVariables = Exact<{
  filter?: Maybe<OrderLineFilter>;
  sorting?: Maybe<Array<OrderLineSort> | OrderLineSort>;
  paging?: Maybe<CursorPaging>;
}>;


export type BrandOrdersQueryQuery = { __typename: 'Query', orderLines: { __typename: 'OrderLineConnection', pageInfo: { __typename: 'PageInfo', endCursor?: Maybe<any>, startCursor?: Maybe<any>, hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean> }, edges: Array<{ __typename: 'OrderLineEdge', node: { __typename: 'OrderLine', id: string, subTotal: number, shippingHandle?: Maybe<string>, shippingTotal?: Maybe<number>, status: string, paymentDate?: Maybe<any>, invoiceUrl?: Maybe<string>, paymentAdviceUrl?: Maybe<string>, order: { __typename: 'Order', id: string, orderNumber: number, isActive: boolean, status: string, account?: Maybe<{ __typename: 'Account', firstName: string, lastName: string }> }, orderStatus?: Maybe<{ __typename: 'ShopifyOrder', status?: Maybe<string>, shippingStatus: string, confirmed?: Maybe<boolean>, orderReference?: Maybe<string> }>, issues: { __typename: 'OrderLinesIssues', error: string }, brand: { __typename: 'Brand', id: string, brandName?: Maybe<string>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> }, items: Array<{ __typename: 'OrderItem', id: string, quantity: number, price: number, productVariant: { __typename: 'ProductVariant', id: string, title: string, stockStatus: StockStatus, product?: Maybe<{ __typename: 'Product', id: string, productTitle?: Maybe<string>, stockStatus: StockStatus, status: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } }>, ledgerItems: Array<{ __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> }>, shippingMethods: Array<{ __typename: 'OrderLineShippingMethods', title: string, id: string, price: { __typename: 'PriceFormat', amount: string, currencyCode: string } }> } }> } };

export type BrandQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type BrandQuery = { __typename: 'Query', brand?: Maybe<{ __typename: 'Brand', id: string, name?: Maybe<string>, providerName?: Maybe<string>, brandName?: Maybe<string>, enabled?: Maybe<boolean>, verified: BrandStatus, marketingName?: Maybe<string>, marketingDescription?: Maybe<string>, marketingColor?: Maybe<string>, description?: Maybe<string>, providerDescription?: Maybe<string>, brandDescription?: Maybe<string>, address?: Maybe<string>, currency?: Maybe<string>, locale?: Maybe<string>, ownerName?: Maybe<string>, terms?: Maybe<string>, privacyPolicy?: Maybe<string>, returnPolicy?: Maybe<string>, shippingPolicy?: Maybe<string>, lastSync: string, installUrl?: Maybe<string>, phone?: Maybe<string>, providerPhone?: Maybe<string>, brandCellphone?: Maybe<string>, website?: Maybe<string>, websiteOverride?: Maybe<string>, brandWebsite?: Maybe<string>, email?: Maybe<string>, providerEmail?: Maybe<string>, brandEmail?: Maybe<string>, facebook?: Maybe<string>, instagram?: Maybe<string>, commission: number, adminEmails: Array<string>, hiddenFields: Array<BrandContactFields>, vatNumber?: Maybe<string>, productSort: BrandProductSortEnum, productSortFriendly: string, recommendedProductTags: Array<string>, leadTimeDays?: Maybe<number>, tags: Array<{ __typename: 'Tag', id: string, name: string, description?: Maybe<string>, createdAt: any, updatedAt: any, category?: Maybe<TagCategory>, categoryLabel?: Maybe<string>, meta?: Maybe<any>, types: Array<{ __typename: 'TagType', name: TagTypeEnum }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }>, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, images: Array<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredPortrait?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, featuredLandscape?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }>, meta?: Maybe<{ __typename: 'BrandMeta', includeRecentlySold?: Maybe<boolean>, location?: Maybe<string>, fields?: Maybe<Array<{ __typename: 'Field', title: string, link: string, isExternal?: Maybe<boolean> }>> }>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }>, paymentTerms?: Maybe<{ __typename: 'PaymentTerms', unit: number, amount: string }>, bankDetails?: Maybe<{ __typename: 'BankDetails', accountNumber?: Maybe<string>, branchCode?: Maybe<string>, bankName?: Maybe<string> }>, shopify?: Maybe<{ __typename: 'Shopify', id: string, appId?: Maybe<string>, domain: string }>, invoiceAddress?: Maybe<{ __typename: 'BrandAddress', address1: string, address2?: Maybe<string>, city: string, province: string, zip: string }>, locations: Array<{ __typename: 'LocationDTO', id?: Maybe<number>, name?: Maybe<string>, address1?: Maybe<string> }>, sizingGuide?: Maybe<{ __typename: 'SizingGuide', id: string, name: string }> }> };

export type ProductSortQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductSortQuery = { __typename: 'Query', brandProductSortOptions: Array<{ __typename: 'BrandProductSortOption', label: string, value: string }> };

export type StatisticsQueryVariables = Exact<{
  limit: Scalars['Int'];
  offset: Scalars['Int'];
}>;


export type StatisticsQuery = { __typename: 'Query', statistics: { __typename: 'Statistics', sales: { __typename: 'SalesStatistics', revenue: number, salesPerDay: number, salesPerUser: number, activeCarts: { __typename: 'CartStatistics', numOrders: number, value: number, averageBasketSize: number }, completedOrders: { __typename: 'CartStatistics', numOrders: number, value: number, averageBasketSize: number }, topBrands: Array<{ __typename: 'TopBrands', numOrders: number, brand: { __typename: 'Brand', id: string, brandName?: Maybe<string> } }>, topProducts: Array<{ __typename: 'TopProducts', numOrders: number, product: { __typename: 'DashboardProduct', id: string, productTitle: string, brand: { __typename: 'Brand', brandName?: Maybe<string> } } }>, rollingSum: Array<{ __typename: 'DataPoint', day: any, total: number }> }, users: { __typename: 'UserStatistics', signups: number, signupsPerDay: number, wishlists: { __typename: 'WishlistStats', total: number, numberOfUsers: number } }, brandSales: Array<{ __typename: 'BrandSales', name: string, numOrders: number, numProductsSold: number }> } };

export type CreateMessageMutationVariables = Exact<{
  input: CreateMessageInput;
}>;


export type CreateMessageMutation = { __typename: 'Mutation', createMessage: { __typename: 'Message', id: string, name: string } };

export type DeleteMessageMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMessageMutation = { __typename: 'Mutation', removeMessage: boolean };

export type UpdateMessageMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateMessageInput;
}>;


export type UpdateMessageMutation = { __typename: 'Mutation', updateMessage: { __typename: 'Message', id: string, name: string, title: string, body: string, contentId?: Maybe<string>, notificationTitle: string, notificationBody: string, enabled: boolean, meta?: Maybe<{ __typename: 'MessageMeta', deeplink: string }> } };

export type MessagesQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<MessageFilter>;
  sorting?: Maybe<Array<MessageSort> | MessageSort>;
}>;


export type MessagesQuery = { __typename: 'Query', messages: { __typename: 'MessageConnection', edges: Array<{ __typename: 'MessageEdge', node: { __typename: 'Message', id: string, name: string, createdAt?: Maybe<any>, updatedAt?: Maybe<any>, title: string, enabled: boolean, contentId?: Maybe<string> } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type MessageFieldsFragment = { __typename: 'Message', id: string, name: string, title: string, body: string, contentId?: Maybe<string>, notificationTitle: string, notificationBody: string, enabled: boolean, meta?: Maybe<{ __typename: 'MessageMeta', deeplink: string }> };

export type MessageQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MessageQuery = { __typename: 'Query', message?: Maybe<{ __typename: 'Message', id: string, name: string, title: string, body: string, contentId?: Maybe<string>, notificationTitle: string, notificationBody: string, enabled: boolean, meta?: Maybe<{ __typename: 'MessageMeta', deeplink: string }> }> };

export type CreateMessageCampaignMutationVariables = Exact<{
  input: CreateMessageCampaignInput;
}>;


export type CreateMessageCampaignMutation = { __typename: 'Mutation', createMessageCampaign: { __typename: 'MessageCampaign', id: string, name: string, scheduledAt?: Maybe<any> } };

export type DeleteMessageCampaignMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteMessageCampaignMutation = { __typename: 'Mutation', removeMessageCampaign: boolean };

export type UpdateMessageCampaignMutationVariables = Exact<{
  id: Scalars['String'];
  input: UpdateMessageCampaignInput;
}>;


export type UpdateMessageCampaignMutation = { __typename: 'Mutation', updateMessageCampaign: { __typename: 'MessageCampaign', id: string, name: string, scheduledAt?: Maybe<any> } };

export type MessageCampaignsQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<MessageCampaignDtoFilter>;
  sorting?: Maybe<Array<MessageCampaignDtoSort> | MessageCampaignDtoSort>;
}>;


export type MessageCampaignsQuery = { __typename: 'Query', messageCampaigns: { __typename: 'MessageCampaignDTOConnection', edges: Array<{ __typename: 'MessageCampaignDTOEdge', node: { __typename: 'MessageCampaignDTO', id: string, name: string, createdAt: any, sentAt?: Maybe<any>, scheduledAt?: Maybe<any>, nextRunAt?: Maybe<any>, interval?: Maybe<CampaignInterval>, type: CampaignType, message?: Maybe<{ __typename: 'Message', name: string }> } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type MessageCampaignFieldsFragment = { __typename: 'MessageCampaignDTO', id: string, name: string, scheduledAt?: Maybe<any>, comment?: Maybe<string>, sentAt?: Maybe<any>, channels: Array<MessageChannels>, accountGroupOperator: Operator, type: CampaignType, interval?: Maybe<CampaignInterval>, timeToRun?: Maybe<any>, nextRunAt?: Maybe<any>, message?: Maybe<{ __typename: 'Message', id: string, name: string, title: string }>, accountGroups: Array<{ __typename: 'AccountGroup', id: string, name: string }> };

export type MessageCampaignQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type MessageCampaignQuery = { __typename: 'Query', messageCampaign?: Maybe<{ __typename: 'MessageCampaignDTO', id: string, name: string, scheduledAt?: Maybe<any>, comment?: Maybe<string>, sentAt?: Maybe<any>, channels: Array<MessageChannels>, accountGroupOperator: Operator, type: CampaignType, interval?: Maybe<CampaignInterval>, timeToRun?: Maybe<any>, nextRunAt?: Maybe<any>, message?: Maybe<{ __typename: 'Message', id: string, name: string, title: string }>, accountGroups: Array<{ __typename: 'AccountGroup', id: string, name: string }> }> };

export type OrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderQuery = { __typename: 'Query', order?: Maybe<{ __typename: 'Order', useCredit: boolean, totalPaid: number, creditUsed: number, id: string, createdAt: any, updatedAt: any, orderDate?: Maybe<any>, isActive: boolean, subTotal: number, orderNumber: number, productCount: number, status: string, shippingAddress?: Maybe<{ __typename: 'OrderAddress', firstName?: Maybe<string>, lastName?: Maybe<string>, addressLine1: string, addressLine2?: Maybe<string>, suburb?: Maybe<string>, city: string, province: string, postalCode: string, country: string, phone?: Maybe<string>, note?: Maybe<string> }>, billingAddress?: Maybe<{ __typename: 'OrderAddress', addressLine1: string, addressLine2?: Maybe<string>, suburb?: Maybe<string>, city: string, province: string, postalCode: string, country: string, phone?: Maybe<string>, note?: Maybe<string> }>, lines: Array<{ __typename: 'OrderLine', id: string, subTotal: number, shippingHandle?: Maybe<string>, shippingTotal?: Maybe<number>, status: string, paymentDate?: Maybe<any>, invoiceUrl?: Maybe<string>, paymentAdviceUrl?: Maybe<string>, orderStatus?: Maybe<{ __typename: 'ShopifyOrder', status?: Maybe<string>, shippingStatus: string, confirmed?: Maybe<boolean>, orderReference?: Maybe<string> }>, issues: { __typename: 'OrderLinesIssues', error: string }, brand: { __typename: 'Brand', id: string, brandName?: Maybe<string>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> }, items: Array<{ __typename: 'OrderItem', id: string, quantity: number, price: number, productVariant: { __typename: 'ProductVariant', id: string, title: string, stockStatus: StockStatus, product?: Maybe<{ __typename: 'Product', id: string, productTitle?: Maybe<string>, stockStatus: StockStatus, status: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } }>, ledgerItems: Array<{ __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> }>, shippingMethods: Array<{ __typename: 'OrderLineShippingMethods', title: string, id: string, price: { __typename: 'PriceFormat', amount: string, currencyCode: string } }> }>, payments: Array<{ __typename: 'Payment', id: string, amount: number, createdAt?: Maybe<any>, method: string, state: string }>, customer?: Maybe<{ __typename: 'Customer', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, accountId?: Maybe<string>, email: string, mobile?: Maybe<string> }>, metadata: { __typename: 'OrderMetadata', checkout?: Maybe<{ __typename: 'OrderMetaFields', platform?: Maybe<string> }> } }> };

export type AccountingCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountingCodesQuery = { __typename: 'Query', accountingCodes: Array<{ __typename: 'AccountCode', id: number, code: string, description: string }> };

export type CreateLedgerItemMutationVariables = Exact<{
  orderLineId: Scalars['String'];
  input: OrderLineLedgerInput;
}>;


export type CreateLedgerItemMutation = { __typename: 'Mutation', createLedgerItem: { __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> } };

export type UpdateLedgerItemMutationVariables = Exact<{
  id: Scalars['String'];
  input: OrderLineLedgerInput;
}>;


export type UpdateLedgerItemMutation = { __typename: 'Mutation', updateLedgerEntry: { __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> } };

export type DeleteLedgerItemMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteLedgerItemMutation = { __typename: 'Mutation', deleteLedgerEntry: boolean };

export type ExportOrdersMutationVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<OrderFilter>;
  sorting?: Maybe<Array<OrderSort> | OrderSort>;
}>;


export type ExportOrdersMutation = { __typename: 'Mutation', exportOrders: boolean };

export type PaymentRequirementsMutationVariables = Exact<{ [key: string]: never; }>;


export type PaymentRequirementsMutation = { __typename: 'Mutation', paymentRequirements: boolean };

export type SalesCommissionReportMutationVariables = Exact<{ [key: string]: never; }>;


export type SalesCommissionReportMutation = { __typename: 'Mutation', salesCommissionReport: boolean };

export type RemoveTagsFromProductsMutationVariables = Exact<{
  input: RemoveTagsFromProducts;
}>;


export type RemoveTagsFromProductsMutation = { __typename: 'Mutation', removeTagsFromProducts: boolean };

export type AddTagsToProductsMutationVariables = Exact<{
  input: AddTagsToProducts;
}>;


export type AddTagsToProductsMutation = { __typename: 'Mutation', addTagsToProducts: boolean };

export type RefundQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RefundQuery = { __typename: 'Query', refund?: Maybe<{ __typename: 'Refund', id: string, createdAt: any, updatedAt: any, state: string, basketAmount: number, adjustmentAmount?: Maybe<number>, note?: Maybe<string>, orderLine?: Maybe<{ __typename: 'OrderLine', id: string, subTotal: number, shippingHandle?: Maybe<string>, shippingTotal?: Maybe<number>, status: string, paymentDate?: Maybe<any>, invoiceUrl?: Maybe<string>, paymentAdviceUrl?: Maybe<string>, order: { __typename: 'Order', id: string, orderNumber: number, orderDate?: Maybe<any>, status: string, createdAt: any, updatedAt: any, creditUsed: number, subTotal: number, totalPaid: number, productCount: number, customer?: Maybe<{ __typename: 'Customer', id?: Maybe<string>, firstName?: Maybe<string>, lastName?: Maybe<string>, accountId?: Maybe<string>, email: string, mobile?: Maybe<string> }>, shippingAddress?: Maybe<{ __typename: 'OrderAddress', addressLine1: string, addressLine2?: Maybe<string>, suburb?: Maybe<string>, city: string, province: string, postalCode: string, country: string, phone?: Maybe<string>, note?: Maybe<string> }>, billingAddress?: Maybe<{ __typename: 'OrderAddress', addressLine1: string, addressLine2?: Maybe<string>, suburb?: Maybe<string>, city: string, province: string, postalCode: string, country: string, phone?: Maybe<string>, note?: Maybe<string> }>, payments: Array<{ __typename: 'Payment', id: string, amount: number, createdAt?: Maybe<any>, method: string, state: string }>, lines: Array<{ __typename: 'OrderLine', id: string }> }, orderStatus?: Maybe<{ __typename: 'ShopifyOrder', status?: Maybe<string>, shippingStatus: string, confirmed?: Maybe<boolean>, orderReference?: Maybe<string> }>, issues: { __typename: 'OrderLinesIssues', error: string }, brand: { __typename: 'Brand', id: string, brandName?: Maybe<string>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> }, items: Array<{ __typename: 'OrderItem', id: string, quantity: number, price: number, productVariant: { __typename: 'ProductVariant', id: string, title: string, stockStatus: StockStatus, product?: Maybe<{ __typename: 'Product', id: string, productTitle?: Maybe<string>, stockStatus: StockStatus, status: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } }>, ledgerItems: Array<{ __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> }>, shippingMethods: Array<{ __typename: 'OrderLineShippingMethods', title: string, id: string, price: { __typename: 'PriceFormat', amount: string, currencyCode: string } }> }> }> };

export type UpdaterOrderLinePaymentDateMutationVariables = Exact<{
  input: OrderLinePaymentDateInput;
}>;


export type UpdaterOrderLinePaymentDateMutation = { __typename: 'Mutation', updateOrderLinePaymentDate: { __typename: 'OrderLine', id: string, subTotal: number, shippingHandle?: Maybe<string>, shippingTotal?: Maybe<number>, status: string, paymentDate?: Maybe<any>, invoiceUrl?: Maybe<string>, paymentAdviceUrl?: Maybe<string>, orderStatus?: Maybe<{ __typename: 'ShopifyOrder', status?: Maybe<string>, shippingStatus: string, confirmed?: Maybe<boolean>, orderReference?: Maybe<string> }>, issues: { __typename: 'OrderLinesIssues', error: string }, brand: { __typename: 'Brand', id: string, brandName?: Maybe<string>, notes?: Maybe<{ __typename: 'Notes', product?: Maybe<string>, cart?: Maybe<string>, alert?: Maybe<string>, checkout?: Maybe<string>, shipping?: Maybe<string>, freeShippingThreshold?: Maybe<string> }> }, items: Array<{ __typename: 'OrderItem', id: string, quantity: number, price: number, productVariant: { __typename: 'ProductVariant', id: string, title: string, stockStatus: StockStatus, product?: Maybe<{ __typename: 'Product', id: string, productTitle?: Maybe<string>, stockStatus: StockStatus, status: string, image?: Maybe<{ __typename: 'Image', id: string, key?: Maybe<string>, url: string, sourceType: string }> }> } }>, ledgerItems: Array<{ __typename: 'OrderLedger', id?: Maybe<string>, code: string, createdAt: any, isCredit?: Maybe<boolean>, amount: number, description?: Maybe<string>, isSystem?: Maybe<boolean> }>, shippingMethods: Array<{ __typename: 'OrderLineShippingMethods', title: string, id: string, price: { __typename: 'PriceFormat', amount: string, currencyCode: string } }> } };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetOnePasswordInput;
}>;


export type ResetPasswordMutation = { __typename: 'Mutation', resetOnePassword: boolean };

export type CreateTriggerMutationVariables = Exact<{
  input: CreateTriggerInput;
}>;


export type CreateTriggerMutation = { __typename: 'Mutation', createTrigger: { __typename: 'Trigger', id: string } };

export type DeleteTriggerMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteTriggerMutation = { __typename: 'Mutation', deleteTrigger: boolean };

export type UpdateTriggerMutationVariables = Exact<{
  id: Scalars['ID'];
  input: UpdateTriggerInput;
}>;


export type UpdateTriggerMutation = { __typename: 'Mutation', updateTrigger: { __typename: 'Trigger', id: string } };

export type TriggersQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<TriggerFilter>;
  sorting?: Maybe<Array<TriggerSort> | TriggerSort>;
}>;


export type TriggersQuery = { __typename: 'Query', triggers: { __typename: 'TriggerConnection', edges: Array<{ __typename: 'TriggerEdge', node: { __typename: 'Trigger', id: string, name: string, enabled: boolean, eventType: AccountEventType, createdAt: any, updatedAt: any } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> } } };

export type TriggerFieldsFragment = { __typename: 'Trigger', id: string, name: string, eventType: AccountEventType, enabled: boolean, criteria: any, createdAt: any, updatedAt: any, actions: Array<{ __typename: 'Action', id: string, name: string, type: ActionEventType, enabled: boolean, messageId?: Maybe<string>, channels?: Maybe<Array<MessageChannels>>, createdAt: any, updatedAt: any, voucherValue?: Maybe<number>, voucherMessage?: Maybe<string>, expiryDate?: Maybe<any>, message?: Maybe<{ __typename: 'Message', id: string, name: string }>, delay?: Maybe<{ __typename: 'Delay', unit: string, value: number }> }>, accountGroups?: Maybe<Array<{ __typename: 'AccountGroup', id: string, name: string }>> };

export type TriggerQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type TriggerQuery = { __typename: 'Query', trigger?: Maybe<{ __typename: 'Trigger', id: string, name: string, eventType: AccountEventType, enabled: boolean, criteria: any, createdAt: any, updatedAt: any, actions: Array<{ __typename: 'Action', id: string, name: string, type: ActionEventType, enabled: boolean, messageId?: Maybe<string>, channels?: Maybe<Array<MessageChannels>>, createdAt: any, updatedAt: any, voucherValue?: Maybe<number>, voucherMessage?: Maybe<string>, expiryDate?: Maybe<any>, message?: Maybe<{ __typename: 'Message', id: string, name: string }>, delay?: Maybe<{ __typename: 'Delay', unit: string, value: number }> }>, accountGroups?: Maybe<Array<{ __typename: 'AccountGroup', id: string, name: string }>> }> };

export type PermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type PermissionsQuery = { __typename: 'Query', permissions: Array<{ __typename: 'AccountPermissionDTO', label: string, value: AccountPermission }> };

export type UpdateAccountGroupUsersMutationVariables = Exact<{
  ids: Array<Scalars['String']> | Scalars['String'];
  accountGroupId: Scalars['String'];
  action: AccountsAction;
}>;


export type UpdateAccountGroupUsersMutation = { __typename: 'Mutation', updateAccountGroupUsers: boolean };

export type UpdateOneVoucherMutationVariables = Exact<{
  input: UpdateOneVoucherInput;
}>;


export type UpdateOneVoucherMutation = { __typename: 'Mutation', updateOneVoucher: { __typename: 'Voucher', id: string, status: VoucherStatus, expiryDate: any } };

export type VouchersQueryVariables = Exact<{
  paging?: Maybe<CursorPaging>;
  filter?: Maybe<VoucherFilter>;
  sorting?: Maybe<Array<VoucherSort> | VoucherSort>;
}>;


export type VouchersQuery = { __typename: 'Query', vouchers: { __typename: 'VoucherConnection', pageInfo: { __typename: 'PageInfo', hasNextPage?: Maybe<boolean>, hasPreviousPage?: Maybe<boolean>, startCursor?: Maybe<any>, endCursor?: Maybe<any> }, edges: Array<{ __typename: 'VoucherEdge', node: { __typename: 'Voucher', id: string, voucherNumber: number, code: string, value: number, recipientEmail?: Maybe<string>, createdAt: any, status: VoucherStatus, expiryDate: any, reason?: Maybe<string>, createdBy?: Maybe<{ __typename: 'Account', id: string, email: string }> } }> } };

export type ResendVoucherMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type ResendVoucherMutation = { __typename: 'Mutation', resendVoucher: boolean };

export type CreateVouchersMutationVariables = Exact<{
  input: CreateVouchersInput;
}>;


export type CreateVouchersMutation = { __typename: 'Mutation', createVouchers: boolean };

export type VoucherDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type VoucherDashboardQuery = { __typename: 'Query', voucherStats: { __typename: 'VoucherStats', totalSales: number, totalIssued: number, averageSalesPerDay: number, totalWalletBalance: string, unredeemedAmounts: { __typename: 'UnredeemedAmounts', internal: number, purchased: number }, dailySales: Array<{ __typename: 'DataPoint', day: any, total: number }>, internal: { __typename: 'InternalStats', created: { __typename: 'TimePeriods', total: number, month: number }, available: { __typename: 'TimePeriods', total: number, month: number }, used: { __typename: 'TimePeriods', total: number, month: number } } } };

export const AccountFieldsFragmentDoc = gql`
    fragment AccountFields on Account {
  id
  email
  firstName
  lastName
  status
  enabled
  roles
  createdAt
  permissions
}
    `;
export const BrandMetaFieldsFragmentDoc = gql`
    fragment BrandMetaFields on BrandMeta {
  fields {
    title
    link
    isExternal
  }
  includeRecentlySold
  location
}
    `;
export const NotesFieldsFragmentDoc = gql`
    fragment NotesFields on Notes {
  product
  cart
  alert
  checkout
  shipping
  freeShippingThreshold
}
    `;
export const BrandDetailFieldsFragmentDoc = gql`
    fragment BrandDetailFields on Brand {
  description
  providerDescription
  brandDescription
  address
  currency
  locale
  ownerName
  terms
  privacyPolicy
  returnPolicy
  shippingPolicy
  lastSync
  installUrl
  phone
  providerPhone
  brandCellphone
  website
  websiteOverride
  brandWebsite
  email
  providerEmail
  brandEmail
  facebook
  instagram
  meta {
    ...BrandMetaFields
  }
  notes {
    ...NotesFields
  }
  commission
  paymentTerms {
    unit
    amount
  }
  bankDetails {
    accountNumber
    branchCode
    bankName
  }
  shopify {
    id
    appId
    domain
  }
  adminEmails
  hiddenFields
  vatNumber
  invoiceAddress {
    address1
    address2
    city
    province
    zip
  }
  productSort
  productSortFriendly
  recommendedProductTags
  hiddenFields
  locations {
    id
    name
    address1
  }
  sizingGuide {
    id
    name
  }
  leadTimeDays
}
    ${BrandMetaFieldsFragmentDoc}
${NotesFieldsFragmentDoc}`;
export const ImageFieldsFragmentDoc = gql`
    fragment ImageFields on Image {
  id
  key
  url
  sourceType
}
    `;
export const TagFieldsFragmentDoc = gql`
    fragment TagFields on Tag {
  id
  name
  description
  types {
    name
  }
  createdAt
  updatedAt
  category
  categoryLabel
  image {
    ...ImageFields
  }
  meta
}
    ${ImageFieldsFragmentDoc}`;
export const BrandFieldsFragmentDoc = gql`
    fragment BrandFields on Brand {
  id
  name
  providerName
  brandName
  enabled
  verified
  marketingName
  marketingDescription
  marketingColor
  tags {
    ...TagFields
  }
  image {
    ...ImageFields
  }
  images {
    ...ImageFields
  }
  featuredPortrait {
    ...ImageFields
  }
  featuredLandscape {
    ...ImageFields
  }
}
    ${TagFieldsFragmentDoc}
${ImageFieldsFragmentDoc}`;
export const OptionNameFieldsFragmentDoc = gql`
    fragment OptionNameFields on OptionName {
  id
  name
}
    `;
export const OptionFieldsFragmentDoc = gql`
    fragment OptionFields on ProductOption {
  id
  value
  name {
    ...OptionNameFields
  }
}
    ${OptionNameFieldsFragmentDoc}`;
export const VariantFieldsFragmentDoc = gql`
    fragment VariantFields on ProductVariant {
  id
  title
  price
  inventory
  sku
  inventoryPolicy
}
    `;
export const MetaFieldsFragmentDoc = gql`
    fragment MetaFields on Meta {
  fields {
    title
    link
    isExternal
  }
}
    `;
export const ProductFieldsFragmentDoc = gql`
    fragment ProductFields on Product {
  id
  title
  providerTitle
  productTitle
  description
  providerId
  providerDescription
  productDescription
  description
  tracksInventory
  image {
    ...ImageFields
  }
  images {
    ...ImageFields
  }
  providerImages {
    ...ImageFields
  }
  enabled
  createdAt
  updatedAt
  brand {
    ...BrandFields
  }
  options {
    ...OptionFields
  }
  variants {
    ...VariantFields
    selectedOptions {
      name
      value
    }
    images {
      ...ImageFields
    }
  }
  tags {
    ...TagFields
  }
  providerTags
  providerImage
  providerImages {
    url
  }
  isAutoPublish
  isImageContained
  sizingGuide {
    id
    name
  }
  meta {
    ...MetaFields
  }
  notes {
    ...NotesFields
  }
}
    ${ImageFieldsFragmentDoc}
${BrandFieldsFragmentDoc}
${OptionFieldsFragmentDoc}
${VariantFieldsFragmentDoc}
${TagFieldsFragmentDoc}
${MetaFieldsFragmentDoc}
${NotesFieldsFragmentDoc}`;
export const PagingFieldsFragmentDoc = gql`
    fragment PagingFields on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
    `;
export const AccountingCodeFieldsFragmentDoc = gql`
    fragment AccountingCodeFields on AccountCode {
  id
  code
  description
}
    `;
export const BaseOrderFieldsFragmentDoc = gql`
    fragment BaseOrderFields on Order {
  id
  createdAt
  updatedAt
  orderDate
  isActive
  subTotal
  orderNumber
  productCount
  status
  shippingAddress {
    firstName
    lastName
  }
  customer {
    id
    firstName
    lastName
    accountId
    email
    mobile
  }
  metadata {
    checkout {
      platform
    }
  }
}
    `;
export const OrderAddressFieldsFragmentDoc = gql`
    fragment OrderAddressFields on OrderAddress {
  addressLine1
  addressLine2
  suburb
  city
  province
  postalCode
  country
  phone
  note
}
    `;
export const OrderLedgerFieldsFragmentDoc = gql`
    fragment OrderLedgerFields on OrderLedger {
  id
  code
  createdAt
  isCredit
  amount
  description
  isSystem
}
    `;
export const OrderLineFieldsFragmentDoc = gql`
    fragment OrderLineFields on OrderLine {
  id
  subTotal
  shippingHandle
  shippingTotal
  status
  paymentDate
  orderStatus {
    status
    shippingStatus
    confirmed
    orderReference
  }
  issues {
    error
  }
  brand {
    id
    brandName
    notes {
      product
      cart
      alert
      checkout
      shipping
      freeShippingThreshold
    }
  }
  items {
    id
    quantity
    price
    productVariant {
      id
      title
      stockStatus
      product {
        id
        productTitle
        stockStatus
        status
        image {
          ...ImageFields
        }
      }
    }
  }
  ledgerItems {
    ...OrderLedgerFields
  }
  shippingMethods {
    title
    price {
      amount
      currencyCode
    }
    id: handle
  }
  invoiceUrl
  paymentAdviceUrl
}
    ${ImageFieldsFragmentDoc}
${OrderLedgerFieldsFragmentDoc}`;
export const OrderFieldsFragmentDoc = gql`
    fragment OrderFields on Order {
  ...BaseOrderFields
  useCredit
  totalPaid
  creditUsed
  shippingAddress {
    ...OrderAddressFields
  }
  billingAddress {
    ...OrderAddressFields
  }
  lines {
    ...OrderLineFields
  }
  payments {
    id
    amount
    createdAt
    method
    state
  }
}
    ${BaseOrderFieldsFragmentDoc}
${OrderAddressFieldsFragmentDoc}
${OrderLineFieldsFragmentDoc}`;
export const ProductTableFieldsFragmentDoc = gql`
    fragment ProductTableFields on Product {
  id
  productTitle
  image {
    ...ImageFields
  }
  brand {
    brandName
  }
  enabled
  tags {
    ...TagFields
  }
}
    ${ImageFieldsFragmentDoc}
${TagFieldsFragmentDoc}`;
export const RefundFieldsFragmentDoc = gql`
    fragment RefundFields on Refund {
  id
  createdAt
  updatedAt
  state
  basketAmount
  adjustmentAmount
  note
  orderLine {
    ...OrderLineFields
    order {
      id
      orderNumber
      orderDate
      status
      createdAt
      updatedAt
      creditUsed
      subTotal
      totalPaid
      customer {
        id
        firstName
        lastName
        accountId
        email
        mobile
      }
      shippingAddress {
        ...OrderAddressFields
      }
      billingAddress {
        ...OrderAddressFields
      }
      payments {
        id
        amount
        createdAt
        method
        state
      }
      lines {
        id
      }
      productCount
    }
  }
}
    ${OrderLineFieldsFragmentDoc}
${OrderAddressFieldsFragmentDoc}`;
export const AccountGroupFieldsFragmentDoc = gql`
    fragment AccountGroupFields on AccountGroup {
  id
  name
  description
  definition
}
    `;
export const MessageFieldsFragmentDoc = gql`
    fragment MessageFields on Message {
  id
  name
  title
  body
  contentId
  notificationTitle
  notificationBody
  enabled
  meta {
    deeplink
  }
}
    `;
export const MessageCampaignFieldsFragmentDoc = gql`
    fragment MessageCampaignFields on MessageCampaignDTO {
  id
  name
  scheduledAt
  comment
  sentAt
  message {
    id
    name
    title
  }
  accountGroups {
    id
    name
  }
  channels
  accountGroupOperator
  type
  interval
  timeToRun
  nextRunAt
}
    `;
export const TriggerFieldsFragmentDoc = gql`
    fragment TriggerFields on Trigger {
  id
  name
  eventType
  enabled
  actions {
    id
    name
    type
    enabled
    message {
      id
      name
    }
    messageId
    channels
    createdAt
    updatedAt
    voucherValue
    voucherMessage
    expiryDate
    delay {
      unit
      value
    }
  }
  accountGroups {
    id
    name
  }
  criteria
  createdAt
  updatedAt
}
    `;
export const AccountEventOptionsDocument = gql`
    query AccountEventOptions {
  accountEventOptions
}
    `;

/**
 * __useAccountEventOptionsQuery__
 *
 * To run a query within a React component, call `useAccountEventOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountEventOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountEventOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountEventOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountEventOptionsQuery, AccountEventOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountEventOptionsQuery, AccountEventOptionsQueryVariables>(AccountEventOptionsDocument, options);
      }
export function useAccountEventOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountEventOptionsQuery, AccountEventOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountEventOptionsQuery, AccountEventOptionsQueryVariables>(AccountEventOptionsDocument, options);
        }
export type AccountEventOptionsQueryHookResult = ReturnType<typeof useAccountEventOptionsQuery>;
export type AccountEventOptionsLazyQueryHookResult = ReturnType<typeof useAccountEventOptionsLazyQuery>;
export type AccountEventOptionsQueryResult = Apollo.QueryResult<AccountEventOptionsQuery, AccountEventOptionsQueryVariables>;
export const AllAccountGroupsDocument = gql`
    query AllAccountGroups {
  allAccountGroups {
    id
    name
  }
}
    `;

/**
 * __useAllAccountGroupsQuery__
 *
 * To run a query within a React component, call `useAllAccountGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAccountGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAccountGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAccountGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllAccountGroupsQuery, AllAccountGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllAccountGroupsQuery, AllAccountGroupsQueryVariables>(AllAccountGroupsDocument, options);
      }
export function useAllAccountGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllAccountGroupsQuery, AllAccountGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllAccountGroupsQuery, AllAccountGroupsQueryVariables>(AllAccountGroupsDocument, options);
        }
export type AllAccountGroupsQueryHookResult = ReturnType<typeof useAllAccountGroupsQuery>;
export type AllAccountGroupsLazyQueryHookResult = ReturnType<typeof useAllAccountGroupsLazyQuery>;
export type AllAccountGroupsQueryResult = Apollo.QueryResult<AllAccountGroupsQuery, AllAccountGroupsQueryVariables>;
export const AccountGroupConfigDocument = gql`
    query AccountGroupConfig {
  accountGroupConfig {
    fields
  }
}
    `;

/**
 * __useAccountGroupConfigQuery__
 *
 * To run a query within a React component, call `useAccountGroupConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountGroupConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountGroupConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountGroupConfigQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountGroupConfigQuery, AccountGroupConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountGroupConfigQuery, AccountGroupConfigQueryVariables>(AccountGroupConfigDocument, options);
      }
export function useAccountGroupConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountGroupConfigQuery, AccountGroupConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountGroupConfigQuery, AccountGroupConfigQueryVariables>(AccountGroupConfigDocument, options);
        }
export type AccountGroupConfigQueryHookResult = ReturnType<typeof useAccountGroupConfigQuery>;
export type AccountGroupConfigLazyQueryHookResult = ReturnType<typeof useAccountGroupConfigLazyQuery>;
export type AccountGroupConfigQueryResult = Apollo.QueryResult<AccountGroupConfigQuery, AccountGroupConfigQueryVariables>;
export const ProcessBrandStatementDocument = gql`
    mutation ProcessBrandStatement($startDate: String!, $endDate: String!, $brandId: String!, $sendToBrand: Boolean!) {
  processBrandStatement(
    startDate: $startDate
    endDate: $endDate
    brandId: $brandId
    sendToBrand: $sendToBrand
  )
}
    `;
export type ProcessBrandStatementMutationFn = Apollo.MutationFunction<ProcessBrandStatementMutation, ProcessBrandStatementMutationVariables>;

/**
 * __useProcessBrandStatementMutation__
 *
 * To run a mutation, you first call `useProcessBrandStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessBrandStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processBrandStatementMutation, { data, loading, error }] = useProcessBrandStatementMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      brandId: // value for 'brandId'
 *      sendToBrand: // value for 'sendToBrand'
 *   },
 * });
 */
export function useProcessBrandStatementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProcessBrandStatementMutation, ProcessBrandStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProcessBrandStatementMutation, ProcessBrandStatementMutationVariables>(ProcessBrandStatementDocument, options);
      }
export type ProcessBrandStatementMutationHookResult = ReturnType<typeof useProcessBrandStatementMutation>;
export type ProcessBrandStatementMutationResult = Apollo.MutationResult<ProcessBrandStatementMutation>;
export type ProcessBrandStatementMutationOptions = Apollo.BaseMutationOptions<ProcessBrandStatementMutation, ProcessBrandStatementMutationVariables>;
export const ActionTypeOptionsDocument = gql`
    query ActionTypeOptions {
  actionTypeOptions
}
    `;

/**
 * __useActionTypeOptionsQuery__
 *
 * To run a query within a React component, call `useActionTypeOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionTypeOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionTypeOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActionTypeOptionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ActionTypeOptionsQuery, ActionTypeOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActionTypeOptionsQuery, ActionTypeOptionsQueryVariables>(ActionTypeOptionsDocument, options);
      }
export function useActionTypeOptionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActionTypeOptionsQuery, ActionTypeOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActionTypeOptionsQuery, ActionTypeOptionsQueryVariables>(ActionTypeOptionsDocument, options);
        }
export type ActionTypeOptionsQueryHookResult = ReturnType<typeof useActionTypeOptionsQuery>;
export type ActionTypeOptionsLazyQueryHookResult = ReturnType<typeof useActionTypeOptionsLazyQuery>;
export type ActionTypeOptionsQueryResult = Apollo.QueryResult<ActionTypeOptionsQuery, ActionTypeOptionsQueryVariables>;
export const UpdateConfigDocument = gql`
    mutation UpdateConfig($id: String!, $input: UpdateConfigInput!) {
  updateConfig(id: $id, input: $input)
}
    `;
export type UpdateConfigMutationFn = Apollo.MutationFunction<UpdateConfigMutation, UpdateConfigMutationVariables>;

/**
 * __useUpdateConfigMutation__
 *
 * To run a mutation, you first call `useUpdateConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConfigMutation, { data, loading, error }] = useUpdateConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateConfigMutation, UpdateConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateConfigMutation, UpdateConfigMutationVariables>(UpdateConfigDocument, options);
      }
export type UpdateConfigMutationHookResult = ReturnType<typeof useUpdateConfigMutation>;
export type UpdateConfigMutationResult = Apollo.MutationResult<UpdateConfigMutation>;
export type UpdateConfigMutationOptions = Apollo.BaseMutationOptions<UpdateConfigMutation, UpdateConfigMutationVariables>;
export const GetAppVersionDocument = gql`
    query GetAppVersion {
  configValue(name: "minimum_app_version") {
    id
    value
  }
}
    `;

/**
 * __useGetAppVersionQuery__
 *
 * To run a query within a React component, call `useGetAppVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppVersionQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAppVersionQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAppVersionQuery, GetAppVersionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAppVersionQuery, GetAppVersionQueryVariables>(GetAppVersionDocument, options);
      }
export function useGetAppVersionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAppVersionQuery, GetAppVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAppVersionQuery, GetAppVersionQueryVariables>(GetAppVersionDocument, options);
        }
export type GetAppVersionQueryHookResult = ReturnType<typeof useGetAppVersionQuery>;
export type GetAppVersionLazyQueryHookResult = ReturnType<typeof useGetAppVersionLazyQuery>;
export type GetAppVersionQueryResult = Apollo.QueryResult<GetAppVersionQuery, GetAppVersionQueryVariables>;
export const BrandPoliciesDocument = gql`
    query BrandPolicies($id: ID!) {
  policies(input: {id: $id}) {
    body
    url
    handle
  }
}
    `;

/**
 * __useBrandPoliciesQuery__
 *
 * To run a query within a React component, call `useBrandPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandPoliciesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBrandPoliciesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BrandPoliciesQuery, BrandPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandPoliciesQuery, BrandPoliciesQueryVariables>(BrandPoliciesDocument, options);
      }
export function useBrandPoliciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandPoliciesQuery, BrandPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandPoliciesQuery, BrandPoliciesQueryVariables>(BrandPoliciesDocument, options);
        }
export type BrandPoliciesQueryHookResult = ReturnType<typeof useBrandPoliciesQuery>;
export type BrandPoliciesLazyQueryHookResult = ReturnType<typeof useBrandPoliciesLazyQuery>;
export type BrandPoliciesQueryResult = Apollo.QueryResult<BrandPoliciesQuery, BrandPoliciesQueryVariables>;
export const UpdateShopifyDocument = gql`
    mutation UpdateShopify($id: String!, $update: ShopifyUpdate!) {
  updateShopify(id: $id, update: $update) {
    id
    domain
  }
}
    `;
export type UpdateShopifyMutationFn = Apollo.MutationFunction<UpdateShopifyMutation, UpdateShopifyMutationVariables>;

/**
 * __useUpdateShopifyMutation__
 *
 * To run a mutation, you first call `useUpdateShopifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShopifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShopifyMutation, { data, loading, error }] = useUpdateShopifyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateShopifyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateShopifyMutation, UpdateShopifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateShopifyMutation, UpdateShopifyMutationVariables>(UpdateShopifyDocument, options);
      }
export type UpdateShopifyMutationHookResult = ReturnType<typeof useUpdateShopifyMutation>;
export type UpdateShopifyMutationResult = Apollo.MutationResult<UpdateShopifyMutation>;
export type UpdateShopifyMutationOptions = Apollo.BaseMutationOptions<UpdateShopifyMutation, UpdateShopifyMutationVariables>;
export const RemoveItemDocument = gql`
    mutation RemoveItem($orderId: String!, $input: RemoveItemInput!) {
  removeItemFromOrder(orderId: $orderId, input: $input) {
    id
  }
}
    `;
export type RemoveItemMutationFn = Apollo.MutationFunction<RemoveItemMutation, RemoveItemMutationVariables>;

/**
 * __useRemoveItemMutation__
 *
 * To run a mutation, you first call `useRemoveItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeItemMutation, { data, loading, error }] = useRemoveItemMutation({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveItemMutation, RemoveItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveItemMutation, RemoveItemMutationVariables>(RemoveItemDocument, options);
      }
export type RemoveItemMutationHookResult = ReturnType<typeof useRemoveItemMutation>;
export type RemoveItemMutationResult = Apollo.MutationResult<RemoveItemMutation>;
export type RemoveItemMutationOptions = Apollo.BaseMutationOptions<RemoveItemMutation, RemoveItemMutationVariables>;
export const RemoveLineByIdDocument = gql`
    mutation RemoveLineById($lineId: String!) {
  removeLineById(id: $lineId) {
    id
  }
}
    `;
export type RemoveLineByIdMutationFn = Apollo.MutationFunction<RemoveLineByIdMutation, RemoveLineByIdMutationVariables>;

/**
 * __useRemoveLineByIdMutation__
 *
 * To run a mutation, you first call `useRemoveLineByIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLineByIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLineByIdMutation, { data, loading, error }] = useRemoveLineByIdMutation({
 *   variables: {
 *      lineId: // value for 'lineId'
 *   },
 * });
 */
export function useRemoveLineByIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveLineByIdMutation, RemoveLineByIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveLineByIdMutation, RemoveLineByIdMutationVariables>(RemoveLineByIdDocument, options);
      }
export type RemoveLineByIdMutationHookResult = ReturnType<typeof useRemoveLineByIdMutation>;
export type RemoveLineByIdMutationResult = Apollo.MutationResult<RemoveLineByIdMutation>;
export type RemoveLineByIdMutationOptions = Apollo.BaseMutationOptions<RemoveLineByIdMutation, RemoveLineByIdMutationVariables>;
export const MessageChannelsDocument = gql`
    query MessageChannels {
  messageChannels
}
    `;

/**
 * __useMessageChannelsQuery__
 *
 * To run a query within a React component, call `useMessageChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageChannelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMessageChannelsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessageChannelsQuery, MessageChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MessageChannelsQuery, MessageChannelsQueryVariables>(MessageChannelsDocument, options);
      }
export function useMessageChannelsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessageChannelsQuery, MessageChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MessageChannelsQuery, MessageChannelsQueryVariables>(MessageChannelsDocument, options);
        }
export type MessageChannelsQueryHookResult = ReturnType<typeof useMessageChannelsQuery>;
export type MessageChannelsLazyQueryHookResult = ReturnType<typeof useMessageChannelsLazyQuery>;
export type MessageChannelsQueryResult = Apollo.QueryResult<MessageChannelsQuery, MessageChannelsQueryVariables>;
export const ReprocessOrderDocument = gql`
    mutation reprocessOrder($id: String!) {
  reprocessOrder(id: $id)
}
    `;
export type ReprocessOrderMutationFn = Apollo.MutationFunction<ReprocessOrderMutation, ReprocessOrderMutationVariables>;

/**
 * __useReprocessOrderMutation__
 *
 * To run a mutation, you first call `useReprocessOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessOrderMutation, { data, loading, error }] = useReprocessOrderMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReprocessOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReprocessOrderMutation, ReprocessOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReprocessOrderMutation, ReprocessOrderMutationVariables>(ReprocessOrderDocument, options);
      }
export type ReprocessOrderMutationHookResult = ReturnType<typeof useReprocessOrderMutation>;
export type ReprocessOrderMutationResult = Apollo.MutationResult<ReprocessOrderMutation>;
export type ReprocessOrderMutationOptions = Apollo.BaseMutationOptions<ReprocessOrderMutation, ReprocessOrderMutationVariables>;
export const FetchAndSyncProductDocument = gql`
    mutation FetchAndSyncProduct($input: FetchProductByProviderIdInput!) {
  fetchAndSyncProductByProviderId(input: $input)
}
    `;
export type FetchAndSyncProductMutationFn = Apollo.MutationFunction<FetchAndSyncProductMutation, FetchAndSyncProductMutationVariables>;

/**
 * __useFetchAndSyncProductMutation__
 *
 * To run a mutation, you first call `useFetchAndSyncProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchAndSyncProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchAndSyncProductMutation, { data, loading, error }] = useFetchAndSyncProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchAndSyncProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FetchAndSyncProductMutation, FetchAndSyncProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FetchAndSyncProductMutation, FetchAndSyncProductMutationVariables>(FetchAndSyncProductDocument, options);
      }
export type FetchAndSyncProductMutationHookResult = ReturnType<typeof useFetchAndSyncProductMutation>;
export type FetchAndSyncProductMutationResult = Apollo.MutationResult<FetchAndSyncProductMutation>;
export type FetchAndSyncProductMutationOptions = Apollo.BaseMutationOptions<FetchAndSyncProductMutation, FetchAndSyncProductMutationVariables>;
export const ProductStatsDocument = gql`
    query ProductStats {
  productStats {
    label
    value
  }
}
    `;

/**
 * __useProductStatsQuery__
 *
 * To run a query within a React component, call `useProductStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductStatsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductStatsQuery, ProductStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductStatsQuery, ProductStatsQueryVariables>(ProductStatsDocument, options);
      }
export function useProductStatsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductStatsQuery, ProductStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductStatsQuery, ProductStatsQueryVariables>(ProductStatsDocument, options);
        }
export type ProductStatsQueryHookResult = ReturnType<typeof useProductStatsQuery>;
export type ProductStatsLazyQueryHookResult = ReturnType<typeof useProductStatsLazyQuery>;
export type ProductStatsQueryResult = Apollo.QueryResult<ProductStatsQuery, ProductStatsQueryVariables>;
export const ReprocessInvoiceDocument = gql`
    mutation ReprocessInvoice($id: String!) {
  reprocessInvoice(id: $id)
}
    `;
export type ReprocessInvoiceMutationFn = Apollo.MutationFunction<ReprocessInvoiceMutation, ReprocessInvoiceMutationVariables>;

/**
 * __useReprocessInvoiceMutation__
 *
 * To run a mutation, you first call `useReprocessInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReprocessInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reprocessInvoiceMutation, { data, loading, error }] = useReprocessInvoiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReprocessInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReprocessInvoiceMutation, ReprocessInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReprocessInvoiceMutation, ReprocessInvoiceMutationVariables>(ReprocessInvoiceDocument, options);
      }
export type ReprocessInvoiceMutationHookResult = ReturnType<typeof useReprocessInvoiceMutation>;
export type ReprocessInvoiceMutationResult = Apollo.MutationResult<ReprocessInvoiceMutation>;
export type ReprocessInvoiceMutationOptions = Apollo.BaseMutationOptions<ReprocessInvoiceMutation, ReprocessInvoiceMutationVariables>;
export const UserExportDocument = gql`
    mutation UserExport($isSubscribed: Boolean!, $dateRange: [DateTime!], $emails: [String!]) {
  sendCustomerCsv(
    isSubscribed: $isSubscribed
    dateRange: $dateRange
    emails: $emails
  )
}
    `;
export type UserExportMutationFn = Apollo.MutationFunction<UserExportMutation, UserExportMutationVariables>;

/**
 * __useUserExportMutation__
 *
 * To run a mutation, you first call `useUserExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userExportMutation, { data, loading, error }] = useUserExportMutation({
 *   variables: {
 *      isSubscribed: // value for 'isSubscribed'
 *      dateRange: // value for 'dateRange'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useUserExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserExportMutation, UserExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserExportMutation, UserExportMutationVariables>(UserExportDocument, options);
      }
export type UserExportMutationHookResult = ReturnType<typeof useUserExportMutation>;
export type UserExportMutationResult = Apollo.MutationResult<UserExportMutation>;
export type UserExportMutationOptions = Apollo.BaseMutationOptions<UserExportMutation, UserExportMutationVariables>;
export const VoucherReasonsDocument = gql`
    query voucherReasons {
  voucherReasons
}
    `;

/**
 * __useVoucherReasonsQuery__
 *
 * To run a query within a React component, call `useVoucherReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoucherReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoucherReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useVoucherReasonsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VoucherReasonsQuery, VoucherReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VoucherReasonsQuery, VoucherReasonsQueryVariables>(VoucherReasonsDocument, options);
      }
export function useVoucherReasonsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VoucherReasonsQuery, VoucherReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VoucherReasonsQuery, VoucherReasonsQueryVariables>(VoucherReasonsDocument, options);
        }
export type VoucherReasonsQueryHookResult = ReturnType<typeof useVoucherReasonsQuery>;
export type VoucherReasonsLazyQueryHookResult = ReturnType<typeof useVoucherReasonsLazyQuery>;
export type VoucherReasonsQueryResult = Apollo.QueryResult<VoucherReasonsQuery, VoucherReasonsQueryVariables>;
export const VouchersExportDocument = gql`
    mutation VouchersExport($reason: String) {
  sendVouchersCsv(reason: $reason)
}
    `;
export type VouchersExportMutationFn = Apollo.MutationFunction<VouchersExportMutation, VouchersExportMutationVariables>;

/**
 * __useVouchersExportMutation__
 *
 * To run a mutation, you first call `useVouchersExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVouchersExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [vouchersExportMutation, { data, loading, error }] = useVouchersExportMutation({
 *   variables: {
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useVouchersExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<VouchersExportMutation, VouchersExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<VouchersExportMutation, VouchersExportMutationVariables>(VouchersExportDocument, options);
      }
export type VouchersExportMutationHookResult = ReturnType<typeof useVouchersExportMutation>;
export type VouchersExportMutationResult = Apollo.MutationResult<VouchersExportMutation>;
export type VouchersExportMutationOptions = Apollo.BaseMutationOptions<VouchersExportMutation, VouchersExportMutationVariables>;
export const MeQueryDocument = gql`
    query MeQuery {
  me {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useMeQueryQuery__
 *
 * To run a query within a React component, call `useMeQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MeQueryQuery, MeQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MeQueryQuery, MeQueryQueryVariables>(MeQueryDocument, options);
      }
export function useMeQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MeQueryQuery, MeQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MeQueryQuery, MeQueryQueryVariables>(MeQueryDocument, options);
        }
export type MeQueryQueryHookResult = ReturnType<typeof useMeQueryQuery>;
export type MeQueryLazyQueryHookResult = ReturnType<typeof useMeQueryLazyQuery>;
export type MeQueryQueryResult = Apollo.QueryResult<MeQueryQuery, MeQueryQueryVariables>;
export const UpdateOrderCustomerDocument = gql`
    mutation UpdateOrderCustomer($input: UpdateOneCustomerInput!) {
  updateOneCustomer(input: $input) {
    id
    firstName
    lastName
    email
    mobile
  }
}
    `;
export type UpdateOrderCustomerMutationFn = Apollo.MutationFunction<UpdateOrderCustomerMutation, UpdateOrderCustomerMutationVariables>;

/**
 * __useUpdateOrderCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateOrderCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderCustomerMutation, { data, loading, error }] = useUpdateOrderCustomerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrderCustomerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOrderCustomerMutation, UpdateOrderCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOrderCustomerMutation, UpdateOrderCustomerMutationVariables>(UpdateOrderCustomerDocument, options);
      }
export type UpdateOrderCustomerMutationHookResult = ReturnType<typeof useUpdateOrderCustomerMutation>;
export type UpdateOrderCustomerMutationResult = Apollo.MutationResult<UpdateOrderCustomerMutation>;
export type UpdateOrderCustomerMutationOptions = Apollo.BaseMutationOptions<UpdateOrderCustomerMutation, UpdateOrderCustomerMutationVariables>;
export const AllBrandsQueryDocument = gql`
    query AllBrandsQuery {
  allBrands {
    id
    brandName
    tags {
      id
      name
      category
      categoryLabel
    }
  }
}
    `;

/**
 * __useAllBrandsQueryQuery__
 *
 * To run a query within a React component, call `useAllBrandsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllBrandsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllBrandsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllBrandsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllBrandsQueryQuery, AllBrandsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllBrandsQueryQuery, AllBrandsQueryQueryVariables>(AllBrandsQueryDocument, options);
      }
export function useAllBrandsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllBrandsQueryQuery, AllBrandsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllBrandsQueryQuery, AllBrandsQueryQueryVariables>(AllBrandsQueryDocument, options);
        }
export type AllBrandsQueryQueryHookResult = ReturnType<typeof useAllBrandsQueryQuery>;
export type AllBrandsQueryLazyQueryHookResult = ReturnType<typeof useAllBrandsQueryLazyQuery>;
export type AllBrandsQueryQueryResult = Apollo.QueryResult<AllBrandsQueryQuery, AllBrandsQueryQueryVariables>;
export const BrandsQueryDocument = gql`
    query BrandsQuery($paging: CursorPaging, $filter: BrandFilter, $sorting: [BrandSort!]) {
  brands(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        ...BrandFields
      }
    }
    pageInfo {
      ...PagingFields
    }
  }
}
    ${BrandFieldsFragmentDoc}
${PagingFieldsFragmentDoc}`;

/**
 * __useBrandsQueryQuery__
 *
 * To run a query within a React component, call `useBrandsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandsQueryQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useBrandsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrandsQueryQuery, BrandsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandsQueryQuery, BrandsQueryQueryVariables>(BrandsQueryDocument, options);
      }
export function useBrandsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandsQueryQuery, BrandsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandsQueryQuery, BrandsQueryQueryVariables>(BrandsQueryDocument, options);
        }
export type BrandsQueryQueryHookResult = ReturnType<typeof useBrandsQueryQuery>;
export type BrandsQueryLazyQueryHookResult = ReturnType<typeof useBrandsQueryLazyQuery>;
export type BrandsQueryQueryResult = Apollo.QueryResult<BrandsQueryQuery, BrandsQueryQueryVariables>;
export const DeleteBrandDocument = gql`
    mutation DeleteBrand($id: ID!) {
  deleteOneBrand(input: {id: $id}) {
    id
  }
}
    `;
export type DeleteBrandMutationFn = Apollo.MutationFunction<DeleteBrandMutation, DeleteBrandMutationVariables>;

/**
 * __useDeleteBrandMutation__
 *
 * To run a mutation, you first call `useDeleteBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandMutation, { data, loading, error }] = useDeleteBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBrandMutation, DeleteBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBrandMutation, DeleteBrandMutationVariables>(DeleteBrandDocument, options);
      }
export type DeleteBrandMutationHookResult = ReturnType<typeof useDeleteBrandMutation>;
export type DeleteBrandMutationResult = Apollo.MutationResult<DeleteBrandMutation>;
export type DeleteBrandMutationOptions = Apollo.BaseMutationOptions<DeleteBrandMutation, DeleteBrandMutationVariables>;
export const DeleteBrandsDocument = gql`
    mutation DeleteBrands($ids: [ID!]!) {
  deleteManyBrands(input: {filter: {id: {in: $ids}}}) {
    deletedCount
  }
}
    `;
export type DeleteBrandsMutationFn = Apollo.MutationFunction<DeleteBrandsMutation, DeleteBrandsMutationVariables>;

/**
 * __useDeleteBrandsMutation__
 *
 * To run a mutation, you first call `useDeleteBrandsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBrandsMutation, { data, loading, error }] = useDeleteBrandsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteBrandsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteBrandsMutation, DeleteBrandsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteBrandsMutation, DeleteBrandsMutationVariables>(DeleteBrandsDocument, options);
      }
export type DeleteBrandsMutationHookResult = ReturnType<typeof useDeleteBrandsMutation>;
export type DeleteBrandsMutationResult = Apollo.MutationResult<DeleteBrandsMutation>;
export type DeleteBrandsMutationOptions = Apollo.BaseMutationOptions<DeleteBrandsMutation, DeleteBrandsMutationVariables>;
export const UpdateBrandsDocument = gql`
    mutation UpdateBrands($ids: [ID!]!, $update: BrandsInput!) {
  updateManyBrands(input: {filter: {id: {in: $ids}}, update: $update}) {
    updatedCount
  }
}
    `;
export type UpdateBrandsMutationFn = Apollo.MutationFunction<UpdateBrandsMutation, UpdateBrandsMutationVariables>;

/**
 * __useUpdateBrandsMutation__
 *
 * To run a mutation, you first call `useUpdateBrandsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandsMutation, { data, loading, error }] = useUpdateBrandsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateBrandsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBrandsMutation, UpdateBrandsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBrandsMutation, UpdateBrandsMutationVariables>(UpdateBrandsDocument, options);
      }
export type UpdateBrandsMutationHookResult = ReturnType<typeof useUpdateBrandsMutation>;
export type UpdateBrandsMutationResult = Apollo.MutationResult<UpdateBrandsMutation>;
export type UpdateBrandsMutationOptions = Apollo.BaseMutationOptions<UpdateBrandsMutation, UpdateBrandsMutationVariables>;
export const UpdateBrandDocument = gql`
    mutation UpdateBrand($id: ID!, $update: BrandsInput!) {
  updateBrand(id: $id, update: $update) {
    ...BrandFields
    ...BrandDetailFields
  }
}
    ${BrandFieldsFragmentDoc}
${BrandDetailFieldsFragmentDoc}`;
export type UpdateBrandMutationFn = Apollo.MutationFunction<UpdateBrandMutation, UpdateBrandMutationVariables>;

/**
 * __useUpdateBrandMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBrandMutation, { data, loading, error }] = useUpdateBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateBrandMutation, UpdateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateBrandMutation, UpdateBrandMutationVariables>(UpdateBrandDocument, options);
      }
export type UpdateBrandMutationHookResult = ReturnType<typeof useUpdateBrandMutation>;
export type UpdateBrandMutationResult = Apollo.MutationResult<UpdateBrandMutation>;
export type UpdateBrandMutationOptions = Apollo.BaseMutationOptions<UpdateBrandMutation, UpdateBrandMutationVariables>;
export const SetTagsOnBrandDocument = gql`
    mutation SetTagsOnBrand($id: ID!, $tagIds: [ID!]!) {
  setTagsOnBrand(input: {id: $id, relationIds: $tagIds}) {
    id
    tags {
      ...TagFields
    }
  }
}
    ${TagFieldsFragmentDoc}`;
export type SetTagsOnBrandMutationFn = Apollo.MutationFunction<SetTagsOnBrandMutation, SetTagsOnBrandMutationVariables>;

/**
 * __useSetTagsOnBrandMutation__
 *
 * To run a mutation, you first call `useSetTagsOnBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTagsOnBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTagsOnBrandMutation, { data, loading, error }] = useSetTagsOnBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useSetTagsOnBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetTagsOnBrandMutation, SetTagsOnBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetTagsOnBrandMutation, SetTagsOnBrandMutationVariables>(SetTagsOnBrandDocument, options);
      }
export type SetTagsOnBrandMutationHookResult = ReturnType<typeof useSetTagsOnBrandMutation>;
export type SetTagsOnBrandMutationResult = Apollo.MutationResult<SetTagsOnBrandMutation>;
export type SetTagsOnBrandMutationOptions = Apollo.BaseMutationOptions<SetTagsOnBrandMutation, SetTagsOnBrandMutationVariables>;
export const CreateBrandDocument = gql`
    mutation CreateBrand($input: CreateOneShopifyBrandInput!) {
  createOneShopifyBrand(input: $input) {
    ...BrandFields
  }
}
    ${BrandFieldsFragmentDoc}`;
export type CreateBrandMutationFn = Apollo.MutationFunction<CreateBrandMutation, CreateBrandMutationVariables>;

/**
 * __useCreateBrandMutation__
 *
 * To run a mutation, you first call `useCreateBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBrandMutation, { data, loading, error }] = useCreateBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateBrandMutation, CreateBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateBrandMutation, CreateBrandMutationVariables>(CreateBrandDocument, options);
      }
export type CreateBrandMutationHookResult = ReturnType<typeof useCreateBrandMutation>;
export type CreateBrandMutationResult = Apollo.MutationResult<CreateBrandMutation>;
export type CreateBrandMutationOptions = Apollo.BaseMutationOptions<CreateBrandMutation, CreateBrandMutationVariables>;
export const SetPortraitOnBrandDocument = gql`
    mutation SetPortraitOnBrand($id: ID!, $imageId: ID!) {
  setFeaturedPortraitOnBrand(input: {id: $id, relationId: $imageId}) {
    id
    featuredPortrait {
      ...ImageFields
    }
  }
}
    ${ImageFieldsFragmentDoc}`;
export type SetPortraitOnBrandMutationFn = Apollo.MutationFunction<SetPortraitOnBrandMutation, SetPortraitOnBrandMutationVariables>;

/**
 * __useSetPortraitOnBrandMutation__
 *
 * To run a mutation, you first call `useSetPortraitOnBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPortraitOnBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPortraitOnBrandMutation, { data, loading, error }] = useSetPortraitOnBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useSetPortraitOnBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetPortraitOnBrandMutation, SetPortraitOnBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetPortraitOnBrandMutation, SetPortraitOnBrandMutationVariables>(SetPortraitOnBrandDocument, options);
      }
export type SetPortraitOnBrandMutationHookResult = ReturnType<typeof useSetPortraitOnBrandMutation>;
export type SetPortraitOnBrandMutationResult = Apollo.MutationResult<SetPortraitOnBrandMutation>;
export type SetPortraitOnBrandMutationOptions = Apollo.BaseMutationOptions<SetPortraitOnBrandMutation, SetPortraitOnBrandMutationVariables>;
export const SetLandscapeOnBrandDocument = gql`
    mutation SetLandscapeOnBrand($id: ID!, $imageId: ID!) {
  setFeaturedLandscapeOnBrand(input: {id: $id, relationId: $imageId}) {
    id
    featuredLandscape {
      ...ImageFields
    }
  }
}
    ${ImageFieldsFragmentDoc}`;
export type SetLandscapeOnBrandMutationFn = Apollo.MutationFunction<SetLandscapeOnBrandMutation, SetLandscapeOnBrandMutationVariables>;

/**
 * __useSetLandscapeOnBrandMutation__
 *
 * To run a mutation, you first call `useSetLandscapeOnBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLandscapeOnBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLandscapeOnBrandMutation, { data, loading, error }] = useSetLandscapeOnBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useSetLandscapeOnBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetLandscapeOnBrandMutation, SetLandscapeOnBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetLandscapeOnBrandMutation, SetLandscapeOnBrandMutationVariables>(SetLandscapeOnBrandDocument, options);
      }
export type SetLandscapeOnBrandMutationHookResult = ReturnType<typeof useSetLandscapeOnBrandMutation>;
export type SetLandscapeOnBrandMutationResult = Apollo.MutationResult<SetLandscapeOnBrandMutation>;
export type SetLandscapeOnBrandMutationOptions = Apollo.BaseMutationOptions<SetLandscapeOnBrandMutation, SetLandscapeOnBrandMutationVariables>;
export const SetImagesOnBrandDocument = gql`
    mutation SetImagesOnBrand($id: ID!, $imageIds: [ID!]!) {
  setImagesOnBrand(input: {id: $id, relationIds: $imageIds}) {
    id
    images {
      ...ImageFields
    }
  }
}
    ${ImageFieldsFragmentDoc}`;
export type SetImagesOnBrandMutationFn = Apollo.MutationFunction<SetImagesOnBrandMutation, SetImagesOnBrandMutationVariables>;

/**
 * __useSetImagesOnBrandMutation__
 *
 * To run a mutation, you first call `useSetImagesOnBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetImagesOnBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setImagesOnBrandMutation, { data, loading, error }] = useSetImagesOnBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imageIds: // value for 'imageIds'
 *   },
 * });
 */
export function useSetImagesOnBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetImagesOnBrandMutation, SetImagesOnBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetImagesOnBrandMutation, SetImagesOnBrandMutationVariables>(SetImagesOnBrandDocument, options);
      }
export type SetImagesOnBrandMutationHookResult = ReturnType<typeof useSetImagesOnBrandMutation>;
export type SetImagesOnBrandMutationResult = Apollo.MutationResult<SetImagesOnBrandMutation>;
export type SetImagesOnBrandMutationOptions = Apollo.BaseMutationOptions<SetImagesOnBrandMutation, SetImagesOnBrandMutationVariables>;
export const SetLogoOnBrandDocument = gql`
    mutation SetLogoOnBrand($id: ID!, $imageId: ID!) {
  setImageOnBrand(input: {id: $id, relationId: $imageId}) {
    id
    image {
      ...ImageFields
    }
  }
}
    ${ImageFieldsFragmentDoc}`;
export type SetLogoOnBrandMutationFn = Apollo.MutationFunction<SetLogoOnBrandMutation, SetLogoOnBrandMutationVariables>;

/**
 * __useSetLogoOnBrandMutation__
 *
 * To run a mutation, you first call `useSetLogoOnBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLogoOnBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLogoOnBrandMutation, { data, loading, error }] = useSetLogoOnBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useSetLogoOnBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetLogoOnBrandMutation, SetLogoOnBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetLogoOnBrandMutation, SetLogoOnBrandMutationVariables>(SetLogoOnBrandDocument, options);
      }
export type SetLogoOnBrandMutationHookResult = ReturnType<typeof useSetLogoOnBrandMutation>;
export type SetLogoOnBrandMutationResult = Apollo.MutationResult<SetLogoOnBrandMutation>;
export type SetLogoOnBrandMutationOptions = Apollo.BaseMutationOptions<SetLogoOnBrandMutation, SetLogoOnBrandMutationVariables>;
export const SendOneBrandVerifyDocument = gql`
    mutation SendOneBrandVerify($id: ID!, $email: String!) {
  sendOneBrandVerify(input: {id: $id, email: $email})
}
    `;
export type SendOneBrandVerifyMutationFn = Apollo.MutationFunction<SendOneBrandVerifyMutation, SendOneBrandVerifyMutationVariables>;

/**
 * __useSendOneBrandVerifyMutation__
 *
 * To run a mutation, you first call `useSendOneBrandVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOneBrandVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOneBrandVerifyMutation, { data, loading, error }] = useSendOneBrandVerifyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendOneBrandVerifyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendOneBrandVerifyMutation, SendOneBrandVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendOneBrandVerifyMutation, SendOneBrandVerifyMutationVariables>(SendOneBrandVerifyDocument, options);
      }
export type SendOneBrandVerifyMutationHookResult = ReturnType<typeof useSendOneBrandVerifyMutation>;
export type SendOneBrandVerifyMutationResult = Apollo.MutationResult<SendOneBrandVerifyMutation>;
export type SendOneBrandVerifyMutationOptions = Apollo.BaseMutationOptions<SendOneBrandVerifyMutation, SendOneBrandVerifyMutationVariables>;
export const UpdateOneBrandVerifyDocument = gql`
    mutation UpdateOneBrandVerify($id: ID!, $installUrl: String!) {
  updateOneBrandVerify(input: {id: $id, installUrl: $installUrl})
}
    `;
export type UpdateOneBrandVerifyMutationFn = Apollo.MutationFunction<UpdateOneBrandVerifyMutation, UpdateOneBrandVerifyMutationVariables>;

/**
 * __useUpdateOneBrandVerifyMutation__
 *
 * To run a mutation, you first call `useUpdateOneBrandVerifyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneBrandVerifyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneBrandVerifyMutation, { data, loading, error }] = useUpdateOneBrandVerifyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      installUrl: // value for 'installUrl'
 *   },
 * });
 */
export function useUpdateOneBrandVerifyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOneBrandVerifyMutation, UpdateOneBrandVerifyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOneBrandVerifyMutation, UpdateOneBrandVerifyMutationVariables>(UpdateOneBrandVerifyDocument, options);
      }
export type UpdateOneBrandVerifyMutationHookResult = ReturnType<typeof useUpdateOneBrandVerifyMutation>;
export type UpdateOneBrandVerifyMutationResult = Apollo.MutationResult<UpdateOneBrandVerifyMutation>;
export type UpdateOneBrandVerifyMutationOptions = Apollo.BaseMutationOptions<UpdateOneBrandVerifyMutation, UpdateOneBrandVerifyMutationVariables>;
export const SyncOneBrandDocument = gql`
    mutation SyncOneBrand($id: ID!) {
  syncOneBrand(input: {id: $id})
}
    `;
export type SyncOneBrandMutationFn = Apollo.MutationFunction<SyncOneBrandMutation, SyncOneBrandMutationVariables>;

/**
 * __useSyncOneBrandMutation__
 *
 * To run a mutation, you first call `useSyncOneBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncOneBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncOneBrandMutation, { data, loading, error }] = useSyncOneBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncOneBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SyncOneBrandMutation, SyncOneBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SyncOneBrandMutation, SyncOneBrandMutationVariables>(SyncOneBrandDocument, options);
      }
export type SyncOneBrandMutationHookResult = ReturnType<typeof useSyncOneBrandMutation>;
export type SyncOneBrandMutationResult = Apollo.MutationResult<SyncOneBrandMutation>;
export type SyncOneBrandMutationOptions = Apollo.BaseMutationOptions<SyncOneBrandMutation, SyncOneBrandMutationVariables>;
export const IndexBrandDocument = gql`
    mutation IndexBrand($id: String!) {
  indexBrand(id: $id)
}
    `;
export type IndexBrandMutationFn = Apollo.MutationFunction<IndexBrandMutation, IndexBrandMutationVariables>;

/**
 * __useIndexBrandMutation__
 *
 * To run a mutation, you first call `useIndexBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndexBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indexBrandMutation, { data, loading, error }] = useIndexBrandMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIndexBrandMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IndexBrandMutation, IndexBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IndexBrandMutation, IndexBrandMutationVariables>(IndexBrandDocument, options);
      }
export type IndexBrandMutationHookResult = ReturnType<typeof useIndexBrandMutation>;
export type IndexBrandMutationResult = Apollo.MutationResult<IndexBrandMutation>;
export type IndexBrandMutationOptions = Apollo.BaseMutationOptions<IndexBrandMutation, IndexBrandMutationVariables>;
export const SetupWebhookDocument = gql`
    mutation SetupWebhook($id: String!) {
  registerBrandWebhooks(id: $id)
}
    `;
export type SetupWebhookMutationFn = Apollo.MutationFunction<SetupWebhookMutation, SetupWebhookMutationVariables>;

/**
 * __useSetupWebhookMutation__
 *
 * To run a mutation, you first call `useSetupWebhookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupWebhookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupWebhookMutation, { data, loading, error }] = useSetupWebhookMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetupWebhookMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetupWebhookMutation, SetupWebhookMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetupWebhookMutation, SetupWebhookMutationVariables>(SetupWebhookDocument, options);
      }
export type SetupWebhookMutationHookResult = ReturnType<typeof useSetupWebhookMutation>;
export type SetupWebhookMutationResult = Apollo.MutationResult<SetupWebhookMutation>;
export type SetupWebhookMutationOptions = Apollo.BaseMutationOptions<SetupWebhookMutation, SetupWebhookMutationVariables>;
export const UploadOneImageDocument = gql`
    mutation UploadOneImage($file: Upload!) {
  uploadOneImage(file: $file) {
    ...ImageFields
  }
}
    ${ImageFieldsFragmentDoc}`;
export type UploadOneImageMutationFn = Apollo.MutationFunction<UploadOneImageMutation, UploadOneImageMutationVariables>;

/**
 * __useUploadOneImageMutation__
 *
 * To run a mutation, you first call `useUploadOneImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOneImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOneImageMutation, { data, loading, error }] = useUploadOneImageMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadOneImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UploadOneImageMutation, UploadOneImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UploadOneImageMutation, UploadOneImageMutationVariables>(UploadOneImageDocument, options);
      }
export type UploadOneImageMutationHookResult = ReturnType<typeof useUploadOneImageMutation>;
export type UploadOneImageMutationResult = Apollo.MutationResult<UploadOneImageMutation>;
export type UploadOneImageMutationOptions = Apollo.BaseMutationOptions<UploadOneImageMutation, UploadOneImageMutationVariables>;
export const OrdersQueryDocument = gql`
    query OrdersQuery($paging: CursorPaging, $filter: OrderFilter, $sorting: [OrderSort!]) {
  orders(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        ...BaseOrderFields
        lines {
          brand {
            brandName
          }
        }
      }
    }
    pageInfo {
      ...PagingFields
    }
  }
}
    ${BaseOrderFieldsFragmentDoc}
${PagingFieldsFragmentDoc}`;

/**
 * __useOrdersQueryQuery__
 *
 * To run a query within a React component, call `useOrdersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrdersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrdersQueryQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useOrdersQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrdersQueryQuery, OrdersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrdersQueryQuery, OrdersQueryQueryVariables>(OrdersQueryDocument, options);
      }
export function useOrdersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrdersQueryQuery, OrdersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrdersQueryQuery, OrdersQueryQueryVariables>(OrdersQueryDocument, options);
        }
export type OrdersQueryQueryHookResult = ReturnType<typeof useOrdersQueryQuery>;
export type OrdersQueryLazyQueryHookResult = ReturnType<typeof useOrdersQueryLazyQuery>;
export type OrdersQueryQueryResult = Apollo.QueryResult<OrdersQueryQuery, OrdersQueryQueryVariables>;
export const ProductsQueryDocument = gql`
    query ProductsQuery($paging: CursorPaging, $filter: ProductFilter, $sorting: [ProductSort!]) {
  products(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        ...ProductTableFields
      }
    }
    pageInfo {
      ...PagingFields
    }
  }
}
    ${ProductTableFieldsFragmentDoc}
${PagingFieldsFragmentDoc}`;

/**
 * __useProductsQueryQuery__
 *
 * To run a query within a React component, call `useProductsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductsQueryQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useProductsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductsQueryQuery, ProductsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductsQueryQuery, ProductsQueryQueryVariables>(ProductsQueryDocument, options);
      }
export function useProductsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductsQueryQuery, ProductsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductsQueryQuery, ProductsQueryQueryVariables>(ProductsQueryDocument, options);
        }
export type ProductsQueryQueryHookResult = ReturnType<typeof useProductsQueryQuery>;
export type ProductsQueryLazyQueryHookResult = ReturnType<typeof useProductsQueryLazyQuery>;
export type ProductsQueryQueryResult = Apollo.QueryResult<ProductsQueryQuery, ProductsQueryQueryVariables>;
export const ProductQueryDocument = gql`
    query ProductQuery($id: ID!) {
  product(id: $id) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;

/**
 * __useProductQueryQuery__
 *
 * To run a query within a React component, call `useProductQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductQueryQuery, ProductQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductQueryQuery, ProductQueryQueryVariables>(ProductQueryDocument, options);
      }
export function useProductQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductQueryQuery, ProductQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductQueryQuery, ProductQueryQueryVariables>(ProductQueryDocument, options);
        }
export type ProductQueryQueryHookResult = ReturnType<typeof useProductQueryQuery>;
export type ProductQueryLazyQueryHookResult = ReturnType<typeof useProductQueryLazyQuery>;
export type ProductQueryQueryResult = Apollo.QueryResult<ProductQueryQuery, ProductQueryQueryVariables>;
export const AllProductsDocument = gql`
    query AllProducts($paging: CursorPaging, $filter: ProductFilter, $sorting: [ProductSort!]) {
  allProducts(paging: $paging, filter: $filter, sorting: $sorting) {
    id
  }
}
    `;

/**
 * __useAllProductsQuery__
 *
 * To run a query within a React component, call `useAllProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllProductsQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useAllProductsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllProductsQuery, AllProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllProductsQuery, AllProductsQueryVariables>(AllProductsDocument, options);
      }
export function useAllProductsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllProductsQuery, AllProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllProductsQuery, AllProductsQueryVariables>(AllProductsDocument, options);
        }
export type AllProductsQueryHookResult = ReturnType<typeof useAllProductsQuery>;
export type AllProductsLazyQueryHookResult = ReturnType<typeof useAllProductsLazyQuery>;
export type AllProductsQueryResult = Apollo.QueryResult<AllProductsQuery, AllProductsQueryVariables>;
export const UpdateProductDocument = gql`
    mutation UpdateProduct($id: ID!, $update: ProductsInput!) {
  updateOneProduct(input: {id: $id, update: $update}) {
    ...ProductFields
  }
}
    ${ProductFieldsFragmentDoc}`;
export type UpdateProductMutationFn = Apollo.MutationFunction<UpdateProductMutation, UpdateProductMutationVariables>;

/**
 * __useUpdateProductMutation__
 *
 * To run a mutation, you first call `useUpdateProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductMutation, { data, loading, error }] = useUpdateProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductMutation, UpdateProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProductMutation, UpdateProductMutationVariables>(UpdateProductDocument, options);
      }
export type UpdateProductMutationHookResult = ReturnType<typeof useUpdateProductMutation>;
export type UpdateProductMutationResult = Apollo.MutationResult<UpdateProductMutation>;
export type UpdateProductMutationOptions = Apollo.BaseMutationOptions<UpdateProductMutation, UpdateProductMutationVariables>;
export const UpdateProductsDocument = gql`
    mutation UpdateProducts($ids: [ID!]!, $update: ProductsInput!) {
  updateManyProducts(input: {filter: {id: {in: $ids}}, update: $update}) {
    updatedCount
  }
}
    `;
export type UpdateProductsMutationFn = Apollo.MutationFunction<UpdateProductsMutation, UpdateProductsMutationVariables>;

/**
 * __useUpdateProductsMutation__
 *
 * To run a mutation, you first call `useUpdateProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductsMutation, { data, loading, error }] = useUpdateProductsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateProductsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductsMutation, UpdateProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProductsMutation, UpdateProductsMutationVariables>(UpdateProductsDocument, options);
      }
export type UpdateProductsMutationHookResult = ReturnType<typeof useUpdateProductsMutation>;
export type UpdateProductsMutationResult = Apollo.MutationResult<UpdateProductsMutation>;
export type UpdateProductsMutationOptions = Apollo.BaseMutationOptions<UpdateProductsMutation, UpdateProductsMutationVariables>;
export const SetTagsOnProductDocument = gql`
    mutation SetTagsOnProduct($id: ID!, $tagIds: [ID!]!) {
  setTagsOnProduct(input: {id: $id, relationIds: $tagIds}) {
    id
    tags {
      ...TagFields
    }
  }
}
    ${TagFieldsFragmentDoc}`;
export type SetTagsOnProductMutationFn = Apollo.MutationFunction<SetTagsOnProductMutation, SetTagsOnProductMutationVariables>;

/**
 * __useSetTagsOnProductMutation__
 *
 * To run a mutation, you first call `useSetTagsOnProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTagsOnProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTagsOnProductMutation, { data, loading, error }] = useSetTagsOnProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      tagIds: // value for 'tagIds'
 *   },
 * });
 */
export function useSetTagsOnProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetTagsOnProductMutation, SetTagsOnProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetTagsOnProductMutation, SetTagsOnProductMutationVariables>(SetTagsOnProductDocument, options);
      }
export type SetTagsOnProductMutationHookResult = ReturnType<typeof useSetTagsOnProductMutation>;
export type SetTagsOnProductMutationResult = Apollo.MutationResult<SetTagsOnProductMutation>;
export type SetTagsOnProductMutationOptions = Apollo.BaseMutationOptions<SetTagsOnProductMutation, SetTagsOnProductMutationVariables>;
export const SetImageOnProductDocument = gql`
    mutation SetImageOnProduct($id: ID!, $imageId: ID!) {
  setImageOnProduct(input: {id: $id, relationId: $imageId}) {
    id
    image {
      ...ImageFields
    }
  }
}
    ${ImageFieldsFragmentDoc}`;
export type SetImageOnProductMutationFn = Apollo.MutationFunction<SetImageOnProductMutation, SetImageOnProductMutationVariables>;

/**
 * __useSetImageOnProductMutation__
 *
 * To run a mutation, you first call `useSetImageOnProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetImageOnProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setImageOnProductMutation, { data, loading, error }] = useSetImageOnProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useSetImageOnProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetImageOnProductMutation, SetImageOnProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetImageOnProductMutation, SetImageOnProductMutationVariables>(SetImageOnProductDocument, options);
      }
export type SetImageOnProductMutationHookResult = ReturnType<typeof useSetImageOnProductMutation>;
export type SetImageOnProductMutationResult = Apollo.MutationResult<SetImageOnProductMutation>;
export type SetImageOnProductMutationOptions = Apollo.BaseMutationOptions<SetImageOnProductMutation, SetImageOnProductMutationVariables>;
export const SetImagesOnProductDocument = gql`
    mutation SetImagesOnProduct($id: ID!, $imageIds: [ID!]!) {
  setImagesOnProduct(input: {id: $id, relationIds: $imageIds}) {
    id
    images {
      ...ImageFields
    }
  }
}
    ${ImageFieldsFragmentDoc}`;
export type SetImagesOnProductMutationFn = Apollo.MutationFunction<SetImagesOnProductMutation, SetImagesOnProductMutationVariables>;

/**
 * __useSetImagesOnProductMutation__
 *
 * To run a mutation, you first call `useSetImagesOnProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetImagesOnProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setImagesOnProductMutation, { data, loading, error }] = useSetImagesOnProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imageIds: // value for 'imageIds'
 *   },
 * });
 */
export function useSetImagesOnProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetImagesOnProductMutation, SetImagesOnProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetImagesOnProductMutation, SetImagesOnProductMutationVariables>(SetImagesOnProductDocument, options);
      }
export type SetImagesOnProductMutationHookResult = ReturnType<typeof useSetImagesOnProductMutation>;
export type SetImagesOnProductMutationResult = Apollo.MutationResult<SetImagesOnProductMutation>;
export type SetImagesOnProductMutationOptions = Apollo.BaseMutationOptions<SetImagesOnProductMutation, SetImagesOnProductMutationVariables>;
export const UpdateProductVariantDocument = gql`
    mutation UpdateProductVariant($id: ID!, $update: ProductVariantsInput!) {
  updateOneProductVariant(input: {id: $id, update: $update}) {
    ...VariantFields
  }
}
    ${VariantFieldsFragmentDoc}`;
export type UpdateProductVariantMutationFn = Apollo.MutationFunction<UpdateProductVariantMutation, UpdateProductVariantMutationVariables>;

/**
 * __useUpdateProductVariantMutation__
 *
 * To run a mutation, you first call `useUpdateProductVariantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProductVariantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProductVariantMutation, { data, loading, error }] = useUpdateProductVariantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateProductVariantMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProductVariantMutation, UpdateProductVariantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProductVariantMutation, UpdateProductVariantMutationVariables>(UpdateProductVariantDocument, options);
      }
export type UpdateProductVariantMutationHookResult = ReturnType<typeof useUpdateProductVariantMutation>;
export type UpdateProductVariantMutationResult = Apollo.MutationResult<UpdateProductVariantMutation>;
export type UpdateProductVariantMutationOptions = Apollo.BaseMutationOptions<UpdateProductVariantMutation, UpdateProductVariantMutationVariables>;
export const IndexProductDocument = gql`
    mutation IndexProduct($id: String!) {
  indexProduct(id: $id)
}
    `;
export type IndexProductMutationFn = Apollo.MutationFunction<IndexProductMutation, IndexProductMutationVariables>;

/**
 * __useIndexProductMutation__
 *
 * To run a mutation, you first call `useIndexProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIndexProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [indexProductMutation, { data, loading, error }] = useIndexProductMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIndexProductMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<IndexProductMutation, IndexProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<IndexProductMutation, IndexProductMutationVariables>(IndexProductDocument, options);
      }
export type IndexProductMutationHookResult = ReturnType<typeof useIndexProductMutation>;
export type IndexProductMutationResult = Apollo.MutationResult<IndexProductMutation>;
export type IndexProductMutationOptions = Apollo.BaseMutationOptions<IndexProductMutation, IndexProductMutationVariables>;
export const RefundsDocument = gql`
    query Refunds($paging: CursorPaging, $filter: RefundFilter, $sorting: [RefundSort!]) {
  refunds(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        ...RefundFields
      }
    }
    pageInfo {
      ...PagingFields
    }
  }
}
    ${RefundFieldsFragmentDoc}
${PagingFieldsFragmentDoc}`;

/**
 * __useRefundsQuery__
 *
 * To run a query within a React component, call `useRefundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundsQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useRefundsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RefundsQuery, RefundsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RefundsQuery, RefundsQueryVariables>(RefundsDocument, options);
      }
export function useRefundsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RefundsQuery, RefundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RefundsQuery, RefundsQueryVariables>(RefundsDocument, options);
        }
export type RefundsQueryHookResult = ReturnType<typeof useRefundsQuery>;
export type RefundsLazyQueryHookResult = ReturnType<typeof useRefundsLazyQuery>;
export type RefundsQueryResult = Apollo.QueryResult<RefundsQuery, RefundsQueryVariables>;
export const SizingGuidesQueryDocument = gql`
    query SizingGuidesQuery($paging: CursorPaging, $filter: SizingGuideFilter, $sorting: [SizingGuideSort!]) {
  sizingGuides(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        id
        name
        createdAt
      }
    }
    pageInfo {
      ...PagingFields
    }
  }
}
    ${PagingFieldsFragmentDoc}`;

/**
 * __useSizingGuidesQueryQuery__
 *
 * To run a query within a React component, call `useSizingGuidesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSizingGuidesQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSizingGuidesQueryQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useSizingGuidesQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SizingGuidesQueryQuery, SizingGuidesQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SizingGuidesQueryQuery, SizingGuidesQueryQueryVariables>(SizingGuidesQueryDocument, options);
      }
export function useSizingGuidesQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SizingGuidesQueryQuery, SizingGuidesQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SizingGuidesQueryQuery, SizingGuidesQueryQueryVariables>(SizingGuidesQueryDocument, options);
        }
export type SizingGuidesQueryQueryHookResult = ReturnType<typeof useSizingGuidesQueryQuery>;
export type SizingGuidesQueryLazyQueryHookResult = ReturnType<typeof useSizingGuidesQueryLazyQuery>;
export type SizingGuidesQueryQueryResult = Apollo.QueryResult<SizingGuidesQueryQuery, SizingGuidesQueryQueryVariables>;
export const SizingGuideQueryDocument = gql`
    query SizingGuideQuery($id: ID!) {
  sizingGuide(id: $id) {
    id
    name
    content
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useSizingGuideQueryQuery__
 *
 * To run a query within a React component, call `useSizingGuideQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSizingGuideQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSizingGuideQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSizingGuideQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SizingGuideQueryQuery, SizingGuideQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SizingGuideQueryQuery, SizingGuideQueryQueryVariables>(SizingGuideQueryDocument, options);
      }
export function useSizingGuideQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SizingGuideQueryQuery, SizingGuideQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SizingGuideQueryQuery, SizingGuideQueryQueryVariables>(SizingGuideQueryDocument, options);
        }
export type SizingGuideQueryQueryHookResult = ReturnType<typeof useSizingGuideQueryQuery>;
export type SizingGuideQueryLazyQueryHookResult = ReturnType<typeof useSizingGuideQueryLazyQuery>;
export type SizingGuideQueryQueryResult = Apollo.QueryResult<SizingGuideQueryQuery, SizingGuideQueryQueryVariables>;
export const AllSizingGuidesDocument = gql`
    query AllSizingGuides {
  sizingGuides(paging: {first: 200}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAllSizingGuidesQuery__
 *
 * To run a query within a React component, call `useAllSizingGuidesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllSizingGuidesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllSizingGuidesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllSizingGuidesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllSizingGuidesQuery, AllSizingGuidesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllSizingGuidesQuery, AllSizingGuidesQueryVariables>(AllSizingGuidesDocument, options);
      }
export function useAllSizingGuidesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllSizingGuidesQuery, AllSizingGuidesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllSizingGuidesQuery, AllSizingGuidesQueryVariables>(AllSizingGuidesDocument, options);
        }
export type AllSizingGuidesQueryHookResult = ReturnType<typeof useAllSizingGuidesQuery>;
export type AllSizingGuidesLazyQueryHookResult = ReturnType<typeof useAllSizingGuidesLazyQuery>;
export type AllSizingGuidesQueryResult = Apollo.QueryResult<AllSizingGuidesQuery, AllSizingGuidesQueryVariables>;
export const SizingGuidesForSelectDocument = gql`
    query SizingGuidesForSelect($paging: CursorPaging, $filter: SizingGuideFilter) {
  sizingGuides(paging: $paging, filter: $filter) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useSizingGuidesForSelectQuery__
 *
 * To run a query within a React component, call `useSizingGuidesForSelectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSizingGuidesForSelectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSizingGuidesForSelectQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSizingGuidesForSelectQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SizingGuidesForSelectQuery, SizingGuidesForSelectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SizingGuidesForSelectQuery, SizingGuidesForSelectQueryVariables>(SizingGuidesForSelectDocument, options);
      }
export function useSizingGuidesForSelectLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SizingGuidesForSelectQuery, SizingGuidesForSelectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SizingGuidesForSelectQuery, SizingGuidesForSelectQueryVariables>(SizingGuidesForSelectDocument, options);
        }
export type SizingGuidesForSelectQueryHookResult = ReturnType<typeof useSizingGuidesForSelectQuery>;
export type SizingGuidesForSelectLazyQueryHookResult = ReturnType<typeof useSizingGuidesForSelectLazyQuery>;
export type SizingGuidesForSelectQueryResult = Apollo.QueryResult<SizingGuidesForSelectQuery, SizingGuidesForSelectQueryVariables>;
export const CreateSizingGuideDocument = gql`
    mutation CreateSizingGuide($input: CreateSizingGuideInput!) {
  createOneSizingGuide(input: {sizingGuide: $input}) {
    id
    name
  }
}
    `;
export type CreateSizingGuideMutationFn = Apollo.MutationFunction<CreateSizingGuideMutation, CreateSizingGuideMutationVariables>;

/**
 * __useCreateSizingGuideMutation__
 *
 * To run a mutation, you first call `useCreateSizingGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSizingGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSizingGuideMutation, { data, loading, error }] = useCreateSizingGuideMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSizingGuideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateSizingGuideMutation, CreateSizingGuideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateSizingGuideMutation, CreateSizingGuideMutationVariables>(CreateSizingGuideDocument, options);
      }
export type CreateSizingGuideMutationHookResult = ReturnType<typeof useCreateSizingGuideMutation>;
export type CreateSizingGuideMutationResult = Apollo.MutationResult<CreateSizingGuideMutation>;
export type CreateSizingGuideMutationOptions = Apollo.BaseMutationOptions<CreateSizingGuideMutation, CreateSizingGuideMutationVariables>;
export const UpdateSizingGuideDocument = gql`
    mutation UpdateSizingGuide($id: ID!, $update: UpdateSizingGuideInput!) {
  updateOneSizingGuide(input: {id: $id, update: $update}) {
    id
    name
    content
  }
}
    `;
export type UpdateSizingGuideMutationFn = Apollo.MutationFunction<UpdateSizingGuideMutation, UpdateSizingGuideMutationVariables>;

/**
 * __useUpdateSizingGuideMutation__
 *
 * To run a mutation, you first call `useUpdateSizingGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSizingGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSizingGuideMutation, { data, loading, error }] = useUpdateSizingGuideMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateSizingGuideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSizingGuideMutation, UpdateSizingGuideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSizingGuideMutation, UpdateSizingGuideMutationVariables>(UpdateSizingGuideDocument, options);
      }
export type UpdateSizingGuideMutationHookResult = ReturnType<typeof useUpdateSizingGuideMutation>;
export type UpdateSizingGuideMutationResult = Apollo.MutationResult<UpdateSizingGuideMutation>;
export type UpdateSizingGuideMutationOptions = Apollo.BaseMutationOptions<UpdateSizingGuideMutation, UpdateSizingGuideMutationVariables>;
export const DeleteSizingGuideDocument = gql`
    mutation DeleteSizingGuide($id: ID!) {
  deleteOneSizingGuide(input: {id: $id}) {
    id
  }
}
    `;
export type DeleteSizingGuideMutationFn = Apollo.MutationFunction<DeleteSizingGuideMutation, DeleteSizingGuideMutationVariables>;

/**
 * __useDeleteSizingGuideMutation__
 *
 * To run a mutation, you first call `useDeleteSizingGuideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSizingGuideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSizingGuideMutation, { data, loading, error }] = useDeleteSizingGuideMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSizingGuideMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteSizingGuideMutation, DeleteSizingGuideMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteSizingGuideMutation, DeleteSizingGuideMutationVariables>(DeleteSizingGuideDocument, options);
      }
export type DeleteSizingGuideMutationHookResult = ReturnType<typeof useDeleteSizingGuideMutation>;
export type DeleteSizingGuideMutationResult = Apollo.MutationResult<DeleteSizingGuideMutation>;
export type DeleteSizingGuideMutationOptions = Apollo.BaseMutationOptions<DeleteSizingGuideMutation, DeleteSizingGuideMutationVariables>;
export const TagQueryDocument = gql`
    query TagQuery($id: ID!) {
  tag(id: $id) {
    ...TagFields
  }
}
    ${TagFieldsFragmentDoc}`;

/**
 * __useTagQueryQuery__
 *
 * To run a query within a React component, call `useTagQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagQueryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTagQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TagQueryQuery, TagQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TagQueryQuery, TagQueryQueryVariables>(TagQueryDocument, options);
      }
export function useTagQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TagQueryQuery, TagQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TagQueryQuery, TagQueryQueryVariables>(TagQueryDocument, options);
        }
export type TagQueryQueryHookResult = ReturnType<typeof useTagQueryQuery>;
export type TagQueryLazyQueryHookResult = ReturnType<typeof useTagQueryLazyQuery>;
export type TagQueryQueryResult = Apollo.QueryResult<TagQueryQuery, TagQueryQueryVariables>;
export const TagTypesDocument = gql`
    query TagTypes {
  tagTypes {
    edges {
      node {
        name
      }
    }
  }
}
    `;

/**
 * __useTagTypesQuery__
 *
 * To run a query within a React component, call `useTagTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagTypesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TagTypesQuery, TagTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TagTypesQuery, TagTypesQueryVariables>(TagTypesDocument, options);
      }
export function useTagTypesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TagTypesQuery, TagTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TagTypesQuery, TagTypesQueryVariables>(TagTypesDocument, options);
        }
export type TagTypesQueryHookResult = ReturnType<typeof useTagTypesQuery>;
export type TagTypesLazyQueryHookResult = ReturnType<typeof useTagTypesLazyQuery>;
export type TagTypesQueryResult = Apollo.QueryResult<TagTypesQuery, TagTypesQueryVariables>;
export const TagCategoriesDocument = gql`
    query TagCategories {
  tagCategories {
    name
    title
  }
}
    `;

/**
 * __useTagCategoriesQuery__
 *
 * To run a query within a React component, call `useTagCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TagCategoriesQuery, TagCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TagCategoriesQuery, TagCategoriesQueryVariables>(TagCategoriesDocument, options);
      }
export function useTagCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TagCategoriesQuery, TagCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TagCategoriesQuery, TagCategoriesQueryVariables>(TagCategoriesDocument, options);
        }
export type TagCategoriesQueryHookResult = ReturnType<typeof useTagCategoriesQuery>;
export type TagCategoriesLazyQueryHookResult = ReturnType<typeof useTagCategoriesLazyQuery>;
export type TagCategoriesQueryResult = Apollo.QueryResult<TagCategoriesQuery, TagCategoriesQueryVariables>;
export const AllTagsDocument = gql`
    query AllTags($type: TagTypeEnum) {
  allTags(type: $type) {
    ...TagFields
  }
}
    ${TagFieldsFragmentDoc}`;

/**
 * __useAllTagsQuery__
 *
 * To run a query within a React component, call `useAllTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTagsQuery({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useAllTagsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AllTagsQuery, AllTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AllTagsQuery, AllTagsQueryVariables>(AllTagsDocument, options);
      }
export function useAllTagsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AllTagsQuery, AllTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AllTagsQuery, AllTagsQueryVariables>(AllTagsDocument, options);
        }
export type AllTagsQueryHookResult = ReturnType<typeof useAllTagsQuery>;
export type AllTagsLazyQueryHookResult = ReturnType<typeof useAllTagsLazyQuery>;
export type AllTagsQueryResult = Apollo.QueryResult<AllTagsQuery, AllTagsQueryVariables>;
export const TagsQueryDocument = gql`
    query TagsQuery($paging: CursorPaging, $filter: TagFilter, $sorting: [TagSort!]) {
  tags(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        ...TagFields
      }
    }
    pageInfo {
      ...PagingFields
    }
  }
}
    ${TagFieldsFragmentDoc}
${PagingFieldsFragmentDoc}`;

/**
 * __useTagsQueryQuery__
 *
 * To run a query within a React component, call `useTagsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQueryQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useTagsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TagsQueryQuery, TagsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TagsQueryQuery, TagsQueryQueryVariables>(TagsQueryDocument, options);
      }
export function useTagsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TagsQueryQuery, TagsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TagsQueryQuery, TagsQueryQueryVariables>(TagsQueryDocument, options);
        }
export type TagsQueryQueryHookResult = ReturnType<typeof useTagsQueryQuery>;
export type TagsQueryLazyQueryHookResult = ReturnType<typeof useTagsQueryLazyQuery>;
export type TagsQueryQueryResult = Apollo.QueryResult<TagsQueryQuery, TagsQueryQueryVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($id: ID!) {
  deleteOneTag(input: {id: $id}) {
    id
  }
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;
export const DeleteTagsDocument = gql`
    mutation DeleteTags($ids: [String!]!) {
  deleteManyTags(input: {filter: {id: {in: $ids}}}) {
    deletedCount
  }
}
    `;
export type DeleteTagsMutationFn = Apollo.MutationFunction<DeleteTagsMutation, DeleteTagsMutationVariables>;

/**
 * __useDeleteTagsMutation__
 *
 * To run a mutation, you first call `useDeleteTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagsMutation, { data, loading, error }] = useDeleteTagsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteTagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTagsMutation, DeleteTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTagsMutation, DeleteTagsMutationVariables>(DeleteTagsDocument, options);
      }
export type DeleteTagsMutationHookResult = ReturnType<typeof useDeleteTagsMutation>;
export type DeleteTagsMutationResult = Apollo.MutationResult<DeleteTagsMutation>;
export type DeleteTagsMutationOptions = Apollo.BaseMutationOptions<DeleteTagsMutation, DeleteTagsMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($id: ID!, $update: UpdateTag!) {
  updateOneTag(input: {id: $id, update: $update}) {
    ...TagFields
  }
}
    ${TagFieldsFragmentDoc}`;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const CreateTagDocument = gql`
    mutation CreateTag($tag: CreateTag!) {
  createOneTag(input: {tag: $tag}) {
    ...TagFields
  }
}
    ${TagFieldsFragmentDoc}`;
export type CreateTagMutationFn = Apollo.MutationFunction<CreateTagMutation, CreateTagMutationVariables>;

/**
 * __useCreateTagMutation__
 *
 * To run a mutation, you first call `useCreateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTagMutation, { data, loading, error }] = useCreateTagMutation({
 *   variables: {
 *      tag: // value for 'tag'
 *   },
 * });
 */
export function useCreateTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTagMutation, CreateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTagMutation, CreateTagMutationVariables>(CreateTagDocument, options);
      }
export type CreateTagMutationHookResult = ReturnType<typeof useCreateTagMutation>;
export type CreateTagMutationResult = Apollo.MutationResult<CreateTagMutation>;
export type CreateTagMutationOptions = Apollo.BaseMutationOptions<CreateTagMutation, CreateTagMutationVariables>;
export const SetImageOnTagDocument = gql`
    mutation SetImageOnTag($id: ID!, $imageId: ID!) {
  setImageOnTag(input: {id: $id, relationId: $imageId}) {
    id
    image {
      ...ImageFields
    }
  }
}
    ${ImageFieldsFragmentDoc}`;
export type SetImageOnTagMutationFn = Apollo.MutationFunction<SetImageOnTagMutation, SetImageOnTagMutationVariables>;

/**
 * __useSetImageOnTagMutation__
 *
 * To run a mutation, you first call `useSetImageOnTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetImageOnTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setImageOnTagMutation, { data, loading, error }] = useSetImageOnTagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      imageId: // value for 'imageId'
 *   },
 * });
 */
export function useSetImageOnTagMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetImageOnTagMutation, SetImageOnTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SetImageOnTagMutation, SetImageOnTagMutationVariables>(SetImageOnTagDocument, options);
      }
export type SetImageOnTagMutationHookResult = ReturnType<typeof useSetImageOnTagMutation>;
export type SetImageOnTagMutationResult = Apollo.MutationResult<SetImageOnTagMutation>;
export type SetImageOnTagMutationOptions = Apollo.BaseMutationOptions<SetImageOnTagMutation, SetImageOnTagMutationVariables>;
export const PublishTagFeedDocument = gql`
    mutation PublishTagFeed($tagId: String!) {
  publishTagFeed(tagId: $tagId)
}
    `;
export type PublishTagFeedMutationFn = Apollo.MutationFunction<PublishTagFeedMutation, PublishTagFeedMutationVariables>;

/**
 * __usePublishTagFeedMutation__
 *
 * To run a mutation, you first call `usePublishTagFeedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishTagFeedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishTagFeedMutation, { data, loading, error }] = usePublishTagFeedMutation({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function usePublishTagFeedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PublishTagFeedMutation, PublishTagFeedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PublishTagFeedMutation, PublishTagFeedMutationVariables>(PublishTagFeedDocument, options);
      }
export type PublishTagFeedMutationHookResult = ReturnType<typeof usePublishTagFeedMutation>;
export type PublishTagFeedMutationResult = Apollo.MutationResult<PublishTagFeedMutation>;
export type PublishTagFeedMutationOptions = Apollo.BaseMutationOptions<PublishTagFeedMutation, PublishTagFeedMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation forgotPassword($email: String!) {
  sendOnePasswordForgot(input: {email: $email}) {
    success
    message
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const UserDocument = gql`
    query User($id: ID!, $firstTransactions: Int!, $after: String) {
  account(id: $id) {
    ...AccountFields
    customer {
      availableCredit
      transactions(first: $firstTransactions, after: $after) {
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            type
            amount
            createdAt
            order {
              id
              orderNumber
            }
            voucher {
              id
              redemptionDate
              updatedAt
              voucherNumber
            }
          }
        }
      }
    }
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *      firstTransactions: // value for 'firstTransactions'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useUserQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UsersQueryDocument = gql`
    query UsersQuery($paging: CursorPaging, $filter: AccountFilter, $sorting: [AccountSort!]) {
  accounts(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        ...AccountFields
      }
    }
    pageInfo {
      ...PagingFields
    }
  }
}
    ${AccountFieldsFragmentDoc}
${PagingFieldsFragmentDoc}`;

/**
 * __useUsersQueryQuery__
 *
 * To run a query within a React component, call `useUsersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQueryQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useUsersQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<UsersQueryQuery, UsersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersQueryQuery, UsersQueryQueryVariables>(UsersQueryDocument, options);
      }
export function useUsersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersQueryQuery, UsersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersQueryQuery, UsersQueryQueryVariables>(UsersQueryDocument, options);
        }
export type UsersQueryQueryHookResult = ReturnType<typeof useUsersQueryQuery>;
export type UsersQueryLazyQueryHookResult = ReturnType<typeof useUsersQueryLazyQuery>;
export type UsersQueryQueryResult = Apollo.QueryResult<UsersQueryQuery, UsersQueryQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateOneAccountInput!) {
  createOneAccount(input: $input) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $update: AccountUpdateInput!) {
  updateOneAccount(input: {id: $id, update: $update}) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateUsersDocument = gql`
    mutation UpdateUsers($ids: [String!]!, $update: AccountUpdateInput!) {
  updateManyAccounts(input: {filter: {id: {in: $ids}}, update: $update}) {
    updatedCount
  }
}
    `;
export type UpdateUsersMutationFn = Apollo.MutationFunction<UpdateUsersMutation, UpdateUsersMutationVariables>;

/**
 * __useUpdateUsersMutation__
 *
 * To run a mutation, you first call `useUpdateUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUsersMutation, { data, loading, error }] = useUpdateUsersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useUpdateUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateUsersMutation, UpdateUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateUsersMutation, UpdateUsersMutationVariables>(UpdateUsersDocument, options);
      }
export type UpdateUsersMutationHookResult = ReturnType<typeof useUpdateUsersMutation>;
export type UpdateUsersMutationResult = Apollo.MutationResult<UpdateUsersMutation>;
export type UpdateUsersMutationOptions = Apollo.BaseMutationOptions<UpdateUsersMutation, UpdateUsersMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!) {
  deleteOneAccount(input: {id: $id}) {
    id
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const DeleteUsersDocument = gql`
    mutation DeleteUsers($ids: [String!]!) {
  deleteManyAccounts(input: {filter: {id: {in: $ids}}}) {
    deletedCount
  }
}
    `;
export type DeleteUsersMutationFn = Apollo.MutationFunction<DeleteUsersMutation, DeleteUsersMutationVariables>;

/**
 * __useDeleteUsersMutation__
 *
 * To run a mutation, you first call `useDeleteUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUsersMutation, { data, loading, error }] = useDeleteUsersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteUsersMutation, DeleteUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteUsersMutation, DeleteUsersMutationVariables>(DeleteUsersDocument, options);
      }
export type DeleteUsersMutationHookResult = ReturnType<typeof useDeleteUsersMutation>;
export type DeleteUsersMutationResult = Apollo.MutationResult<DeleteUsersMutation>;
export type DeleteUsersMutationOptions = Apollo.BaseMutationOptions<DeleteUsersMutation, DeleteUsersMutationVariables>;
export const GetOptionNamesDocument = gql`
    query GetOptionNames($paging: CursorPaging, $filter: OptionNameFilter, $sorting: [OptionNameSort!]) {
  optionNames(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        ...OptionNameFields
      }
    }
    pageInfo {
      ...PagingFields
    }
  }
}
    ${OptionNameFieldsFragmentDoc}
${PagingFieldsFragmentDoc}`;

/**
 * __useGetOptionNamesQuery__
 *
 * To run a query within a React component, call `useGetOptionNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOptionNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOptionNamesQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetOptionNamesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetOptionNamesQuery, GetOptionNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOptionNamesQuery, GetOptionNamesQueryVariables>(GetOptionNamesDocument, options);
      }
export function useGetOptionNamesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOptionNamesQuery, GetOptionNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOptionNamesQuery, GetOptionNamesQueryVariables>(GetOptionNamesDocument, options);
        }
export type GetOptionNamesQueryHookResult = ReturnType<typeof useGetOptionNamesQuery>;
export type GetOptionNamesLazyQueryHookResult = ReturnType<typeof useGetOptionNamesLazyQuery>;
export type GetOptionNamesQueryResult = Apollo.QueryResult<GetOptionNamesQuery, GetOptionNamesQueryVariables>;
export const UpdateOptionNameDocument = gql`
    mutation UpdateOptionName($input: UpdateOneOptionNameInput!) {
  updateOneOptionName(input: $input) {
    ...OptionNameFields
  }
}
    ${OptionNameFieldsFragmentDoc}`;
export type UpdateOptionNameMutationFn = Apollo.MutationFunction<UpdateOptionNameMutation, UpdateOptionNameMutationVariables>;

/**
 * __useUpdateOptionNameMutation__
 *
 * To run a mutation, you first call `useUpdateOptionNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptionNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOptionNameMutation, { data, loading, error }] = useUpdateOptionNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOptionNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOptionNameMutation, UpdateOptionNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOptionNameMutation, UpdateOptionNameMutationVariables>(UpdateOptionNameDocument, options);
      }
export type UpdateOptionNameMutationHookResult = ReturnType<typeof useUpdateOptionNameMutation>;
export type UpdateOptionNameMutationResult = Apollo.MutationResult<UpdateOptionNameMutation>;
export type UpdateOptionNameMutationOptions = Apollo.BaseMutationOptions<UpdateOptionNameMutation, UpdateOptionNameMutationVariables>;
export const GetAccountGroupsDocument = gql`
    query GetAccountGroups($paging: CursorPaging, $filter: AccountGroupFilter, $sorting: [AccountGroupSort!]) {
  accountGroups(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        id
        name
        description
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetAccountGroupsQuery__
 *
 * To run a query within a React component, call `useGetAccountGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountGroupsQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useGetAccountGroupsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountGroupsQuery, GetAccountGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccountGroupsQuery, GetAccountGroupsQueryVariables>(GetAccountGroupsDocument, options);
      }
export function useGetAccountGroupsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountGroupsQuery, GetAccountGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccountGroupsQuery, GetAccountGroupsQueryVariables>(GetAccountGroupsDocument, options);
        }
export type GetAccountGroupsQueryHookResult = ReturnType<typeof useGetAccountGroupsQuery>;
export type GetAccountGroupsLazyQueryHookResult = ReturnType<typeof useGetAccountGroupsLazyQuery>;
export type GetAccountGroupsQueryResult = Apollo.QueryResult<GetAccountGroupsQuery, GetAccountGroupsQueryVariables>;
export const CreateAccountGroupDocument = gql`
    mutation CreateAccountGroup($input: AccountGroupInput!) {
  createOneAccountGroup(input: {accountGroup: $input}) {
    id
    name
  }
}
    `;
export type CreateAccountGroupMutationFn = Apollo.MutationFunction<CreateAccountGroupMutation, CreateAccountGroupMutationVariables>;

/**
 * __useCreateAccountGroupMutation__
 *
 * To run a mutation, you first call `useCreateAccountGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountGroupMutation, { data, loading, error }] = useCreateAccountGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAccountGroupMutation, CreateAccountGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAccountGroupMutation, CreateAccountGroupMutationVariables>(CreateAccountGroupDocument, options);
      }
export type CreateAccountGroupMutationHookResult = ReturnType<typeof useCreateAccountGroupMutation>;
export type CreateAccountGroupMutationResult = Apollo.MutationResult<CreateAccountGroupMutation>;
export type CreateAccountGroupMutationOptions = Apollo.BaseMutationOptions<CreateAccountGroupMutation, CreateAccountGroupMutationVariables>;
export const DeleteAccountGroupDocument = gql`
    mutation DeleteAccountGroup($id: ID!) {
  deleteOneAccountGroup(input: {id: $id}) {
    id
  }
}
    `;
export type DeleteAccountGroupMutationFn = Apollo.MutationFunction<DeleteAccountGroupMutation, DeleteAccountGroupMutationVariables>;

/**
 * __useDeleteAccountGroupMutation__
 *
 * To run a mutation, you first call `useDeleteAccountGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAccountGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAccountGroupMutation, { data, loading, error }] = useDeleteAccountGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteAccountGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteAccountGroupMutation, DeleteAccountGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteAccountGroupMutation, DeleteAccountGroupMutationVariables>(DeleteAccountGroupDocument, options);
      }
export type DeleteAccountGroupMutationHookResult = ReturnType<typeof useDeleteAccountGroupMutation>;
export type DeleteAccountGroupMutationResult = Apollo.MutationResult<DeleteAccountGroupMutation>;
export type DeleteAccountGroupMutationOptions = Apollo.BaseMutationOptions<DeleteAccountGroupMutation, DeleteAccountGroupMutationVariables>;
export const EditAccountGroupDocument = gql`
    mutation EditAccountGroup($id: ID!, $update: AccountGroupInput!) {
  updateOneAccountGroup(input: {id: $id, update: $update}) {
    ...AccountGroupFields
  }
}
    ${AccountGroupFieldsFragmentDoc}`;
export type EditAccountGroupMutationFn = Apollo.MutationFunction<EditAccountGroupMutation, EditAccountGroupMutationVariables>;

/**
 * __useEditAccountGroupMutation__
 *
 * To run a mutation, you first call `useEditAccountGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditAccountGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editAccountGroupMutation, { data, loading, error }] = useEditAccountGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      update: // value for 'update'
 *   },
 * });
 */
export function useEditAccountGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditAccountGroupMutation, EditAccountGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditAccountGroupMutation, EditAccountGroupMutationVariables>(EditAccountGroupDocument, options);
      }
export type EditAccountGroupMutationHookResult = ReturnType<typeof useEditAccountGroupMutation>;
export type EditAccountGroupMutationResult = Apollo.MutationResult<EditAccountGroupMutation>;
export type EditAccountGroupMutationOptions = Apollo.BaseMutationOptions<EditAccountGroupMutation, EditAccountGroupMutationVariables>;
export const ExportAccountGroupDocument = gql`
    mutation ExportAccountGroup($id: String!) {
  exportAccountGroupAccounts(accountGroupId: $id)
}
    `;
export type ExportAccountGroupMutationFn = Apollo.MutationFunction<ExportAccountGroupMutation, ExportAccountGroupMutationVariables>;

/**
 * __useExportAccountGroupMutation__
 *
 * To run a mutation, you first call `useExportAccountGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportAccountGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportAccountGroupMutation, { data, loading, error }] = useExportAccountGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useExportAccountGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExportAccountGroupMutation, ExportAccountGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExportAccountGroupMutation, ExportAccountGroupMutationVariables>(ExportAccountGroupDocument, options);
      }
export type ExportAccountGroupMutationHookResult = ReturnType<typeof useExportAccountGroupMutation>;
export type ExportAccountGroupMutationResult = Apollo.MutationResult<ExportAccountGroupMutation>;
export type ExportAccountGroupMutationOptions = Apollo.BaseMutationOptions<ExportAccountGroupMutation, ExportAccountGroupMutationVariables>;
export const GetAccountGroupDocument = gql`
    query GetAccountGroup($id: ID!) {
  accountGroup(id: $id) {
    ...AccountGroupFields
  }
}
    ${AccountGroupFieldsFragmentDoc}`;

/**
 * __useGetAccountGroupQuery__
 *
 * To run a query within a React component, call `useGetAccountGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAccountGroupQuery, GetAccountGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccountGroupQuery, GetAccountGroupQueryVariables>(GetAccountGroupDocument, options);
      }
export function useGetAccountGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountGroupQuery, GetAccountGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccountGroupQuery, GetAccountGroupQueryVariables>(GetAccountGroupDocument, options);
        }
export type GetAccountGroupQueryHookResult = ReturnType<typeof useGetAccountGroupQuery>;
export type GetAccountGroupLazyQueryHookResult = ReturnType<typeof useGetAccountGroupLazyQuery>;
export type GetAccountGroupQueryResult = Apollo.QueryResult<GetAccountGroupQuery, GetAccountGroupQueryVariables>;
export const GetAccountsInAccountGroupDocument = gql`
    query GetAccountsInAccountGroup($ids: [String!]!, $first: Int, $after: String, $last: Int, $before: String) {
  getAccountGroupAccounts(
    accountGroupIds: $ids
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    count
    edges {
      node {
        id: accountId
        email
        customerRecencyGroup
        lastPurchaseAt
        lastLogin
        hasActiveCart
        currentCartValue
        cartUpdatedAt
        numberOfOrders
        valueOfOrders
        registeredDate
        appOS
        firstName
        lastName
        birthday
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useGetAccountsInAccountGroupQuery__
 *
 * To run a query within a React component, call `useGetAccountsInAccountGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsInAccountGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsInAccountGroupQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useGetAccountsInAccountGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetAccountsInAccountGroupQuery, GetAccountsInAccountGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccountsInAccountGroupQuery, GetAccountsInAccountGroupQueryVariables>(GetAccountsInAccountGroupDocument, options);
      }
export function useGetAccountsInAccountGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountsInAccountGroupQuery, GetAccountsInAccountGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccountsInAccountGroupQuery, GetAccountsInAccountGroupQueryVariables>(GetAccountsInAccountGroupDocument, options);
        }
export type GetAccountsInAccountGroupQueryHookResult = ReturnType<typeof useGetAccountsInAccountGroupQuery>;
export type GetAccountsInAccountGroupLazyQueryHookResult = ReturnType<typeof useGetAccountsInAccountGroupLazyQuery>;
export type GetAccountsInAccountGroupQueryResult = Apollo.QueryResult<GetAccountsInAccountGroupQuery, GetAccountsInAccountGroupQueryVariables>;
export const DeleteActionDocument = gql`
    mutation DeleteAction($id: ID!) {
  deleteAction(id: $id)
}
    `;
export type DeleteActionMutationFn = Apollo.MutationFunction<DeleteActionMutation, DeleteActionMutationVariables>;

/**
 * __useDeleteActionMutation__
 *
 * To run a mutation, you first call `useDeleteActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteActionMutation, { data, loading, error }] = useDeleteActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteActionMutation, DeleteActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteActionMutation, DeleteActionMutationVariables>(DeleteActionDocument, options);
      }
export type DeleteActionMutationHookResult = ReturnType<typeof useDeleteActionMutation>;
export type DeleteActionMutationResult = Apollo.MutationResult<DeleteActionMutation>;
export type DeleteActionMutationOptions = Apollo.BaseMutationOptions<DeleteActionMutation, DeleteActionMutationVariables>;
export const ActionDocument = gql`
    query Action($id: ID!) {
  action(id: $id) {
    id
    name
    type
    enabled
    message {
      id
      name
    }
    channels
    createdAt
    updatedAt
    voucherValue
    voucherMessage
    expiryDate
    delay {
      unit
      value
    }
    trigger {
      ...TriggerFields
    }
  }
}
    ${TriggerFieldsFragmentDoc}`;

/**
 * __useActionQuery__
 *
 * To run a query within a React component, call `useActionQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ActionQuery, ActionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ActionQuery, ActionQueryVariables>(ActionDocument, options);
      }
export function useActionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ActionQuery, ActionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ActionQuery, ActionQueryVariables>(ActionDocument, options);
        }
export type ActionQueryHookResult = ReturnType<typeof useActionQuery>;
export type ActionLazyQueryHookResult = ReturnType<typeof useActionLazyQuery>;
export type ActionQueryResult = Apollo.QueryResult<ActionQuery, ActionQueryVariables>;
export const UpdateActionDocument = gql`
    mutation UpdateAction($id: ID!, $input: UpdateActionInput!) {
  updateAction(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateActionMutationFn = Apollo.MutationFunction<UpdateActionMutation, UpdateActionMutationVariables>;

/**
 * __useUpdateActionMutation__
 *
 * To run a mutation, you first call `useUpdateActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateActionMutation, { data, loading, error }] = useUpdateActionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateActionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateActionMutation, UpdateActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateActionMutation, UpdateActionMutationVariables>(UpdateActionDocument, options);
      }
export type UpdateActionMutationHookResult = ReturnType<typeof useUpdateActionMutation>;
export type UpdateActionMutationResult = Apollo.MutationResult<UpdateActionMutation>;
export type UpdateActionMutationOptions = Apollo.BaseMutationOptions<UpdateActionMutation, UpdateActionMutationVariables>;
export const BrandOrdersDocument = gql`
    query BrandOrders($filter: OrderLineFilter, $sorting: [OrderLineSort!], $paging: CursorPaging) {
  orderLines(filter: $filter, sorting: $sorting, paging: $paging) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...OrderLineFields
        order {
          id
          orderNumber
          isActive
          status
          account {
            firstName
            lastName
          }
        }
      }
    }
  }
}
    ${OrderLineFieldsFragmentDoc}`;

/**
 * __useBrandOrdersQuery__
 *
 * To run a query within a React component, call `useBrandOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandOrdersQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useBrandOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrandOrdersQuery, BrandOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandOrdersQuery, BrandOrdersQueryVariables>(BrandOrdersDocument, options);
      }
export function useBrandOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandOrdersQuery, BrandOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandOrdersQuery, BrandOrdersQueryVariables>(BrandOrdersDocument, options);
        }
export type BrandOrdersQueryHookResult = ReturnType<typeof useBrandOrdersQuery>;
export type BrandOrdersLazyQueryHookResult = ReturnType<typeof useBrandOrdersLazyQuery>;
export type BrandOrdersQueryResult = Apollo.QueryResult<BrandOrdersQuery, BrandOrdersQueryVariables>;
export const BrandOrdersQueryDocument = gql`
    query BrandOrdersQuery($filter: OrderLineFilter, $sorting: [OrderLineSort!], $paging: CursorPaging) {
  orderLines(filter: $filter, sorting: $sorting, paging: $paging) {
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage
    }
    edges {
      node {
        ...OrderLineFields
        order {
          id
          orderNumber
          isActive
          status
          account {
            firstName
            lastName
          }
        }
      }
    }
  }
}
    ${OrderLineFieldsFragmentDoc}`;

/**
 * __useBrandOrdersQueryQuery__
 *
 * To run a query within a React component, call `useBrandOrdersQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandOrdersQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandOrdersQueryQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *      paging: // value for 'paging'
 *   },
 * });
 */
export function useBrandOrdersQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BrandOrdersQueryQuery, BrandOrdersQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandOrdersQueryQuery, BrandOrdersQueryQueryVariables>(BrandOrdersQueryDocument, options);
      }
export function useBrandOrdersQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandOrdersQueryQuery, BrandOrdersQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandOrdersQueryQuery, BrandOrdersQueryQueryVariables>(BrandOrdersQueryDocument, options);
        }
export type BrandOrdersQueryQueryHookResult = ReturnType<typeof useBrandOrdersQueryQuery>;
export type BrandOrdersQueryLazyQueryHookResult = ReturnType<typeof useBrandOrdersQueryLazyQuery>;
export type BrandOrdersQueryQueryResult = Apollo.QueryResult<BrandOrdersQueryQuery, BrandOrdersQueryQueryVariables>;
export const BrandDocument = gql`
    query Brand($id: ID!) {
  brand(id: $id) {
    ...BrandFields
    ...BrandDetailFields
  }
}
    ${BrandFieldsFragmentDoc}
${BrandDetailFieldsFragmentDoc}`;

/**
 * __useBrandQuery__
 *
 * To run a query within a React component, call `useBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBrandQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBrandQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BrandQuery, BrandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BrandQuery, BrandQueryVariables>(BrandDocument, options);
      }
export function useBrandLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BrandQuery, BrandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BrandQuery, BrandQueryVariables>(BrandDocument, options);
        }
export type BrandQueryHookResult = ReturnType<typeof useBrandQuery>;
export type BrandLazyQueryHookResult = ReturnType<typeof useBrandLazyQuery>;
export type BrandQueryResult = Apollo.QueryResult<BrandQuery, BrandQueryVariables>;
export const ProductSortDocument = gql`
    query ProductSort {
  brandProductSortOptions {
    label
    value
  }
}
    `;

/**
 * __useProductSortQuery__
 *
 * To run a query within a React component, call `useProductSortQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSortQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSortQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductSortQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProductSortQuery, ProductSortQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductSortQuery, ProductSortQueryVariables>(ProductSortDocument, options);
      }
export function useProductSortLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductSortQuery, ProductSortQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductSortQuery, ProductSortQueryVariables>(ProductSortDocument, options);
        }
export type ProductSortQueryHookResult = ReturnType<typeof useProductSortQuery>;
export type ProductSortLazyQueryHookResult = ReturnType<typeof useProductSortLazyQuery>;
export type ProductSortQueryResult = Apollo.QueryResult<ProductSortQuery, ProductSortQueryVariables>;
export const StatisticsDocument = gql`
    query Statistics($limit: Int!, $offset: Int!) {
  statistics {
    sales {
      revenue
      salesPerDay
      salesPerUser
      activeCarts {
        numOrders
        value
        averageBasketSize
      }
      completedOrders {
        numOrders
        value
        averageBasketSize
      }
      topBrands {
        numOrders
        brand {
          id
          brandName
        }
      }
      topProducts {
        numOrders
        product {
          id
          productTitle
          brand {
            brandName
          }
        }
      }
      rollingSum {
        day
        total
      }
    }
    users {
      signups
      wishlists {
        total
        numberOfUsers
      }
      signupsPerDay
    }
    brandSales(limit: $limit, offset: $offset) {
      name
      numOrders
      numProductsSold
    }
  }
}
    `;

/**
 * __useStatisticsQuery__
 *
 * To run a query within a React component, call `useStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStatisticsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useStatisticsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<StatisticsQuery, StatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<StatisticsQuery, StatisticsQueryVariables>(StatisticsDocument, options);
      }
export function useStatisticsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<StatisticsQuery, StatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<StatisticsQuery, StatisticsQueryVariables>(StatisticsDocument, options);
        }
export type StatisticsQueryHookResult = ReturnType<typeof useStatisticsQuery>;
export type StatisticsLazyQueryHookResult = ReturnType<typeof useStatisticsLazyQuery>;
export type StatisticsQueryResult = Apollo.QueryResult<StatisticsQuery, StatisticsQueryVariables>;
export const CreateMessageDocument = gql`
    mutation CreateMessage($input: CreateMessageInput!) {
  createMessage(input: $input) {
    id
    name
  }
}
    `;
export type CreateMessageMutationFn = Apollo.MutationFunction<CreateMessageMutation, CreateMessageMutationVariables>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMessageMutation, CreateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument, options);
      }
export type CreateMessageMutationHookResult = ReturnType<typeof useCreateMessageMutation>;
export type CreateMessageMutationResult = Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<CreateMessageMutation, CreateMessageMutationVariables>;
export const DeleteMessageDocument = gql`
    mutation DeleteMessage($id: String!) {
  removeMessage(id: $id)
}
    `;
export type DeleteMessageMutationFn = Apollo.MutationFunction<DeleteMessageMutation, DeleteMessageMutationVariables>;

/**
 * __useDeleteMessageMutation__
 *
 * To run a mutation, you first call `useDeleteMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageMutation, { data, loading, error }] = useDeleteMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMessageMutation, DeleteMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMessageMutation, DeleteMessageMutationVariables>(DeleteMessageDocument, options);
      }
export type DeleteMessageMutationHookResult = ReturnType<typeof useDeleteMessageMutation>;
export type DeleteMessageMutationResult = Apollo.MutationResult<DeleteMessageMutation>;
export type DeleteMessageMutationOptions = Apollo.BaseMutationOptions<DeleteMessageMutation, DeleteMessageMutationVariables>;
export const UpdateMessageDocument = gql`
    mutation UpdateMessage($id: String!, $input: UpdateMessageInput!) {
  updateMessage(id: $id, input: $input) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;
export type UpdateMessageMutationFn = Apollo.MutationFunction<UpdateMessageMutation, UpdateMessageMutationVariables>;

/**
 * __useUpdateMessageMutation__
 *
 * To run a mutation, you first call `useUpdateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageMutation, { data, loading, error }] = useUpdateMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMessageMutation, UpdateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMessageMutation, UpdateMessageMutationVariables>(UpdateMessageDocument, options);
      }
export type UpdateMessageMutationHookResult = ReturnType<typeof useUpdateMessageMutation>;
export type UpdateMessageMutationResult = Apollo.MutationResult<UpdateMessageMutation>;
export type UpdateMessageMutationOptions = Apollo.BaseMutationOptions<UpdateMessageMutation, UpdateMessageMutationVariables>;
export const MessagesDocument = gql`
    query Messages($paging: CursorPaging, $filter: MessageFilter, $sorting: [MessageSort!]) {
  messages(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        id
        name
        createdAt
        updatedAt
        title
        enabled
        contentId
        createdAt
        updatedAt
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useMessagesQuery__
 *
 * To run a query within a React component, call `useMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useMessagesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
      }
export function useMessagesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
        }
export type MessagesQueryHookResult = ReturnType<typeof useMessagesQuery>;
export type MessagesLazyQueryHookResult = ReturnType<typeof useMessagesLazyQuery>;
export type MessagesQueryResult = Apollo.QueryResult<MessagesQuery, MessagesQueryVariables>;
export const MessageDocument = gql`
    query Message($id: ID!) {
  message(id: $id) {
    ...MessageFields
  }
}
    ${MessageFieldsFragmentDoc}`;

/**
 * __useMessageQuery__
 *
 * To run a query within a React component, call `useMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MessageQuery, MessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MessageQuery, MessageQueryVariables>(MessageDocument, options);
      }
export function useMessageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessageQuery, MessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MessageQuery, MessageQueryVariables>(MessageDocument, options);
        }
export type MessageQueryHookResult = ReturnType<typeof useMessageQuery>;
export type MessageLazyQueryHookResult = ReturnType<typeof useMessageLazyQuery>;
export type MessageQueryResult = Apollo.QueryResult<MessageQuery, MessageQueryVariables>;
export const CreateMessageCampaignDocument = gql`
    mutation CreateMessageCampaign($input: CreateMessageCampaignInput!) {
  createMessageCampaign(input: $input) {
    id
    name
    scheduledAt
  }
}
    `;
export type CreateMessageCampaignMutationFn = Apollo.MutationFunction<CreateMessageCampaignMutation, CreateMessageCampaignMutationVariables>;

/**
 * __useCreateMessageCampaignMutation__
 *
 * To run a mutation, you first call `useCreateMessageCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageCampaignMutation, { data, loading, error }] = useCreateMessageCampaignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateMessageCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateMessageCampaignMutation, CreateMessageCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateMessageCampaignMutation, CreateMessageCampaignMutationVariables>(CreateMessageCampaignDocument, options);
      }
export type CreateMessageCampaignMutationHookResult = ReturnType<typeof useCreateMessageCampaignMutation>;
export type CreateMessageCampaignMutationResult = Apollo.MutationResult<CreateMessageCampaignMutation>;
export type CreateMessageCampaignMutationOptions = Apollo.BaseMutationOptions<CreateMessageCampaignMutation, CreateMessageCampaignMutationVariables>;
export const DeleteMessageCampaignDocument = gql`
    mutation DeleteMessageCampaign($id: String!) {
  removeMessageCampaign(id: $id)
}
    `;
export type DeleteMessageCampaignMutationFn = Apollo.MutationFunction<DeleteMessageCampaignMutation, DeleteMessageCampaignMutationVariables>;

/**
 * __useDeleteMessageCampaignMutation__
 *
 * To run a mutation, you first call `useDeleteMessageCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageCampaignMutation, { data, loading, error }] = useDeleteMessageCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMessageCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteMessageCampaignMutation, DeleteMessageCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteMessageCampaignMutation, DeleteMessageCampaignMutationVariables>(DeleteMessageCampaignDocument, options);
      }
export type DeleteMessageCampaignMutationHookResult = ReturnType<typeof useDeleteMessageCampaignMutation>;
export type DeleteMessageCampaignMutationResult = Apollo.MutationResult<DeleteMessageCampaignMutation>;
export type DeleteMessageCampaignMutationOptions = Apollo.BaseMutationOptions<DeleteMessageCampaignMutation, DeleteMessageCampaignMutationVariables>;
export const UpdateMessageCampaignDocument = gql`
    mutation UpdateMessageCampaign($id: String!, $input: UpdateMessageCampaignInput!) {
  updateMessageCampaign(id: $id, input: $input) {
    id
    name
    scheduledAt
  }
}
    `;
export type UpdateMessageCampaignMutationFn = Apollo.MutationFunction<UpdateMessageCampaignMutation, UpdateMessageCampaignMutationVariables>;

/**
 * __useUpdateMessageCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateMessageCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageCampaignMutation, { data, loading, error }] = useUpdateMessageCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMessageCampaignMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateMessageCampaignMutation, UpdateMessageCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateMessageCampaignMutation, UpdateMessageCampaignMutationVariables>(UpdateMessageCampaignDocument, options);
      }
export type UpdateMessageCampaignMutationHookResult = ReturnType<typeof useUpdateMessageCampaignMutation>;
export type UpdateMessageCampaignMutationResult = Apollo.MutationResult<UpdateMessageCampaignMutation>;
export type UpdateMessageCampaignMutationOptions = Apollo.BaseMutationOptions<UpdateMessageCampaignMutation, UpdateMessageCampaignMutationVariables>;
export const MessageCampaignsDocument = gql`
    query MessageCampaigns($paging: CursorPaging, $filter: MessageCampaignDTOFilter, $sorting: [MessageCampaignDTOSort!]) {
  messageCampaigns(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        id
        name
        createdAt
        sentAt
        scheduledAt
        nextRunAt
        interval
        type
        message {
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useMessageCampaignsQuery__
 *
 * To run a query within a React component, call `useMessageCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageCampaignsQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useMessageCampaignsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MessageCampaignsQuery, MessageCampaignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MessageCampaignsQuery, MessageCampaignsQueryVariables>(MessageCampaignsDocument, options);
      }
export function useMessageCampaignsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessageCampaignsQuery, MessageCampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MessageCampaignsQuery, MessageCampaignsQueryVariables>(MessageCampaignsDocument, options);
        }
export type MessageCampaignsQueryHookResult = ReturnType<typeof useMessageCampaignsQuery>;
export type MessageCampaignsLazyQueryHookResult = ReturnType<typeof useMessageCampaignsLazyQuery>;
export type MessageCampaignsQueryResult = Apollo.QueryResult<MessageCampaignsQuery, MessageCampaignsQueryVariables>;
export const MessageCampaignDocument = gql`
    query MessageCampaign($id: ID!) {
  messageCampaign(id: $id) {
    ...MessageCampaignFields
  }
}
    ${MessageCampaignFieldsFragmentDoc}`;

/**
 * __useMessageCampaignQuery__
 *
 * To run a query within a React component, call `useMessageCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMessageCampaignQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MessageCampaignQuery, MessageCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MessageCampaignQuery, MessageCampaignQueryVariables>(MessageCampaignDocument, options);
      }
export function useMessageCampaignLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MessageCampaignQuery, MessageCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MessageCampaignQuery, MessageCampaignQueryVariables>(MessageCampaignDocument, options);
        }
export type MessageCampaignQueryHookResult = ReturnType<typeof useMessageCampaignQuery>;
export type MessageCampaignLazyQueryHookResult = ReturnType<typeof useMessageCampaignLazyQuery>;
export type MessageCampaignQueryResult = Apollo.QueryResult<MessageCampaignQuery, MessageCampaignQueryVariables>;
export const OrderDocument = gql`
    query Order($id: ID!) {
  order(id: $id) {
    ...OrderFields
  }
}
    ${OrderFieldsFragmentDoc}`;

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const AccountingCodesDocument = gql`
    query AccountingCodes {
  accountingCodes {
    ...AccountingCodeFields
  }
}
    ${AccountingCodeFieldsFragmentDoc}`;

/**
 * __useAccountingCodesQuery__
 *
 * To run a query within a React component, call `useAccountingCodesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountingCodesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountingCodesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountingCodesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<AccountingCodesQuery, AccountingCodesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AccountingCodesQuery, AccountingCodesQueryVariables>(AccountingCodesDocument, options);
      }
export function useAccountingCodesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AccountingCodesQuery, AccountingCodesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AccountingCodesQuery, AccountingCodesQueryVariables>(AccountingCodesDocument, options);
        }
export type AccountingCodesQueryHookResult = ReturnType<typeof useAccountingCodesQuery>;
export type AccountingCodesLazyQueryHookResult = ReturnType<typeof useAccountingCodesLazyQuery>;
export type AccountingCodesQueryResult = Apollo.QueryResult<AccountingCodesQuery, AccountingCodesQueryVariables>;
export const CreateLedgerItemDocument = gql`
    mutation CreateLedgerItem($orderLineId: String!, $input: OrderLineLedgerInput!) {
  createLedgerItem(orderLineId: $orderLineId, input: $input) {
    ...OrderLedgerFields
  }
}
    ${OrderLedgerFieldsFragmentDoc}`;
export type CreateLedgerItemMutationFn = Apollo.MutationFunction<CreateLedgerItemMutation, CreateLedgerItemMutationVariables>;

/**
 * __useCreateLedgerItemMutation__
 *
 * To run a mutation, you first call `useCreateLedgerItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLedgerItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLedgerItemMutation, { data, loading, error }] = useCreateLedgerItemMutation({
 *   variables: {
 *      orderLineId: // value for 'orderLineId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateLedgerItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateLedgerItemMutation, CreateLedgerItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateLedgerItemMutation, CreateLedgerItemMutationVariables>(CreateLedgerItemDocument, options);
      }
export type CreateLedgerItemMutationHookResult = ReturnType<typeof useCreateLedgerItemMutation>;
export type CreateLedgerItemMutationResult = Apollo.MutationResult<CreateLedgerItemMutation>;
export type CreateLedgerItemMutationOptions = Apollo.BaseMutationOptions<CreateLedgerItemMutation, CreateLedgerItemMutationVariables>;
export const UpdateLedgerItemDocument = gql`
    mutation UpdateLedgerItem($id: String!, $input: OrderLineLedgerInput!) {
  updateLedgerEntry(id: $id, input: $input) {
    ...OrderLedgerFields
  }
}
    ${OrderLedgerFieldsFragmentDoc}`;
export type UpdateLedgerItemMutationFn = Apollo.MutationFunction<UpdateLedgerItemMutation, UpdateLedgerItemMutationVariables>;

/**
 * __useUpdateLedgerItemMutation__
 *
 * To run a mutation, you first call `useUpdateLedgerItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLedgerItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLedgerItemMutation, { data, loading, error }] = useUpdateLedgerItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLedgerItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateLedgerItemMutation, UpdateLedgerItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateLedgerItemMutation, UpdateLedgerItemMutationVariables>(UpdateLedgerItemDocument, options);
      }
export type UpdateLedgerItemMutationHookResult = ReturnType<typeof useUpdateLedgerItemMutation>;
export type UpdateLedgerItemMutationResult = Apollo.MutationResult<UpdateLedgerItemMutation>;
export type UpdateLedgerItemMutationOptions = Apollo.BaseMutationOptions<UpdateLedgerItemMutation, UpdateLedgerItemMutationVariables>;
export const DeleteLedgerItemDocument = gql`
    mutation DeleteLedgerItem($id: String!) {
  deleteLedgerEntry(id: $id)
}
    `;
export type DeleteLedgerItemMutationFn = Apollo.MutationFunction<DeleteLedgerItemMutation, DeleteLedgerItemMutationVariables>;

/**
 * __useDeleteLedgerItemMutation__
 *
 * To run a mutation, you first call `useDeleteLedgerItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLedgerItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLedgerItemMutation, { data, loading, error }] = useDeleteLedgerItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteLedgerItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLedgerItemMutation, DeleteLedgerItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLedgerItemMutation, DeleteLedgerItemMutationVariables>(DeleteLedgerItemDocument, options);
      }
export type DeleteLedgerItemMutationHookResult = ReturnType<typeof useDeleteLedgerItemMutation>;
export type DeleteLedgerItemMutationResult = Apollo.MutationResult<DeleteLedgerItemMutation>;
export type DeleteLedgerItemMutationOptions = Apollo.BaseMutationOptions<DeleteLedgerItemMutation, DeleteLedgerItemMutationVariables>;
export const ExportOrdersDocument = gql`
    mutation ExportOrders($paging: CursorPaging, $filter: OrderFilter, $sorting: [OrderSort!]) {
  exportOrders(paging: $paging, filter: $filter, sorting: $sorting)
}
    `;
export type ExportOrdersMutationFn = Apollo.MutationFunction<ExportOrdersMutation, ExportOrdersMutationVariables>;

/**
 * __useExportOrdersMutation__
 *
 * To run a mutation, you first call `useExportOrdersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportOrdersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportOrdersMutation, { data, loading, error }] = useExportOrdersMutation({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useExportOrdersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExportOrdersMutation, ExportOrdersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExportOrdersMutation, ExportOrdersMutationVariables>(ExportOrdersDocument, options);
      }
export type ExportOrdersMutationHookResult = ReturnType<typeof useExportOrdersMutation>;
export type ExportOrdersMutationResult = Apollo.MutationResult<ExportOrdersMutation>;
export type ExportOrdersMutationOptions = Apollo.BaseMutationOptions<ExportOrdersMutation, ExportOrdersMutationVariables>;
export const PaymentRequirementsDocument = gql`
    mutation paymentRequirements {
  paymentRequirements
}
    `;
export type PaymentRequirementsMutationFn = Apollo.MutationFunction<PaymentRequirementsMutation, PaymentRequirementsMutationVariables>;

/**
 * __usePaymentRequirementsMutation__
 *
 * To run a mutation, you first call `usePaymentRequirementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePaymentRequirementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [paymentRequirementsMutation, { data, loading, error }] = usePaymentRequirementsMutation({
 *   variables: {
 *   },
 * });
 */
export function usePaymentRequirementsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PaymentRequirementsMutation, PaymentRequirementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PaymentRequirementsMutation, PaymentRequirementsMutationVariables>(PaymentRequirementsDocument, options);
      }
export type PaymentRequirementsMutationHookResult = ReturnType<typeof usePaymentRequirementsMutation>;
export type PaymentRequirementsMutationResult = Apollo.MutationResult<PaymentRequirementsMutation>;
export type PaymentRequirementsMutationOptions = Apollo.BaseMutationOptions<PaymentRequirementsMutation, PaymentRequirementsMutationVariables>;
export const SalesCommissionReportDocument = gql`
    mutation salesCommissionReport {
  salesCommissionReport
}
    `;
export type SalesCommissionReportMutationFn = Apollo.MutationFunction<SalesCommissionReportMutation, SalesCommissionReportMutationVariables>;

/**
 * __useSalesCommissionReportMutation__
 *
 * To run a mutation, you first call `useSalesCommissionReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSalesCommissionReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [salesCommissionReportMutation, { data, loading, error }] = useSalesCommissionReportMutation({
 *   variables: {
 *   },
 * });
 */
export function useSalesCommissionReportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SalesCommissionReportMutation, SalesCommissionReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SalesCommissionReportMutation, SalesCommissionReportMutationVariables>(SalesCommissionReportDocument, options);
      }
export type SalesCommissionReportMutationHookResult = ReturnType<typeof useSalesCommissionReportMutation>;
export type SalesCommissionReportMutationResult = Apollo.MutationResult<SalesCommissionReportMutation>;
export type SalesCommissionReportMutationOptions = Apollo.BaseMutationOptions<SalesCommissionReportMutation, SalesCommissionReportMutationVariables>;
export const RemoveTagsFromProductsDocument = gql`
    mutation RemoveTagsFromProducts($input: RemoveTagsFromProducts!) {
  removeTagsFromProducts(input: $input)
}
    `;
export type RemoveTagsFromProductsMutationFn = Apollo.MutationFunction<RemoveTagsFromProductsMutation, RemoveTagsFromProductsMutationVariables>;

/**
 * __useRemoveTagsFromProductsMutation__
 *
 * To run a mutation, you first call `useRemoveTagsFromProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTagsFromProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTagsFromProductsMutation, { data, loading, error }] = useRemoveTagsFromProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTagsFromProductsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RemoveTagsFromProductsMutation, RemoveTagsFromProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RemoveTagsFromProductsMutation, RemoveTagsFromProductsMutationVariables>(RemoveTagsFromProductsDocument, options);
      }
export type RemoveTagsFromProductsMutationHookResult = ReturnType<typeof useRemoveTagsFromProductsMutation>;
export type RemoveTagsFromProductsMutationResult = Apollo.MutationResult<RemoveTagsFromProductsMutation>;
export type RemoveTagsFromProductsMutationOptions = Apollo.BaseMutationOptions<RemoveTagsFromProductsMutation, RemoveTagsFromProductsMutationVariables>;
export const AddTagsToProductsDocument = gql`
    mutation AddTagsToProducts($input: AddTagsToProducts!) {
  addTagsToProducts(input: $input)
}
    `;
export type AddTagsToProductsMutationFn = Apollo.MutationFunction<AddTagsToProductsMutation, AddTagsToProductsMutationVariables>;

/**
 * __useAddTagsToProductsMutation__
 *
 * To run a mutation, you first call `useAddTagsToProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagsToProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagsToProductsMutation, { data, loading, error }] = useAddTagsToProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTagsToProductsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddTagsToProductsMutation, AddTagsToProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddTagsToProductsMutation, AddTagsToProductsMutationVariables>(AddTagsToProductsDocument, options);
      }
export type AddTagsToProductsMutationHookResult = ReturnType<typeof useAddTagsToProductsMutation>;
export type AddTagsToProductsMutationResult = Apollo.MutationResult<AddTagsToProductsMutation>;
export type AddTagsToProductsMutationOptions = Apollo.BaseMutationOptions<AddTagsToProductsMutation, AddTagsToProductsMutationVariables>;
export const RefundDocument = gql`
    query Refund($id: ID!) {
  refund(id: $id) {
    ...RefundFields
  }
}
    ${RefundFieldsFragmentDoc}`;

/**
 * __useRefundQuery__
 *
 * To run a query within a React component, call `useRefundQuery` and pass it any options that fit your needs.
 * When your component renders, `useRefundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRefundQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefundQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RefundQuery, RefundQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RefundQuery, RefundQueryVariables>(RefundDocument, options);
      }
export function useRefundLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RefundQuery, RefundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RefundQuery, RefundQueryVariables>(RefundDocument, options);
        }
export type RefundQueryHookResult = ReturnType<typeof useRefundQuery>;
export type RefundLazyQueryHookResult = ReturnType<typeof useRefundLazyQuery>;
export type RefundQueryResult = Apollo.QueryResult<RefundQuery, RefundQueryVariables>;
export const UpdaterOrderLinePaymentDateDocument = gql`
    mutation UpdaterOrderLinePaymentDate($input: OrderLinePaymentDateInput!) {
  updateOrderLinePaymentDate(input: $input) {
    ...OrderLineFields
  }
}
    ${OrderLineFieldsFragmentDoc}`;
export type UpdaterOrderLinePaymentDateMutationFn = Apollo.MutationFunction<UpdaterOrderLinePaymentDateMutation, UpdaterOrderLinePaymentDateMutationVariables>;

/**
 * __useUpdaterOrderLinePaymentDateMutation__
 *
 * To run a mutation, you first call `useUpdaterOrderLinePaymentDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdaterOrderLinePaymentDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updaterOrderLinePaymentDateMutation, { data, loading, error }] = useUpdaterOrderLinePaymentDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdaterOrderLinePaymentDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdaterOrderLinePaymentDateMutation, UpdaterOrderLinePaymentDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdaterOrderLinePaymentDateMutation, UpdaterOrderLinePaymentDateMutationVariables>(UpdaterOrderLinePaymentDateDocument, options);
      }
export type UpdaterOrderLinePaymentDateMutationHookResult = ReturnType<typeof useUpdaterOrderLinePaymentDateMutation>;
export type UpdaterOrderLinePaymentDateMutationResult = Apollo.MutationResult<UpdaterOrderLinePaymentDateMutation>;
export type UpdaterOrderLinePaymentDateMutationOptions = Apollo.BaseMutationOptions<UpdaterOrderLinePaymentDateMutation, UpdaterOrderLinePaymentDateMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetOnePasswordInput!) {
  resetOnePassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const CreateTriggerDocument = gql`
    mutation CreateTrigger($input: CreateTriggerInput!) {
  createTrigger(input: $input) {
    id
  }
}
    `;
export type CreateTriggerMutationFn = Apollo.MutationFunction<CreateTriggerMutation, CreateTriggerMutationVariables>;

/**
 * __useCreateTriggerMutation__
 *
 * To run a mutation, you first call `useCreateTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTriggerMutation, { data, loading, error }] = useCreateTriggerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTriggerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTriggerMutation, CreateTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTriggerMutation, CreateTriggerMutationVariables>(CreateTriggerDocument, options);
      }
export type CreateTriggerMutationHookResult = ReturnType<typeof useCreateTriggerMutation>;
export type CreateTriggerMutationResult = Apollo.MutationResult<CreateTriggerMutation>;
export type CreateTriggerMutationOptions = Apollo.BaseMutationOptions<CreateTriggerMutation, CreateTriggerMutationVariables>;
export const DeleteTriggerDocument = gql`
    mutation DeleteTrigger($id: ID!) {
  deleteTrigger(id: $id)
}
    `;
export type DeleteTriggerMutationFn = Apollo.MutationFunction<DeleteTriggerMutation, DeleteTriggerMutationVariables>;

/**
 * __useDeleteTriggerMutation__
 *
 * To run a mutation, you first call `useDeleteTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTriggerMutation, { data, loading, error }] = useDeleteTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTriggerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteTriggerMutation, DeleteTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteTriggerMutation, DeleteTriggerMutationVariables>(DeleteTriggerDocument, options);
      }
export type DeleteTriggerMutationHookResult = ReturnType<typeof useDeleteTriggerMutation>;
export type DeleteTriggerMutationResult = Apollo.MutationResult<DeleteTriggerMutation>;
export type DeleteTriggerMutationOptions = Apollo.BaseMutationOptions<DeleteTriggerMutation, DeleteTriggerMutationVariables>;
export const UpdateTriggerDocument = gql`
    mutation UpdateTrigger($id: ID!, $input: UpdateTriggerInput!) {
  updateTrigger(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateTriggerMutationFn = Apollo.MutationFunction<UpdateTriggerMutation, UpdateTriggerMutationVariables>;

/**
 * __useUpdateTriggerMutation__
 *
 * To run a mutation, you first call `useUpdateTriggerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTriggerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTriggerMutation, { data, loading, error }] = useUpdateTriggerMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTriggerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateTriggerMutation, UpdateTriggerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateTriggerMutation, UpdateTriggerMutationVariables>(UpdateTriggerDocument, options);
      }
export type UpdateTriggerMutationHookResult = ReturnType<typeof useUpdateTriggerMutation>;
export type UpdateTriggerMutationResult = Apollo.MutationResult<UpdateTriggerMutation>;
export type UpdateTriggerMutationOptions = Apollo.BaseMutationOptions<UpdateTriggerMutation, UpdateTriggerMutationVariables>;
export const TriggersDocument = gql`
    query Triggers($paging: CursorPaging, $filter: TriggerFilter, $sorting: [TriggerSort!]) {
  triggers(paging: $paging, filter: $filter, sorting: $sorting) {
    edges {
      node {
        id
        name
        enabled
        eventType
        createdAt
        updatedAt
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    `;

/**
 * __useTriggersQuery__
 *
 * To run a query within a React component, call `useTriggersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggersQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useTriggersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TriggersQuery, TriggersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TriggersQuery, TriggersQueryVariables>(TriggersDocument, options);
      }
export function useTriggersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TriggersQuery, TriggersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TriggersQuery, TriggersQueryVariables>(TriggersDocument, options);
        }
export type TriggersQueryHookResult = ReturnType<typeof useTriggersQuery>;
export type TriggersLazyQueryHookResult = ReturnType<typeof useTriggersLazyQuery>;
export type TriggersQueryResult = Apollo.QueryResult<TriggersQuery, TriggersQueryVariables>;
export const TriggerDocument = gql`
    query Trigger($id: ID!) {
  trigger(id: $id) {
    ...TriggerFields
  }
}
    ${TriggerFieldsFragmentDoc}`;

/**
 * __useTriggerQuery__
 *
 * To run a query within a React component, call `useTriggerQuery` and pass it any options that fit your needs.
 * When your component renders, `useTriggerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTriggerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTriggerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TriggerQuery, TriggerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TriggerQuery, TriggerQueryVariables>(TriggerDocument, options);
      }
export function useTriggerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TriggerQuery, TriggerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TriggerQuery, TriggerQueryVariables>(TriggerDocument, options);
        }
export type TriggerQueryHookResult = ReturnType<typeof useTriggerQuery>;
export type TriggerLazyQueryHookResult = ReturnType<typeof useTriggerLazyQuery>;
export type TriggerQueryResult = Apollo.QueryResult<TriggerQuery, TriggerQueryVariables>;
export const PermissionsDocument = gql`
    query Permissions {
  permissions {
    label
    value
  }
}
    `;

/**
 * __usePermissionsQuery__
 *
 * To run a query within a React component, call `usePermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePermissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePermissionsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePermissionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
      }
export function usePermissionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PermissionsQuery, PermissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PermissionsQuery, PermissionsQueryVariables>(PermissionsDocument, options);
        }
export type PermissionsQueryHookResult = ReturnType<typeof usePermissionsQuery>;
export type PermissionsLazyQueryHookResult = ReturnType<typeof usePermissionsLazyQuery>;
export type PermissionsQueryResult = Apollo.QueryResult<PermissionsQuery, PermissionsQueryVariables>;
export const UpdateAccountGroupUsersDocument = gql`
    mutation UpdateAccountGroupUsers($ids: [String!]!, $accountGroupId: String!, $action: AccountsAction!) {
  updateAccountGroupUsers(
    ids: $ids
    accountGroupId: $accountGroupId
    action: $action
  )
}
    `;
export type UpdateAccountGroupUsersMutationFn = Apollo.MutationFunction<UpdateAccountGroupUsersMutation, UpdateAccountGroupUsersMutationVariables>;

/**
 * __useUpdateAccountGroupUsersMutation__
 *
 * To run a mutation, you first call `useUpdateAccountGroupUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountGroupUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountGroupUsersMutation, { data, loading, error }] = useUpdateAccountGroupUsersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      accountGroupId: // value for 'accountGroupId'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useUpdateAccountGroupUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateAccountGroupUsersMutation, UpdateAccountGroupUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateAccountGroupUsersMutation, UpdateAccountGroupUsersMutationVariables>(UpdateAccountGroupUsersDocument, options);
      }
export type UpdateAccountGroupUsersMutationHookResult = ReturnType<typeof useUpdateAccountGroupUsersMutation>;
export type UpdateAccountGroupUsersMutationResult = Apollo.MutationResult<UpdateAccountGroupUsersMutation>;
export type UpdateAccountGroupUsersMutationOptions = Apollo.BaseMutationOptions<UpdateAccountGroupUsersMutation, UpdateAccountGroupUsersMutationVariables>;
export const UpdateOneVoucherDocument = gql`
    mutation UpdateOneVoucher($input: UpdateOneVoucherInput!) {
  updateOneVoucher(input: $input) {
    id
    status
    expiryDate
  }
}
    `;
export type UpdateOneVoucherMutationFn = Apollo.MutationFunction<UpdateOneVoucherMutation, UpdateOneVoucherMutationVariables>;

/**
 * __useUpdateOneVoucherMutation__
 *
 * To run a mutation, you first call `useUpdateOneVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOneVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOneVoucherMutation, { data, loading, error }] = useUpdateOneVoucherMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOneVoucherMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateOneVoucherMutation, UpdateOneVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateOneVoucherMutation, UpdateOneVoucherMutationVariables>(UpdateOneVoucherDocument, options);
      }
export type UpdateOneVoucherMutationHookResult = ReturnType<typeof useUpdateOneVoucherMutation>;
export type UpdateOneVoucherMutationResult = Apollo.MutationResult<UpdateOneVoucherMutation>;
export type UpdateOneVoucherMutationOptions = Apollo.BaseMutationOptions<UpdateOneVoucherMutation, UpdateOneVoucherMutationVariables>;
export const VouchersDocument = gql`
    query Vouchers($paging: CursorPaging, $filter: VoucherFilter, $sorting: [VoucherSort!]) {
  vouchers(paging: $paging, filter: $filter, sorting: $sorting) {
    pageInfo {
      ...PagingFields
    }
    edges {
      node {
        id
        voucherNumber
        code
        value
        recipientEmail
        createdAt
        status
        expiryDate
        reason
        createdBy {
          id
          email
        }
      }
    }
  }
}
    ${PagingFieldsFragmentDoc}`;

/**
 * __useVouchersQuery__
 *
 * To run a query within a React component, call `useVouchersQuery` and pass it any options that fit your needs.
 * When your component renders, `useVouchersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVouchersQuery({
 *   variables: {
 *      paging: // value for 'paging'
 *      filter: // value for 'filter'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useVouchersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VouchersQuery, VouchersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VouchersQuery, VouchersQueryVariables>(VouchersDocument, options);
      }
export function useVouchersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VouchersQuery, VouchersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VouchersQuery, VouchersQueryVariables>(VouchersDocument, options);
        }
export type VouchersQueryHookResult = ReturnType<typeof useVouchersQuery>;
export type VouchersLazyQueryHookResult = ReturnType<typeof useVouchersLazyQuery>;
export type VouchersQueryResult = Apollo.QueryResult<VouchersQuery, VouchersQueryVariables>;
export const ResendVoucherDocument = gql`
    mutation ResendVoucher($id: String!) {
  resendVoucher(id: $id)
}
    `;
export type ResendVoucherMutationFn = Apollo.MutationFunction<ResendVoucherMutation, ResendVoucherMutationVariables>;

/**
 * __useResendVoucherMutation__
 *
 * To run a mutation, you first call `useResendVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendVoucherMutation, { data, loading, error }] = useResendVoucherMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendVoucherMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ResendVoucherMutation, ResendVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ResendVoucherMutation, ResendVoucherMutationVariables>(ResendVoucherDocument, options);
      }
export type ResendVoucherMutationHookResult = ReturnType<typeof useResendVoucherMutation>;
export type ResendVoucherMutationResult = Apollo.MutationResult<ResendVoucherMutation>;
export type ResendVoucherMutationOptions = Apollo.BaseMutationOptions<ResendVoucherMutation, ResendVoucherMutationVariables>;
export const CreateVouchersDocument = gql`
    mutation CreateVouchers($input: CreateVouchersInput!) {
  createVouchers(input: $input)
}
    `;
export type CreateVouchersMutationFn = Apollo.MutationFunction<CreateVouchersMutation, CreateVouchersMutationVariables>;

/**
 * __useCreateVouchersMutation__
 *
 * To run a mutation, you first call `useCreateVouchersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVouchersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVouchersMutation, { data, loading, error }] = useCreateVouchersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVouchersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateVouchersMutation, CreateVouchersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateVouchersMutation, CreateVouchersMutationVariables>(CreateVouchersDocument, options);
      }
export type CreateVouchersMutationHookResult = ReturnType<typeof useCreateVouchersMutation>;
export type CreateVouchersMutationResult = Apollo.MutationResult<CreateVouchersMutation>;
export type CreateVouchersMutationOptions = Apollo.BaseMutationOptions<CreateVouchersMutation, CreateVouchersMutationVariables>;
export const VoucherDashboardDocument = gql`
    query VoucherDashboard {
  voucherStats {
    totalSales
    totalIssued
    unredeemedAmounts {
      internal
      purchased
    }
    dailySales {
      day
      total
    }
    averageSalesPerDay
    totalWalletBalance
    internal {
      created {
        total
        month
      }
      available {
        total
        month
      }
      used {
        total
        month
      }
    }
  }
}
    `;

/**
 * __useVoucherDashboardQuery__
 *
 * To run a query within a React component, call `useVoucherDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useVoucherDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVoucherDashboardQuery({
 *   variables: {
 *   },
 * });
 */
export function useVoucherDashboardQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<VoucherDashboardQuery, VoucherDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<VoucherDashboardQuery, VoucherDashboardQueryVariables>(VoucherDashboardDocument, options);
      }
export function useVoucherDashboardLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<VoucherDashboardQuery, VoucherDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<VoucherDashboardQuery, VoucherDashboardQueryVariables>(VoucherDashboardDocument, options);
        }
export type VoucherDashboardQueryHookResult = ReturnType<typeof useVoucherDashboardQuery>;
export type VoucherDashboardLazyQueryHookResult = ReturnType<typeof useVoucherDashboardLazyQuery>;
export type VoucherDashboardQueryResult = Apollo.QueryResult<VoucherDashboardQuery, VoucherDashboardQueryVariables>;